import React, { useState } from 'react';

import Item from './Item';
import Modal from '../../../../../common/components/Header/Modal';

const ImageOne = (
	<svg
		className="w-full h-auto"
		width="476"
		height="406"
		viewBox="0 0 476 406"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_4301_3120)">
			<rect width="476" height="406" rx="12" fill="#F4F2FF" />
			<rect
				x="55.2771"
				y="53.2771"
				width="366.371"
				height="300.446"
				rx="6.66239"
				fill="white"
			/>
			<rect
				x="55.2771"
				y="53.2771"
				width="366.371"
				height="300.446"
				rx="6.66239"
				stroke="#D7CFFF"
				stroke-width="0.554184"
			/>
			<g opacity="0.3">
				<mask id="path-3-inside-1_4301_3120" fill="white">
					<path d="M55 58.2046C55 55.3302 57.3302 53 60.2046 53H416.72C419.595 53 421.925 55.3302 421.925 58.2046V74.6859C421.925 75.1649 421.537 75.5533 421.058 75.5533H55.8674C55.3884 75.5533 55 75.1649 55 74.6859V58.2046Z" />
				</mask>
				<path
					d="M55 58.2046C55 55.3302 57.3302 53 60.2046 53H416.72C419.595 53 421.925 55.3302 421.925 58.2046V74.6859C421.925 75.1649 421.537 75.5533 421.058 75.5533H55.8674C55.3884 75.5533 55 75.1649 55 74.6859V58.2046Z"
					fill="white"
				/>
				<path
					d="M55 53H421.925H55ZM421.925 74.6859C421.925 75.5391 421.233 76.2308 420.38 76.2308H55.8674C55.0147 76.2308 54.3234 75.5395 54.3234 74.6867L55.6766 74.6859C55.6766 74.7908 55.762 74.8759 55.8674 74.8759H421.058C421.537 74.8759 421.925 74.7908 421.925 74.6859ZM55.8674 76.2308C55.0147 76.2308 54.3234 75.5395 54.3234 74.6867V58.8812C54.3234 55.6331 56.9565 53 60.2046 53C57.7039 53 55.6766 55.3302 55.6766 58.2046V74.6859C55.6766 74.7908 55.762 74.8759 55.8674 74.8759L55.8674 76.2308ZM421.925 53V75.5533V53Z"
					fill="#D8D2FB"
					mask="url(#path-3-inside-1_4301_3120)"
				/>
			</g>
			<circle cx="70.8043" cy="64.9156" r="4.71056" fill="#FF4C4C" />
			<circle cx="86.0543" cy="64.9156" r="4.71056" fill="#FFAB42" />
			<circle cx="101.32" cy="64.9156" r="4.71056" fill="#00A900" />
			<rect
				x="299.917"
				y="94.9365"
				width="104.36"
				height="67.9278"
				rx="5.6955"
				fill="white"
			/>
			<rect
				x="299.917"
				y="94.9365"
				width="104.36"
				height="67.9278"
				rx="5.6955"
				stroke="#EDDFF6"
				stroke-width="0.599527"
			/>
			<rect
				x="326.516"
				y="103.312"
				width="61.5879"
				height="52.9135"
				rx="4.79621"
				fill="#F9F8FF"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M342.489 127.26H343.244L343.257 120.628C343.413 117.499 344.848 114.695 347.071 112.666L347.088 112.649C349.353 110.59 352.429 109.324 355.797 109.324C359.172 109.324 362.256 110.595 364.524 112.666C366.788 114.734 368.236 117.607 368.346 120.806L368.352 127.26H369.106C370.037 127.26 370.887 127.621 371.495 128.196L371.658 128.369C372.172 128.932 372.485 129.661 372.485 130.454V146.79C372.485 147.67 372.104 148.473 371.495 149.048C370.887 149.623 370.037 149.983 369.106 149.983H342.489C341.558 149.983 340.708 149.623 340.1 149.048C339.491 148.473 339.109 147.67 339.109 146.79V130.454C339.109 129.581 339.489 128.785 340.1 128.204C340.708 127.621 341.558 127.26 342.489 127.26ZM355.797 133.057C357.046 133.057 358.059 134.013 358.059 135.194C358.059 136.127 357.426 136.919 356.544 137.211L356.928 138.874L358.059 143.774H355.797H353.536L354.667 138.874L355.05 137.211C354.168 136.919 353.536 136.127 353.536 135.194C353.536 134.013 354.548 133.057 355.797 133.057ZM347.298 127.26H364.297V120.866C364.212 118.724 363.235 116.803 361.719 115.418C360.186 114.014 358.097 113.157 355.797 113.157C353.499 113.157 351.411 114.013 349.886 115.408C348.379 116.787 347.406 118.678 347.296 120.788L347.298 127.26Z"
				fill="#7351FD"
			/>
			<rect
				x="73.5263"
				y="94.9365"
				width="183.455"
				height="67.7465"
				rx="5.6955"
				stroke="#C5B8FB"
				stroke-width="0.599527"
			/>
			<rect
				x="80.1641"
				y="103.312"
				width="86.7435"
				height="8.67435"
				rx="4.33718"
				fill="#C5B8FB"
			/>
			<rect
				x="80.4141"
				y="122.215"
				width="56.955"
				height="3.46974"
				rx="1.73487"
				fill="#C5B8FB"
			/>
			<rect
				x="80.4141"
				y="128.083"
				width="56.955"
				height="2.99763"
				rx="1.49882"
				fill="#C5B8FB"
			/>
			<rect
				x="80.4141"
				y="135.418"
				width="56.955"
				height="3.46974"
				rx="1.73487"
				fill="#C5B8FB"
			/>
			<rect
				x="80.4141"
				y="141.286"
				width="56.955"
				height="2.99763"
				rx="1.49882"
				fill="#C5B8FB"
			/>
			<rect
				x="197.32"
				y="102.43"
				width="52.7584"
				height="52.7584"
				rx="4.79621"
				fill="#F9F8FF"
			/>
			<g clip-path="url(#clip1_4301_3120)">
				<path
					d="M229.781 120.718C228.274 120.718 227.047 119.491 227.047 117.983V108.999H213.062C210.693 108.999 208.766 110.927 208.766 113.296V144.702C208.766 147.071 210.693 148.999 213.062 148.999H234.938C237.307 148.999 239.234 147.071 239.234 144.702V120.718H229.781ZM215.172 137.124H220.853C221.5 137.124 222.025 137.649 222.025 138.296C222.025 138.943 221.5 139.468 220.853 139.468H215.172C214.525 139.468 214 138.943 214 138.296C214 137.649 214.525 137.124 215.172 137.124ZM214 132.046C214 131.399 214.525 130.874 215.172 130.874H232.359C233.007 130.874 233.531 131.399 233.531 132.046C233.531 132.693 233.007 133.218 232.359 133.218H215.172C214.525 133.218 214 132.693 214 132.046ZM232.359 124.624C233.007 124.624 233.531 125.149 233.531 125.796C233.531 126.443 233.007 126.968 232.359 126.968H215.172C214.525 126.968 214 126.443 214 125.796C214 125.149 214.525 124.624 215.172 124.624H232.359Z"
					fill="#7351FD"
				/>
				<path
					d="M229.391 117.984C229.391 118.199 229.566 118.374 229.781 118.374H238.712C238.497 117.976 238.219 117.613 237.891 117.302L230.358 110.175C230.069 109.901 229.743 109.669 229.391 109.485V117.984H229.391Z"
					fill="#7351FD"
				/>
			</g>
			<path
				d="M257.273 128.211L299.24 128.211"
				stroke="#ECDBF7"
				stroke-width="0.599527"
			/>
			<rect
				x="73.6603"
				y="180.08"
				width="208.184"
				height="138.79"
				rx="8.24063"
				fill="#CFC6F5"
				fill-opacity="0.66"
			/>
			<rect
				x="73.6603"
				y="180.08"
				width="208.184"
				height="138.79"
				rx="8.24063"
				stroke="#EDDFF6"
				stroke-width="0.867435"
			/>
			<rect
				x="80.1641"
				y="196.994"
				width="192.571"
				height="15.6138"
				rx="7.80692"
				fill="white"
			/>
			<rect
				x="80.1641"
				y="224.753"
				width="145.729"
				height="8.67435"
				rx="4.33718"
				fill="white"
			/>
			<rect
				x="80.1641"
				y="241.234"
				width="164.813"
				height="8.67435"
				rx="4.33718"
				fill="white"
			/>
			<rect
				x="152.156"
				y="262.053"
				width="48.5764"
				height="47.7089"
				rx="4.33718"
				fill="white"
			/>
			<rect
				x="299.617"
				y="180.513"
				width="104.96"
				height="8.67435"
				rx="3.57676"
				fill="#C5B8FB"
			/>
			<rect
				x="299.617"
				y="199.597"
				width="94.5504"
				height="5.20461"
				rx="2.60231"
				fill="#C5B8FB"
			/>
			<rect
				x="299.617"
				y="210.873"
				width="94.5504"
				height="5.20461"
				rx="2.60231"
				fill="#C5B8FB"
			/>
			<rect
				x="299.617"
				y="223.018"
				width="94.5504"
				height="5.20461"
				rx="2.60231"
				fill="#C5B8FB"
			/>
			<rect
				x="299.617"
				y="234.294"
				width="94.5504"
				height="5.20461"
				rx="2.60231"
				fill="#C5B8FB"
			/>
			<g filter="url(#filter0_d_4301_3120)">
				<rect
					x="347.336"
					y="272.461"
					width="92.8156"
					height="92.8156"
					rx="16.5742"
					fill="white"
				/>
				<path
					d="M403.038 330.018C406.963 330.026 410.802 328.868 414.069 326.693C417.335 324.517 419.883 321.42 421.388 317.796C422.894 314.171 423.29 310.181 422.526 306.331C421.762 302.481 419.873 298.944 417.097 296.169C414.322 293.394 410.785 291.504 406.935 290.74C403.085 289.977 399.095 290.373 395.471 291.878C391.846 293.384 388.75 295.931 386.574 299.198C384.398 302.464 383.241 306.303 383.248 310.228C383.249 312.281 383.565 314.321 384.184 316.278L366.022 334.415C365.769 334.664 365.568 334.961 365.432 335.289C365.295 335.617 365.226 335.969 365.227 336.324V345.297C365.22 345.655 365.285 346.012 365.418 346.345C365.551 346.679 365.75 346.982 366.002 347.238C366.254 347.493 366.554 347.696 366.886 347.834C367.217 347.971 367.573 348.041 367.931 348.04H376.904C377.259 348.041 377.612 347.972 377.941 347.837C378.269 347.702 378.568 347.503 378.82 347.251C379.071 347 379.27 346.701 379.406 346.372C379.541 346.043 379.61 345.691 379.608 345.335V340.836H384.12C384.836 340.833 385.522 340.547 386.028 340.04C386.535 339.534 386.821 338.848 386.824 338.132V333.62H391.323C391.678 333.621 392.03 333.552 392.358 333.415C392.686 333.279 392.983 333.078 393.233 332.825L396.988 329.083C398.945 329.701 400.986 330.017 403.038 330.018ZM407.55 301.179C408.443 301.179 409.315 301.444 410.058 301.94C410.8 302.437 411.378 303.142 411.719 303.967C412.06 304.792 412.149 305.7 411.974 306.576C411.799 307.451 411.368 308.255 410.735 308.886C410.103 309.516 409.298 309.945 408.422 310.117C407.546 310.29 406.638 310.199 405.814 309.855C404.99 309.512 404.286 308.932 403.792 308.188C403.298 307.445 403.036 306.571 403.038 305.678C403.038 305.083 403.156 304.494 403.385 303.944C403.615 303.395 403.951 302.897 404.374 302.479C404.797 302.06 405.299 301.73 405.851 301.507C406.403 301.284 406.993 301.172 407.588 301.179H407.55Z"
					fill="#7351FD"
				/>
			</g>
		</g>
		<defs>
			<filter
				id="filter0_d_4301_3120"
				x="193.666"
				y="165.659"
				width="319.283"
				height="319.285"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx="-40.4345" dy="6.43276" />
				<feGaussianBlur stdDeviation="56.6175" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.291286 0 0 0 0 0.161612 0 0 0 0 0.365385 0 0 0 0.33 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_4301_3120"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_4301_3120"
					result="shape"
				/>
			</filter>
			<clipPath id="clip0_4301_3120">
				<rect width="476" height="406" rx="12" fill="white" />
			</clipPath>
			<clipPath id="clip1_4301_3120">
				<rect
					width="40"
					height="40"
					fill="white"
					transform="translate(204 108.999)"
				/>
			</clipPath>
		</defs>
	</svg>
);

const ImageTwo = (
	<svg
		className="w-full h-auto"
		width="476"
		height="406"
		viewBox="0 0 476 406"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="476" height="406" rx="12" fill="#F4F2FF" />
		<g clip-path="url(#clip0_4301_3131)">
			<rect
				x="42"
				y="43"
				width="391.305"
				height="321"
				rx="7.40058"
				fill="white"
			/>
			<mask id="path-4-inside-1_4301_3131" fill="white">
				<path d="M42 47.7281C42 45.1168 44.1168 43 46.7281 43H474.617C477.228 43 479.345 45.1168 479.345 47.7281V68.4133H42V47.7281Z" />
			</mask>
			<path
				d="M42 47.7281C42 45.1168 44.1168 43 46.7281 43H474.617C477.228 43 479.345 45.1168 479.345 47.7281V68.4133H42V47.7281Z"
				fill="white"
			/>
			<path
				d="M42 43H479.345H42ZM479.345 69.2227H42V67.6039H479.345V69.2227ZM42 68.4133V43V68.4133ZM479.345 43V68.4133V43Z"
				fill="#D8D2FB"
				mask="url(#path-4-inside-1_4301_3131)"
			/>
			<circle cx="58.8361" cy="55.7071" r="5.02355" fill="#FF4C4C" />
			<circle cx="75.1095" cy="55.7071" r="5.02355" fill="#FFAB42" />
			<circle cx="91.3829" cy="55.7071" r="5.02355" fill="#00A900" />
			<rect
				x="78.1797"
				y="104.98"
				width="179.845"
				height="211.797"
				rx="9.25072"
				fill="white"
			/>
			<rect
				x="79.5491"
				y="106.35"
				width="177.107"
				height="209.059"
				rx="7.88134"
				stroke="#7351FD"
				stroke-opacity="0.2"
				stroke-width="2.73876"
			/>
			<rect
				x="114.252"
				y="127.743"
				width="107.836"
				height="97.355"
				rx="8.78819"
				fill="white"
			/>
			<rect
				x="114.252"
				y="127.743"
				width="107.836"
				height="97.355"
				rx="8.78819"
				stroke="#E8E3FD"
				stroke-width="0.925072"
			/>
			<g clip-path="url(#clip1_4301_3131)">
				<path
					d="M201.536 169.894L193.929 155.41C192.498 152.637 190.11 150.479 187.208 149.334C185.941 148.846 182.503 147.646 181.321 147.236C181.249 147.036 181.151 146.846 181.028 146.672L179.038 143.854C178.021 142.413 176.85 142.364 176.246 142.462C173.425 142.905 170.571 143.111 167.715 143.08C164.865 143.112 162.016 142.905 159.2 142.462C158.594 142.364 157.425 142.413 156.408 143.855L154.418 146.672C154.295 146.846 154.197 147.036 154.125 147.236C152.944 147.646 149.505 148.843 148.239 149.334C145.336 150.479 142.948 152.637 141.516 155.41L133.91 169.894C133.788 170.127 133.716 170.383 133.699 170.645C133.682 170.908 133.721 171.171 133.812 171.417C133.904 171.664 134.046 171.889 134.23 172.077C134.414 172.265 134.635 172.412 134.88 172.509L146.183 177.087C146.391 177.171 146.567 177.318 146.687 177.508C146.806 177.698 146.863 177.921 146.85 178.145L145.028 208.01C145.013 208.266 145.049 208.522 145.136 208.762C145.223 209.003 145.358 209.223 145.533 209.41C145.709 209.596 145.92 209.745 146.155 209.846C146.39 209.948 146.643 210 146.898 210.001H188.548C188.804 210.001 189.057 209.948 189.291 209.847C189.526 209.745 189.738 209.597 189.913 209.41C190.088 209.224 190.224 209.004 190.311 208.763C190.398 208.523 190.435 208.267 190.419 208.012L188.598 178.16C188.584 177.936 188.641 177.713 188.76 177.523C188.88 177.333 189.056 177.186 189.264 177.102L200.556 172.514C200.802 172.418 201.025 172.272 201.211 172.084C201.396 171.896 201.54 171.671 201.632 171.424C201.725 171.176 201.764 170.913 201.747 170.649C201.731 170.386 201.659 170.129 201.536 169.895V169.894ZM159.6 144.165C161.483 144.341 165.449 144.713 167.715 144.689C170.018 144.713 173.983 144.319 175.857 144.15C175.957 144.142 176.056 144.161 176.145 144.206C176.234 144.251 176.308 144.32 176.36 144.405C176.412 144.49 176.439 144.588 176.438 144.687C176.437 144.787 176.409 144.884 176.356 144.969C174.559 147.616 171.119 150.025 167.97 151.659C167.894 151.698 167.809 151.719 167.723 151.719C167.637 151.719 167.552 151.698 167.476 151.659C164.333 150.03 160.9 147.628 159.099 144.985C159.045 144.901 159.016 144.803 159.015 144.703C159.015 144.603 159.042 144.504 159.094 144.419C159.146 144.334 159.221 144.265 159.311 144.22C159.4 144.175 159.5 144.156 159.6 144.165ZM154.143 148.933C154.156 148.967 154.165 149.002 154.179 149.035C155.366 151.819 157.138 154.316 159.376 156.355C160.015 156.936 160.848 157.255 161.712 157.249C162.575 157.243 163.405 156.913 164.036 156.324L167.374 153.41C167.472 153.325 167.597 153.278 167.727 153.278C167.856 153.278 167.981 153.325 168.079 153.41L171.4 156.307C172.031 156.902 172.862 157.237 173.729 157.246C174.596 157.255 175.435 156.937 176.078 156.355C178.315 154.316 180.087 151.819 181.274 149.035C181.288 149.002 181.297 148.967 181.31 148.933C181.728 149.078 182.258 149.264 182.824 149.462L182.833 149.482C181.549 152.553 179.608 155.306 177.146 157.546C176.397 158.227 175.46 158.666 174.457 158.806C173.455 158.946 172.434 158.781 171.526 158.332C171.237 158.172 170.96 157.99 170.699 157.788C170.659 157.758 170.612 157.74 170.562 157.735C170.513 157.731 170.463 157.74 170.418 157.763C170.374 157.785 170.336 157.819 170.31 157.861C170.284 157.904 170.27 157.953 170.27 158.002V160.927C170.27 161.094 170.237 161.26 170.173 161.415C170.109 161.569 170.015 161.71 169.897 161.828C169.779 161.947 169.638 162.041 169.483 162.105C169.329 162.169 169.163 162.202 168.995 162.201H166.448C166.281 162.202 166.115 162.169 165.96 162.105C165.805 162.041 165.665 161.947 165.546 161.828C165.428 161.71 165.334 161.569 165.27 161.415C165.206 161.26 165.173 161.094 165.173 160.927V158.012C165.173 157.962 165.159 157.913 165.133 157.871C165.107 157.829 165.07 157.795 165.025 157.772C164.981 157.75 164.931 157.741 164.881 157.745C164.832 157.75 164.784 157.768 164.745 157.798C164.512 157.978 164.267 158.142 164.012 158.289C163.098 158.762 162.061 158.944 161.04 158.811C160.019 158.678 159.063 158.237 158.3 157.546C155.841 155.305 153.903 152.552 152.622 149.481L152.631 149.461C153.195 149.263 153.725 149.077 154.143 148.933Z"
					fill="#7351FD"
				/>
				<path
					d="M168.093 158.048C168.607 158.048 169.023 157.632 169.023 157.119C169.023 156.606 168.607 156.189 168.093 156.189C167.58 156.189 167.164 156.606 167.164 157.119C167.164 157.632 167.58 158.048 168.093 158.048Z"
					fill="#7351FD"
				/>
			</g>
			<rect
				x="121.219"
				y="246.131"
				width="101.334"
				height="6.39044"
				rx="3.19522"
				fill="#C5B8FB"
			/>
			<rect
				x="121.219"
				y="264.39"
				width="76.6853"
				height="6.39044"
				rx="3.19522"
				fill="#C5B8FB"
			/>
			<rect
				x="61.4141"
				y="117.006"
				width="38.1994"
				height="38.1994"
				rx="3.70029"
				fill="#7351FD"
			/>
			<rect
				x="61.4514"
				y="117.043"
				width="38.1248"
				height="38.1248"
				rx="3.66298"
				stroke="#7351FD"
				stroke-opacity="0.2"
				stroke-width="0.0746082"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M75.0222 149.807C75.1287 149.892 75.2571 149.946 75.3925 149.961C75.5279 149.976 75.665 149.953 75.7878 149.894C75.9107 149.835 76.0144 149.743 76.0871 149.627C76.1598 149.512 76.1984 149.378 76.1986 149.242V140.665C76.1984 140.529 76.1598 140.396 76.0871 140.28C76.0144 140.165 75.9107 140.072 75.7878 140.013C75.665 139.954 75.5279 139.931 75.3925 139.947C75.2571 139.962 75.1287 140.015 75.0222 140.1L69.6617 144.389C69.5771 144.457 69.5088 144.543 69.4619 144.64C69.415 144.738 69.3906 144.845 69.3906 144.954C69.3906 145.062 69.415 145.169 69.4619 145.267C69.5088 145.365 69.5771 145.451 69.6617 145.519L75.0222 149.807ZM86.0677 122.715C85.9612 122.63 85.8328 122.577 85.6974 122.561C85.562 122.546 85.4249 122.569 85.3021 122.628C85.1792 122.687 85.0755 122.78 85.0028 122.895C84.9301 123.01 84.8915 123.144 84.8913 123.28V131.857C84.8915 131.993 84.9301 132.127 85.0028 132.242C85.0755 132.357 85.1792 132.45 85.3021 132.509C85.4249 132.568 85.562 132.591 85.6974 132.576C85.8328 132.56 85.9612 132.507 86.0677 132.422L91.4282 128.133C91.5128 128.066 91.5811 127.98 91.628 127.882C91.6749 127.784 91.6993 127.677 91.6993 127.568C91.6993 127.46 91.6749 127.353 91.628 127.255C91.5811 127.157 91.5128 127.071 91.4282 127.003L86.0677 122.715Z"
				fill="white"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M89.2215 127.567C89.2215 127.183 89.0689 126.814 88.7972 126.543C88.5255 126.271 88.157 126.118 87.7727 126.118H81.2532H74.7337C73.2831 126.118 71.8554 126.481 70.5809 127.173C69.3063 127.866 68.2254 128.867 67.4365 130.084C66.6477 131.301 66.1761 132.697 66.0647 134.143C65.9533 135.59 66.2057 137.041 66.7987 138.365C66.9578 138.712 67.2478 138.983 67.6056 139.118C67.9633 139.252 68.3598 139.24 68.7086 139.084C69.0574 138.927 69.3303 138.64 69.4678 138.283C69.6053 137.926 69.5963 137.53 69.4428 137.18C69.0474 136.297 68.8793 135.329 68.9537 134.365C69.0281 133.401 69.3426 132.471 69.8685 131.659C70.3945 130.848 71.1152 130.18 71.965 129.719C72.8148 129.257 73.7666 129.015 74.7337 129.016H87.7727C88.157 129.016 88.5255 128.863 88.7972 128.591C89.0689 128.32 89.2215 127.951 89.2215 127.567ZM71.8361 144.952C71.8361 145.337 71.9888 145.705 72.2605 145.977C72.5322 146.248 72.9007 146.401 73.2849 146.401H86.3239C87.7746 146.401 89.2022 146.039 90.4768 145.346C91.7513 144.653 92.8323 143.653 93.6211 142.435C94.4099 141.218 94.8815 139.822 94.9929 138.376C95.1043 136.93 94.852 135.478 94.2589 134.155C94.0998 133.807 93.8098 133.536 93.4521 133.402C93.0943 133.267 92.6978 133.279 92.349 133.436C92.0002 133.592 91.7273 133.88 91.5898 134.236C91.4523 134.593 91.4613 134.99 91.6149 135.34C92.0102 136.222 92.1783 137.19 92.104 138.154C92.0296 139.118 91.7151 140.049 91.1891 140.86C90.6631 141.672 89.9424 142.339 89.0926 142.8C88.2429 143.262 87.2911 143.504 86.3239 143.504H73.2849C72.9007 143.504 72.5322 143.656 72.2605 143.928C71.9888 144.2 71.8361 144.568 71.8361 144.952Z"
				fill="white"
			/>
			<g filter="url(#filter0_d_4301_3131)">
				<rect
					x="239.219"
					y="142.391"
					width="174.568"
					height="127.928"
					rx="7.40058"
					fill="white"
				/>
				<rect
					x="239.441"
					y="142.613"
					width="174.124"
					height="127.484"
					rx="7.17848"
					stroke="#7351FD"
					stroke-opacity="0.2"
					stroke-width="0.444194"
				/>
				<mask
					id="path-22-outside-2_4301_3131"
					maskUnits="userSpaceOnUse"
					x="247.023"
					y="148.938"
					width="28"
					height="10"
					fill="black"
				>
					<rect fill="white" x="247.023" y="148.938" width="28" height="10" />
					<path d="M248.389 156.217C249.1 155.603 249.659 155.099 250.066 154.707C250.481 154.307 250.825 153.893 251.099 153.463C251.373 153.034 251.51 152.604 251.51 152.175C251.51 151.731 251.402 151.383 251.188 151.131C250.98 150.879 250.651 150.754 250.199 150.754C249.763 150.754 249.422 150.894 249.178 151.176C248.941 151.45 248.815 151.82 248.8 152.286H247.579C247.601 151.442 247.853 150.798 248.334 150.354C248.822 149.902 249.441 149.676 250.188 149.676C250.995 149.676 251.625 149.899 252.076 150.343C252.535 150.787 252.765 151.379 252.765 152.12C252.765 152.653 252.628 153.167 252.354 153.663C252.087 154.152 251.765 154.592 251.388 154.985C251.017 155.37 250.544 155.817 249.966 156.328L249.467 156.772H252.987V157.827H247.59V156.906L248.389 156.217ZM254.432 153.785C254.432 152.505 254.647 151.505 255.076 150.787C255.513 150.061 256.261 149.699 257.319 149.699C258.378 149.699 259.122 150.061 259.551 150.787C259.988 151.505 260.207 152.505 260.207 153.785C260.207 155.081 259.988 156.095 259.551 156.828C259.122 157.554 258.378 157.916 257.319 157.916C256.261 157.916 255.513 157.554 255.076 156.828C254.647 156.095 254.432 155.081 254.432 153.785ZM258.963 153.785C258.963 153.186 258.922 152.678 258.841 152.264C258.767 151.849 258.611 151.512 258.374 151.253C258.137 150.987 257.786 150.854 257.319 150.854C256.853 150.854 256.501 150.987 256.264 151.253C256.027 151.512 255.868 151.849 255.787 152.264C255.713 152.678 255.676 153.186 255.676 153.785C255.676 154.407 255.713 154.929 255.787 155.351C255.861 155.773 256.016 156.114 256.253 156.373C256.498 156.632 256.853 156.761 257.319 156.761C257.786 156.761 258.137 156.632 258.374 156.373C258.619 156.114 258.778 155.773 258.852 155.351C258.926 154.929 258.963 154.407 258.963 153.785ZM262.579 156.217C263.29 155.603 263.848 155.099 264.256 154.707C264.67 154.307 265.014 153.893 265.288 153.463C265.562 153.034 265.699 152.604 265.699 152.175C265.699 151.731 265.592 151.383 265.377 151.131C265.17 150.879 264.84 150.754 264.389 150.754C263.952 150.754 263.612 150.894 263.367 151.176C263.13 151.45 263.004 151.82 262.99 152.286H261.768C261.79 151.442 262.042 150.798 262.523 150.354C263.012 149.902 263.63 149.676 264.378 149.676C265.185 149.676 265.814 149.899 266.266 150.343C266.725 150.787 266.954 151.379 266.954 152.12C266.954 152.653 266.817 153.167 266.543 153.663C266.277 154.152 265.955 154.592 265.577 154.985C265.207 155.37 264.733 155.817 264.156 156.328L263.656 156.772H267.176V157.827H261.779V156.906L262.579 156.217ZM273.841 150.931H270.121V153.141C270.276 152.934 270.506 152.76 270.809 152.619C271.12 152.479 271.45 152.408 271.797 152.408C272.419 152.408 272.923 152.542 273.308 152.808C273.7 153.075 273.978 153.411 274.141 153.819C274.311 154.226 274.396 154.655 274.396 155.107C274.396 155.655 274.289 156.143 274.074 156.573C273.867 156.995 273.552 157.328 273.13 157.572C272.715 157.816 272.205 157.938 271.598 157.938C270.791 157.938 270.143 157.739 269.654 157.339C269.166 156.939 268.873 156.41 268.777 155.751H270.01C270.091 156.099 270.272 156.376 270.554 156.584C270.835 156.784 271.187 156.884 271.609 156.884C272.134 156.884 272.527 156.724 272.786 156.406C273.052 156.088 273.186 155.666 273.186 155.14C273.186 154.607 273.052 154.2 272.786 153.919C272.519 153.63 272.127 153.485 271.609 153.485C271.246 153.485 270.939 153.578 270.687 153.763C270.443 153.941 270.265 154.185 270.154 154.496H268.955V149.821H273.841V150.931Z" />
				</mask>
				<path
					d="M248.389 156.217C249.1 155.603 249.659 155.099 250.066 154.707C250.481 154.307 250.825 153.893 251.099 153.463C251.373 153.034 251.51 152.604 251.51 152.175C251.51 151.731 251.402 151.383 251.188 151.131C250.98 150.879 250.651 150.754 250.199 150.754C249.763 150.754 249.422 150.894 249.178 151.176C248.941 151.45 248.815 151.82 248.8 152.286H247.579C247.601 151.442 247.853 150.798 248.334 150.354C248.822 149.902 249.441 149.676 250.188 149.676C250.995 149.676 251.625 149.899 252.076 150.343C252.535 150.787 252.765 151.379 252.765 152.12C252.765 152.653 252.628 153.167 252.354 153.663C252.087 154.152 251.765 154.592 251.388 154.985C251.017 155.37 250.544 155.817 249.966 156.328L249.467 156.772H252.987V157.827H247.59V156.906L248.389 156.217ZM254.432 153.785C254.432 152.505 254.647 151.505 255.076 150.787C255.513 150.061 256.261 149.699 257.319 149.699C258.378 149.699 259.122 150.061 259.551 150.787C259.988 151.505 260.207 152.505 260.207 153.785C260.207 155.081 259.988 156.095 259.551 156.828C259.122 157.554 258.378 157.916 257.319 157.916C256.261 157.916 255.513 157.554 255.076 156.828C254.647 156.095 254.432 155.081 254.432 153.785ZM258.963 153.785C258.963 153.186 258.922 152.678 258.841 152.264C258.767 151.849 258.611 151.512 258.374 151.253C258.137 150.987 257.786 150.854 257.319 150.854C256.853 150.854 256.501 150.987 256.264 151.253C256.027 151.512 255.868 151.849 255.787 152.264C255.713 152.678 255.676 153.186 255.676 153.785C255.676 154.407 255.713 154.929 255.787 155.351C255.861 155.773 256.016 156.114 256.253 156.373C256.498 156.632 256.853 156.761 257.319 156.761C257.786 156.761 258.137 156.632 258.374 156.373C258.619 156.114 258.778 155.773 258.852 155.351C258.926 154.929 258.963 154.407 258.963 153.785ZM262.579 156.217C263.29 155.603 263.848 155.099 264.256 154.707C264.67 154.307 265.014 153.893 265.288 153.463C265.562 153.034 265.699 152.604 265.699 152.175C265.699 151.731 265.592 151.383 265.377 151.131C265.17 150.879 264.84 150.754 264.389 150.754C263.952 150.754 263.612 150.894 263.367 151.176C263.13 151.45 263.004 151.82 262.99 152.286H261.768C261.79 151.442 262.042 150.798 262.523 150.354C263.012 149.902 263.63 149.676 264.378 149.676C265.185 149.676 265.814 149.899 266.266 150.343C266.725 150.787 266.954 151.379 266.954 152.12C266.954 152.653 266.817 153.167 266.543 153.663C266.277 154.152 265.955 154.592 265.577 154.985C265.207 155.37 264.733 155.817 264.156 156.328L263.656 156.772H267.176V157.827H261.779V156.906L262.579 156.217ZM273.841 150.931H270.121V153.141C270.276 152.934 270.506 152.76 270.809 152.619C271.12 152.479 271.45 152.408 271.797 152.408C272.419 152.408 272.923 152.542 273.308 152.808C273.7 153.075 273.978 153.411 274.141 153.819C274.311 154.226 274.396 154.655 274.396 155.107C274.396 155.655 274.289 156.143 274.074 156.573C273.867 156.995 273.552 157.328 273.13 157.572C272.715 157.816 272.205 157.938 271.598 157.938C270.791 157.938 270.143 157.739 269.654 157.339C269.166 156.939 268.873 156.41 268.777 155.751H270.01C270.091 156.099 270.272 156.376 270.554 156.584C270.835 156.784 271.187 156.884 271.609 156.884C272.134 156.884 272.527 156.724 272.786 156.406C273.052 156.088 273.186 155.666 273.186 155.14C273.186 154.607 273.052 154.2 272.786 153.919C272.519 153.63 272.127 153.485 271.609 153.485C271.246 153.485 270.939 153.578 270.687 153.763C270.443 153.941 270.265 154.185 270.154 154.496H268.955V149.821H273.841V150.931Z"
					fill="#FD69FF"
				/>
				<path
					d="M248.389 156.217L248.679 156.554L248.68 156.553L248.389 156.217ZM250.066 154.707L250.374 155.027L250.374 155.027L250.066 154.707ZM251.188 151.131L250.845 151.414L250.85 151.419L251.188 151.131ZM249.178 151.176L248.842 150.884L248.842 150.885L249.178 151.176ZM248.8 152.286V152.73H249.231L249.244 152.3L248.8 152.286ZM247.579 152.286L247.135 152.274L247.123 152.73H247.579V152.286ZM248.334 150.354L248.635 150.68L248.635 150.68L248.334 150.354ZM252.076 150.343L251.765 150.659L251.767 150.662L252.076 150.343ZM252.354 153.663L251.965 153.448L251.964 153.45L252.354 153.663ZM251.388 154.985L251.068 154.677L251.067 154.677L251.388 154.985ZM249.966 156.328L249.672 155.996L249.671 155.996L249.966 156.328ZM249.467 156.772L249.171 156.44L248.298 157.217H249.467V156.772ZM252.987 156.772H253.431V156.328H252.987V156.772ZM252.987 157.827V158.272H253.431V157.827H252.987ZM247.59 157.827H247.146V158.272H247.59V157.827ZM247.59 156.906L247.3 156.569L247.146 156.702V156.906H247.59ZM248.389 156.217L248.68 156.553C249.393 155.936 249.959 155.427 250.374 155.027L250.066 154.707L249.758 154.387C249.359 154.772 248.807 155.269 248.099 155.881L248.389 156.217ZM250.066 154.707L250.374 155.027C250.811 154.606 251.178 154.165 251.473 153.702L251.099 153.463L250.724 153.224C250.472 153.621 250.15 154.009 249.758 154.387L250.066 154.707ZM251.099 153.463L251.473 153.702C251.784 153.215 251.954 152.704 251.954 152.175H251.51H251.066C251.066 152.505 250.961 152.853 250.724 153.224L251.099 153.463ZM251.51 152.175H251.954C251.954 151.662 251.829 151.199 251.526 150.843L251.188 151.131L250.85 151.419C250.975 151.567 251.066 151.8 251.066 152.175H251.51ZM251.188 151.131L251.531 150.849C251.21 150.459 250.73 150.309 250.199 150.309V150.754V151.198C250.572 151.198 250.751 151.3 250.845 151.414L251.188 151.131ZM250.199 150.754V150.309C249.658 150.309 249.186 150.489 248.842 150.884L249.178 151.176L249.513 151.467C249.658 151.3 249.867 151.198 250.199 151.198V150.754ZM249.178 151.176L248.842 150.885C248.521 151.256 248.373 151.734 248.356 152.272L248.8 152.286L249.244 152.3C249.257 151.906 249.361 151.643 249.514 151.466L249.178 151.176ZM248.8 152.286V151.842H247.579V152.286V152.73H248.8V152.286ZM247.579 152.286L248.023 152.298C248.043 151.537 248.266 151.021 248.635 150.68L248.334 150.354L248.033 150.027C247.44 150.575 247.159 151.347 247.135 152.274L247.579 152.286ZM248.334 150.354L248.635 150.68C249.031 150.314 249.537 150.121 250.188 150.121V149.676V149.232C249.344 149.232 248.613 149.491 248.032 150.028L248.334 150.354ZM250.188 149.676V150.121C250.912 150.121 251.417 150.318 251.765 150.659L252.076 150.343L252.388 150.026C251.832 149.479 251.078 149.232 250.188 149.232V149.676ZM252.076 150.343L251.767 150.662C252.126 151.009 252.32 151.479 252.32 152.12H252.765H253.209C253.209 151.28 252.944 150.565 252.385 150.024L252.076 150.343ZM252.765 152.12H252.32C252.32 152.573 252.205 153.014 251.965 153.448L252.354 153.663L252.743 153.878C253.05 153.32 253.209 152.732 253.209 152.12H252.765ZM252.354 153.663L251.964 153.45C251.716 153.905 251.417 154.313 251.068 154.677L251.388 154.985L251.708 155.293C252.113 154.871 252.459 154.398 252.744 153.876L252.354 153.663ZM251.388 154.985L251.067 154.677C250.708 155.05 250.244 155.49 249.672 155.996L249.966 156.328L250.261 156.661C250.843 156.145 251.327 155.689 251.708 155.292L251.388 154.985ZM249.966 156.328L249.671 155.996L249.171 156.44L249.467 156.772L249.762 157.104L250.261 156.66L249.966 156.328ZM249.467 156.772V157.217H252.987V156.772V156.328H249.467V156.772ZM252.987 156.772H252.543V157.827H252.987H253.431V156.772H252.987ZM252.987 157.827V157.383H247.59V157.827V158.272H252.987V157.827ZM247.59 157.827H248.034V156.906H247.59H247.146V157.827H247.59ZM247.59 156.906L247.88 157.242L248.679 156.554L248.389 156.217L248.099 155.881L247.3 156.569L247.59 156.906ZM255.076 150.787L254.696 150.558L254.695 150.559L255.076 150.787ZM259.551 150.787L259.169 151.013L259.172 151.018L259.551 150.787ZM259.551 156.828L259.17 156.601L259.169 156.602L259.551 156.828ZM255.076 156.828L254.693 157.053L254.696 157.057L255.076 156.828ZM258.841 152.264L258.403 152.342L258.405 152.35L258.841 152.264ZM258.374 151.253L258.042 151.548L258.046 151.553L258.374 151.253ZM256.264 151.253L256.592 151.553L256.596 151.548L256.264 151.253ZM255.787 152.264L255.351 152.178L255.35 152.186L255.787 152.264ZM255.787 155.351L256.224 155.274H256.224L255.787 155.351ZM256.253 156.373L255.925 156.672L255.93 156.677L256.253 156.373ZM258.374 156.373L258.051 156.068L258.046 156.073L258.374 156.373ZM258.852 155.351L259.289 155.428L258.852 155.351ZM254.432 153.785H254.876C254.876 152.546 255.085 151.637 255.457 151.015L255.076 150.787L254.695 150.559C254.208 151.373 253.988 152.463 253.988 153.785H254.432ZM255.076 150.787L255.457 151.016C255.792 150.459 256.371 150.143 257.319 150.143V149.699V149.254C256.15 149.254 255.233 149.664 254.696 150.558L255.076 150.787ZM257.319 149.699V150.143C258.267 150.143 258.841 150.458 259.169 151.013L259.551 150.787L259.934 150.561C259.403 149.664 258.488 149.254 257.319 149.254V149.699ZM259.551 150.787L259.172 151.018C259.55 151.639 259.762 152.547 259.762 153.785H260.207H260.651C260.651 152.463 260.427 151.371 259.931 150.556L259.551 150.787ZM260.207 153.785H259.762C259.762 155.039 259.55 155.963 259.17 156.601L259.551 156.828L259.933 157.055C260.427 156.227 260.651 155.123 260.651 153.785H260.207ZM259.551 156.828L259.169 156.602C258.841 157.156 258.267 157.472 257.319 157.472V157.916V158.36C258.488 158.36 259.403 157.951 259.934 157.054L259.551 156.828ZM257.319 157.916V157.472C256.371 157.472 255.792 157.156 255.457 156.599L255.076 156.828L254.696 157.057C255.233 157.951 256.15 158.36 257.319 158.36V157.916ZM255.076 156.828L255.459 156.603C255.086 155.965 254.876 155.04 254.876 153.785H254.432H253.988C253.988 155.122 254.208 156.225 254.693 157.053L255.076 156.828ZM258.963 153.785H259.407C259.407 153.168 259.365 152.63 259.277 152.178L258.841 152.264L258.405 152.35C258.479 152.727 258.519 153.203 258.519 153.785H258.963ZM258.841 152.264L259.278 152.186C259.192 151.705 259.006 151.286 258.702 150.954L258.374 151.253L258.046 151.553C258.216 151.739 258.341 151.993 258.403 152.342L258.841 152.264ZM258.374 151.253L258.706 150.958C258.361 150.57 257.871 150.409 257.319 150.409V150.854V151.298C257.7 151.298 257.914 151.404 258.042 151.548L258.374 151.253ZM257.319 150.854V150.409C256.767 150.409 256.278 150.57 255.932 150.958L256.264 151.253L256.596 151.548C256.725 151.404 256.938 151.298 257.319 151.298V150.854ZM256.264 151.253L255.936 150.954C255.634 151.284 255.445 151.7 255.351 152.178L255.787 152.264L256.223 152.35C256.292 151.999 256.42 151.741 256.592 151.553L256.264 151.253ZM255.787 152.264L255.35 152.186C255.269 152.634 255.232 153.169 255.232 153.785H255.676H256.12C256.12 153.202 256.156 152.723 256.224 152.342L255.787 152.264ZM255.676 153.785H255.232C255.232 154.422 255.269 154.972 255.349 155.428L255.787 155.351L256.224 155.274C256.156 154.886 256.12 154.392 256.12 153.785H255.676ZM255.787 155.351L255.349 155.428C255.435 155.915 255.62 156.338 255.925 156.672L256.253 156.373L256.581 156.073C256.413 155.889 256.287 155.631 256.224 155.274L255.787 155.351ZM256.253 156.373L255.93 156.677C256.282 157.051 256.77 157.206 257.319 157.206V156.761V156.317C256.935 156.317 256.713 156.213 256.576 156.068L256.253 156.373ZM257.319 156.761V157.206C257.867 157.206 258.356 157.051 258.702 156.672L258.374 156.373L258.046 156.073C257.919 156.212 257.704 156.317 257.319 156.317V156.761ZM258.374 156.373L258.697 156.677C259.012 156.343 259.203 155.918 259.289 155.428L258.852 155.351L258.414 155.274C258.352 155.628 258.225 155.884 258.051 156.068L258.374 156.373ZM258.852 155.351L259.289 155.428C259.369 154.972 259.407 154.422 259.407 153.785H258.963H258.519C258.519 154.392 258.482 154.886 258.414 155.274L258.852 155.351ZM262.579 156.217L262.869 156.554L262.869 156.553L262.579 156.217ZM264.256 154.707L264.564 155.027L264.564 155.027L264.256 154.707ZM265.377 151.131L265.034 151.414L265.039 151.419L265.377 151.131ZM263.367 151.176L263.032 150.884L263.031 150.885L263.367 151.176ZM262.99 152.286V152.73H263.42L263.434 152.3L262.99 152.286ZM261.768 152.286L261.324 152.274L261.312 152.73H261.768V152.286ZM262.523 150.354L262.825 150.68L262.825 150.68L262.523 150.354ZM266.266 150.343L265.954 150.659L265.957 150.662L266.266 150.343ZM266.543 153.663L266.154 153.448L266.153 153.45L266.543 153.663ZM265.577 154.985L265.257 154.677L265.257 154.677L265.577 154.985ZM264.156 156.328L263.861 155.996L263.861 155.996L264.156 156.328ZM263.656 156.772L263.361 156.44L262.488 157.217H263.656V156.772ZM267.176 156.772H267.62V156.328H267.176V156.772ZM267.176 157.827V158.272H267.62V157.827H267.176ZM261.779 157.827H261.335V158.272H261.779V157.827ZM261.779 156.906L261.489 156.569L261.335 156.702V156.906H261.779ZM262.579 156.217L262.869 156.553C263.583 155.936 264.148 155.427 264.564 155.027L264.256 154.707L263.947 154.387C263.548 154.772 262.996 155.269 262.288 155.881L262.579 156.217ZM264.256 154.707L264.564 155.027C265 154.606 265.368 154.165 265.663 153.702L265.288 153.463L264.914 153.224C264.661 153.621 264.34 154.009 263.947 154.387L264.256 154.707ZM265.288 153.463L265.663 153.702C265.974 153.215 266.143 152.704 266.143 152.175H265.699H265.255C265.255 152.505 265.151 152.853 264.914 153.224L265.288 153.463ZM265.699 152.175H266.143C266.143 151.662 266.019 151.199 265.715 150.843L265.377 151.131L265.039 151.419C265.165 151.567 265.255 151.8 265.255 152.175H265.699ZM265.377 151.131L265.72 150.849C265.399 150.459 264.919 150.309 264.389 150.309V150.754V151.198C264.762 151.198 264.94 151.3 265.034 151.414L265.377 151.131ZM264.389 150.754V150.309C263.848 150.309 263.375 150.489 263.032 150.884L263.367 151.176L263.703 151.467C263.848 151.3 264.056 151.198 264.389 151.198V150.754ZM263.367 151.176L263.031 150.885C262.711 151.256 262.563 151.734 262.546 152.272L262.99 152.286L263.434 152.3C263.446 151.906 263.55 151.643 263.703 151.466L263.367 151.176ZM262.99 152.286V151.842H261.768V152.286V152.73H262.99V152.286ZM261.768 152.286L262.212 152.298C262.232 151.537 262.455 151.021 262.825 150.68L262.523 150.354L262.222 150.027C261.629 150.575 261.349 151.347 261.324 152.274L261.768 152.286ZM262.523 150.354L262.825 150.68C263.221 150.314 263.727 150.121 264.378 150.121V149.676V149.232C263.533 149.232 262.803 149.491 262.222 150.028L262.523 150.354ZM264.378 149.676V150.121C265.102 150.121 265.607 150.318 265.954 150.659L266.266 150.343L266.577 150.026C266.021 149.479 265.268 149.232 264.378 149.232V149.676ZM266.266 150.343L265.957 150.662C266.315 151.009 266.51 151.479 266.51 152.12H266.954H267.398C267.398 151.28 267.134 150.565 266.575 150.024L266.266 150.343ZM266.954 152.12H266.51C266.51 152.573 266.394 153.014 266.154 153.448L266.543 153.663L266.932 153.878C267.24 153.32 267.398 152.732 267.398 152.12H266.954ZM266.543 153.663L266.153 153.45C265.905 153.905 265.607 154.313 265.257 154.677L265.577 154.985L265.897 155.293C266.303 154.871 266.648 154.398 266.933 153.876L266.543 153.663ZM265.577 154.985L265.257 154.677C264.898 155.05 264.433 155.49 263.861 155.996L264.156 156.328L264.45 156.661C265.033 156.145 265.516 155.689 265.897 155.292L265.577 154.985ZM264.156 156.328L263.861 155.996L263.361 156.44L263.656 156.772L263.951 157.104L264.451 156.66L264.156 156.328ZM263.656 156.772V157.217H267.176V156.772V156.328H263.656V156.772ZM267.176 156.772H266.732V157.827H267.176H267.62V156.772H267.176ZM267.176 157.827V157.383H261.779V157.827V158.272H267.176V157.827ZM261.779 157.827H262.223V156.906H261.779H261.335V157.827H261.779ZM261.779 156.906L262.069 157.242L262.869 156.554L262.579 156.217L262.289 155.881L261.489 156.569L261.779 156.906ZM273.841 150.931V151.376H274.285V150.931H273.841ZM270.121 150.931V150.487H269.676V150.931H270.121ZM270.121 153.141H269.676V154.474L270.476 153.408L270.121 153.141ZM270.809 152.619L270.626 152.215L270.622 152.216L270.809 152.619ZM273.308 152.808L273.055 153.173L273.058 153.175L273.308 152.808ZM274.141 153.819L273.728 153.984L273.731 153.99L274.141 153.819ZM274.074 156.573L273.677 156.374L273.675 156.377L274.074 156.573ZM273.13 157.572L272.907 157.188L272.905 157.189L273.13 157.572ZM269.654 157.339L269.936 156.995L269.654 157.339ZM268.777 155.751V155.307H268.263L268.337 155.815L268.777 155.751ZM270.01 155.751L270.442 155.65L270.362 155.307H270.01V155.751ZM270.554 156.584L270.29 156.941L270.296 156.946L270.554 156.584ZM272.786 156.406L272.445 156.121L272.441 156.126L272.786 156.406ZM272.786 153.919L272.459 154.22L272.463 154.224L272.786 153.919ZM270.687 153.763L270.948 154.122L270.95 154.121L270.687 153.763ZM270.154 154.496V154.94H270.467L270.572 154.645L270.154 154.496ZM268.955 154.496H268.51V154.94H268.955V154.496ZM268.955 149.821V149.377H268.51V149.821H268.955ZM273.841 149.821H274.285V149.377H273.841V149.821ZM273.841 150.931V150.487H270.121V150.931V151.376H273.841V150.931ZM270.121 150.931H269.676V153.141H270.121H270.565V150.931H270.121ZM270.121 153.141L270.476 153.408C270.576 153.274 270.74 153.141 270.996 153.022L270.809 152.619L270.622 152.216C270.271 152.379 269.976 152.594 269.765 152.875L270.121 153.141ZM270.809 152.619L270.992 153.024C271.244 152.91 271.511 152.852 271.797 152.852V152.408V151.964C271.388 151.964 270.996 152.047 270.626 152.215L270.809 152.619ZM271.797 152.408V152.852C272.358 152.852 272.765 152.973 273.055 153.173L273.308 152.808L273.561 152.443C273.08 152.11 272.48 151.964 271.797 151.964V152.408ZM273.308 152.808L273.058 153.175C273.384 153.397 273.601 153.665 273.728 153.984L274.141 153.819L274.553 153.654C274.355 153.157 274.017 152.753 273.557 152.441L273.308 152.808ZM274.141 153.819L273.731 153.99C273.878 154.342 273.952 154.713 273.952 155.107H274.396H274.84C274.84 154.598 274.744 154.11 274.55 153.647L274.141 153.819ZM274.396 155.107H273.952C273.952 155.595 273.856 156.014 273.677 156.374L274.074 156.573L274.471 156.771C274.721 156.272 274.84 155.714 274.84 155.107H274.396ZM274.074 156.573L273.675 156.377C273.508 156.717 273.256 156.986 272.907 157.188L273.13 157.572L273.353 157.956C273.848 157.67 274.225 157.272 274.473 156.768L274.074 156.573ZM273.13 157.572L272.905 157.189C272.574 157.384 272.146 157.494 271.598 157.494V157.938V158.383C272.263 158.383 272.857 158.249 273.356 157.955L273.13 157.572ZM271.598 157.938V157.494C270.864 157.494 270.325 157.314 269.936 156.995L269.654 157.339L269.373 157.683C269.961 158.164 270.717 158.383 271.598 158.383V157.938ZM269.654 157.339L269.936 156.995C269.538 156.67 269.298 156.242 269.216 155.687L268.777 155.751L268.337 155.815C268.449 156.577 268.794 157.209 269.373 157.683L269.654 157.339ZM268.777 155.751V156.195H270.01V155.751V155.307H268.777V155.751ZM270.01 155.751L269.577 155.852C269.682 156.3 269.922 156.67 270.29 156.941L270.554 156.584L270.817 156.226C270.623 156.083 270.5 155.897 270.442 155.65L270.01 155.751ZM270.554 156.584L270.296 156.946C270.668 157.21 271.115 157.328 271.609 157.328V156.884V156.439C271.258 156.439 271.002 156.357 270.811 156.222L270.554 156.584ZM271.609 156.884V157.328C272.227 157.328 272.764 157.136 273.13 156.686L272.786 156.406L272.441 156.126C272.289 156.312 272.041 156.439 271.609 156.439V156.884ZM272.786 156.406L273.126 156.691C273.476 156.273 273.63 155.742 273.63 155.14H273.186H272.741C272.741 155.59 272.629 155.902 272.445 156.121L272.786 156.406ZM273.186 155.14H273.63C273.63 154.537 273.478 154.004 273.108 153.613L272.786 153.919L272.463 154.224C272.626 154.396 272.741 154.677 272.741 155.14H273.186ZM272.786 153.919L273.112 153.617C272.737 153.211 272.209 153.041 271.609 153.041V153.485V153.93C272.044 153.93 272.302 154.049 272.459 154.22L272.786 153.919ZM271.609 153.485V153.041C271.167 153.041 270.764 153.155 270.424 153.405L270.687 153.763L270.95 154.121C271.114 154.001 271.325 153.93 271.609 153.93V153.485ZM270.687 153.763L270.426 153.404C270.102 153.639 269.874 153.96 269.736 154.347L270.154 154.496L270.572 154.645C270.656 154.41 270.783 154.243 270.948 154.122L270.687 153.763ZM270.154 154.496V154.052H268.955V154.496V154.94H270.154V154.496ZM268.955 154.496H269.399V149.821H268.955H268.51V154.496H268.955ZM268.955 149.821V150.265H273.841V149.821V149.377H268.955V149.821ZM273.841 149.821H273.397V150.931H273.841H274.285V149.821H273.841Z"
					fill="#7351FD"
					fill-opacity="0.2"
					mask="url(#path-22-outside-2_4301_3131)"
				/>
				<rect
					x="245.91"
					y="171.486"
					width="162.015"
					height="89.2829"
					rx="8.66178"
					stroke="#7351FD"
					stroke-opacity="0.2"
					stroke-width="0.444194"
				/>
				<path
					opacity="0.2"
					d="M258.437 177.751C258.863 177.383 259.199 177.081 259.443 176.845C259.692 176.605 259.898 176.357 260.062 176.099C260.227 175.841 260.309 175.584 260.309 175.326C260.309 175.06 260.245 174.851 260.116 174.7C259.991 174.549 259.794 174.473 259.523 174.473C259.261 174.473 259.056 174.558 258.91 174.726C258.768 174.891 258.692 175.113 258.683 175.393H257.95C257.964 174.886 258.115 174.5 258.403 174.233C258.697 173.962 259.067 173.827 259.516 173.827C260 173.827 260.378 173.96 260.649 174.227C260.924 174.493 261.062 174.849 261.062 175.293C261.062 175.613 260.98 175.921 260.815 176.219C260.655 176.512 260.462 176.776 260.236 177.012C260.014 177.243 259.729 177.512 259.383 177.818L259.083 178.085H261.195V178.718H257.957V178.165L258.437 177.751ZM265.141 174.513L263.288 178.784H262.522L264.394 174.593H261.929V173.947H265.141V174.513Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M284.655 177.751C285.082 177.383 285.417 177.081 285.662 176.845C285.91 176.605 286.117 176.357 286.281 176.099C286.446 175.841 286.528 175.584 286.528 175.326C286.528 175.06 286.463 174.851 286.335 174.7C286.21 174.549 286.012 174.473 285.742 174.473C285.479 174.473 285.275 174.558 285.129 174.726C284.986 174.891 284.911 175.113 284.902 175.393H284.169C284.182 174.886 284.333 174.5 284.622 174.233C284.915 173.962 285.286 173.827 285.735 173.827C286.219 173.827 286.597 173.96 286.868 174.227C287.143 174.493 287.281 174.849 287.281 175.293C287.281 175.613 287.198 175.921 287.034 176.219C286.874 176.512 286.681 176.776 286.454 177.012C286.232 177.243 285.948 177.512 285.602 177.818L285.302 178.085H287.414V178.718H284.176V178.165L284.655 177.751ZM289.101 176.246C288.639 176.015 288.408 175.65 288.408 175.153C288.408 174.913 288.468 174.693 288.588 174.493C288.708 174.293 288.887 174.136 289.127 174.02C289.367 173.9 289.66 173.84 290.007 173.84C290.349 173.84 290.64 173.9 290.88 174.02C291.124 174.136 291.306 174.293 291.426 174.493C291.546 174.693 291.606 174.913 291.606 175.153C291.606 175.402 291.541 175.622 291.413 175.813C291.288 175.999 291.122 176.143 290.913 176.246C291.166 176.339 291.366 176.492 291.513 176.705C291.659 176.914 291.732 177.161 291.732 177.445C291.732 177.734 291.659 177.989 291.513 178.211C291.366 178.433 291.162 178.604 290.9 178.724C290.638 178.844 290.34 178.904 290.007 178.904C289.674 178.904 289.376 178.844 289.114 178.724C288.856 178.604 288.654 178.433 288.508 178.211C288.361 177.989 288.288 177.734 288.288 177.445C288.288 177.156 288.361 176.907 288.508 176.699C288.654 176.49 288.852 176.339 289.101 176.246ZM290.88 175.246C290.88 174.997 290.802 174.806 290.646 174.673C290.491 174.54 290.278 174.473 290.007 174.473C289.74 174.473 289.529 174.54 289.374 174.673C289.218 174.806 289.141 175 289.141 175.253C289.141 175.475 289.221 175.657 289.38 175.799C289.545 175.937 289.754 176.006 290.007 176.006C290.26 176.006 290.469 175.935 290.633 175.793C290.797 175.65 290.88 175.468 290.88 175.246ZM290.007 176.579C289.714 176.579 289.474 176.652 289.287 176.799C289.105 176.941 289.014 177.147 289.014 177.418C289.014 177.671 289.103 177.878 289.281 178.038C289.458 178.193 289.7 178.271 290.007 178.271C290.309 178.271 290.546 178.191 290.72 178.031C290.897 177.871 290.986 177.667 290.986 177.418C290.986 177.152 290.895 176.945 290.713 176.799C290.535 176.652 290.3 176.579 290.007 176.579Z"
					fill="black"
				/>
				<rect
					x="307.812"
					y="170.896"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M310.323 174.62V173.927H311.709V178.784H310.943V174.62H310.323Z"
					fill="black"
				/>
				<rect
					x="334.023"
					y="170.896"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M337.054 177.751C337.48 177.383 337.816 177.081 338.06 176.845C338.309 176.605 338.515 176.357 338.68 176.099C338.844 175.841 338.926 175.584 338.926 175.326C338.926 175.06 338.862 174.851 338.733 174.7C338.609 174.549 338.411 174.473 338.14 174.473C337.878 174.473 337.674 174.558 337.527 174.726C337.385 174.891 337.309 175.113 337.3 175.393H336.568C336.581 174.886 336.732 174.5 337.021 174.233C337.314 173.962 337.685 173.827 338.133 173.827C338.617 173.827 338.995 173.96 339.266 174.227C339.541 174.493 339.679 174.849 339.679 175.293C339.679 175.613 339.597 175.921 339.433 176.219C339.273 176.512 339.079 176.776 338.853 177.012C338.631 177.243 338.347 177.512 338 177.818L337.7 178.085H339.812V178.718H336.574V178.165L337.054 177.751Z"
					fill="black"
				/>
				<rect
					x="360.227"
					y="170.896"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M362.832 175.126C362.858 174.713 363.016 174.391 363.305 174.16C363.598 173.929 363.971 173.814 364.424 173.814C364.735 173.814 365.004 173.869 365.23 173.98C365.457 174.091 365.628 174.242 365.743 174.433C365.859 174.624 365.917 174.84 365.917 175.08C365.917 175.355 365.843 175.59 365.697 175.786C365.55 175.981 365.375 176.112 365.17 176.179V176.206C365.433 176.286 365.637 176.432 365.783 176.645C365.93 176.854 366.003 177.123 366.003 177.452C366.003 177.714 365.943 177.947 365.823 178.151C365.703 178.356 365.526 178.518 365.29 178.638C365.055 178.753 364.773 178.811 364.444 178.811C363.964 178.811 363.569 178.689 363.258 178.444C362.952 178.196 362.787 177.84 362.765 177.378H363.498C363.516 177.614 363.607 177.807 363.771 177.958C363.936 178.105 364.158 178.178 364.438 178.178C364.708 178.178 364.917 178.105 365.064 177.958C365.21 177.807 365.284 177.614 365.284 177.378C365.284 177.067 365.184 176.847 364.984 176.719C364.788 176.585 364.486 176.519 364.078 176.519H363.904V175.892H364.084C364.444 175.888 364.717 175.828 364.904 175.713C365.095 175.597 365.19 175.415 365.19 175.166C365.19 174.953 365.122 174.784 364.984 174.66C364.846 174.531 364.651 174.467 364.398 174.467C364.149 174.467 363.956 174.531 363.818 174.66C363.68 174.784 363.598 174.94 363.571 175.126H362.832Z"
					fill="black"
				/>
				<rect
					x="386.438"
					y="170.896"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M388.971 177.771V177.198L391.209 173.987H392.129V177.112H392.748V177.771H392.129V178.784H391.383V177.771H388.971ZM391.416 174.76L389.843 177.112H391.416V174.76Z"
					fill="black"
				/>
				<rect
					x="255.398"
					y="186.59"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M261.149 190.273H258.916V191.599C259.01 191.475 259.147 191.37 259.33 191.286C259.516 191.202 259.714 191.159 259.923 191.159C260.296 191.159 260.598 191.239 260.829 191.399C261.064 191.559 261.231 191.761 261.328 192.006C261.431 192.25 261.482 192.508 261.482 192.778C261.482 193.107 261.417 193.4 261.288 193.658C261.164 193.911 260.975 194.111 260.722 194.258C260.473 194.404 260.167 194.478 259.803 194.478C259.318 194.478 258.93 194.358 258.637 194.118C258.343 193.878 258.168 193.56 258.11 193.165H258.85C258.899 193.374 259.008 193.54 259.176 193.665C259.345 193.785 259.556 193.845 259.809 193.845C260.125 193.845 260.36 193.749 260.516 193.558C260.675 193.367 260.755 193.114 260.755 192.798C260.755 192.479 260.675 192.234 260.516 192.066C260.356 191.892 260.12 191.806 259.809 191.806C259.592 191.806 259.407 191.861 259.256 191.972C259.11 192.079 259.003 192.225 258.936 192.412H258.217V189.607H261.149V190.273Z"
					fill="black"
				/>
				<rect
					x="281.609"
					y="186.59"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M286.848 190.746C286.799 190.542 286.71 190.389 286.581 190.287C286.452 190.184 286.272 190.133 286.041 190.133C285.69 190.133 285.428 190.269 285.255 190.54C285.082 190.806 284.991 191.25 284.982 191.872C285.097 191.677 285.266 191.526 285.488 191.419C285.71 191.313 285.95 191.259 286.208 191.259C286.501 191.259 286.759 191.324 286.981 191.453C287.207 191.577 287.383 191.759 287.507 191.999C287.636 192.239 287.7 192.525 287.7 192.858C287.7 193.169 287.638 193.447 287.514 193.691C287.394 193.936 287.214 194.129 286.974 194.271C286.734 194.409 286.446 194.478 286.108 194.478C285.65 194.478 285.291 194.378 285.029 194.178C284.771 193.973 284.589 193.687 284.482 193.318C284.38 192.95 284.329 192.49 284.329 191.939C284.329 190.313 284.902 189.5 286.048 189.5C286.492 189.5 286.841 189.62 287.094 189.86C287.352 190.1 287.503 190.395 287.547 190.746H286.848ZM286.041 191.899C285.77 191.899 285.539 191.981 285.348 192.146C285.162 192.305 285.069 192.539 285.069 192.845C285.069 193.152 285.155 193.396 285.328 193.578C285.506 193.756 285.753 193.845 286.068 193.845C286.348 193.845 286.568 193.758 286.728 193.585C286.892 193.411 286.974 193.18 286.974 192.892C286.974 192.59 286.894 192.35 286.734 192.172C286.579 191.99 286.348 191.899 286.041 191.899Z"
					fill="black"
				/>
				<rect
					x="307.812"
					y="186.59"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M313.501 190.207L311.649 194.478H310.883L312.755 190.287H310.29V189.64H313.501V190.207Z"
					fill="black"
				/>
				<rect
					x="334.023"
					y="186.59"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M337.454 191.939C336.992 191.708 336.761 191.344 336.761 190.846C336.761 190.606 336.821 190.387 336.941 190.187C337.061 189.987 337.24 189.829 337.48 189.714C337.72 189.594 338.013 189.534 338.36 189.534C338.702 189.534 338.993 189.594 339.233 189.714C339.477 189.829 339.659 189.987 339.779 190.187C339.899 190.387 339.959 190.606 339.959 190.846C339.959 191.095 339.895 191.315 339.766 191.506C339.641 191.692 339.475 191.837 339.266 191.939C339.519 192.032 339.719 192.185 339.866 192.399C340.012 192.607 340.086 192.854 340.086 193.138C340.086 193.427 340.012 193.682 339.866 193.905C339.719 194.127 339.515 194.298 339.253 194.418C338.991 194.538 338.693 194.597 338.36 194.597C338.027 194.597 337.729 194.538 337.467 194.418C337.209 194.298 337.007 194.127 336.861 193.905C336.714 193.682 336.641 193.427 336.641 193.138C336.641 192.85 336.714 192.601 336.861 192.392C337.007 192.183 337.205 192.032 337.454 191.939ZM339.233 190.94C339.233 190.691 339.155 190.5 338.999 190.367C338.844 190.233 338.631 190.167 338.36 190.167C338.093 190.167 337.882 190.233 337.727 190.367C337.571 190.5 337.494 190.693 337.494 190.946C337.494 191.168 337.574 191.35 337.734 191.493C337.898 191.63 338.107 191.699 338.36 191.699C338.613 191.699 338.822 191.628 338.986 191.486C339.151 191.344 339.233 191.162 339.233 190.94ZM338.36 192.272C338.067 192.272 337.827 192.345 337.64 192.492C337.458 192.634 337.367 192.841 337.367 193.112C337.367 193.365 337.456 193.571 337.634 193.731C337.811 193.887 338.053 193.964 338.36 193.964C338.662 193.964 338.9 193.885 339.073 193.725C339.25 193.565 339.339 193.36 339.339 193.112C339.339 192.845 339.248 192.639 339.066 192.492C338.888 192.345 338.653 192.272 338.36 192.272Z"
					fill="black"
				/>
				<rect
					x="360.227"
					y="186.589"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M363.791 193.158C363.836 193.38 363.931 193.549 364.078 193.665C364.224 193.78 364.422 193.838 364.671 193.838C364.986 193.838 365.217 193.714 365.364 193.465C365.51 193.216 365.584 192.792 365.584 192.192C365.477 192.343 365.326 192.461 365.13 192.545C364.939 192.625 364.731 192.665 364.504 192.665C364.215 192.665 363.953 192.607 363.718 192.492C363.483 192.372 363.296 192.197 363.158 191.966C363.025 191.73 362.958 191.446 362.958 191.113C362.958 190.624 363.1 190.235 363.385 189.947C363.674 189.654 364.069 189.507 364.571 189.507C365.175 189.507 365.604 189.709 365.857 190.113C366.114 190.513 366.243 191.128 366.243 191.959C366.243 192.532 366.194 193.001 366.097 193.365C366.003 193.729 365.839 194.004 365.604 194.191C365.368 194.378 365.042 194.471 364.624 194.471C364.149 194.471 363.782 194.347 363.525 194.098C363.267 193.849 363.123 193.536 363.092 193.158H363.791ZM364.637 192.026C364.904 192.026 365.113 191.943 365.264 191.779C365.419 191.61 365.497 191.388 365.497 191.113C365.497 190.806 365.415 190.569 365.25 190.4C365.09 190.227 364.871 190.14 364.591 190.14C364.311 190.14 364.089 190.229 363.924 190.407C363.765 190.58 363.685 190.808 363.685 191.093C363.685 191.364 363.762 191.588 363.918 191.766C364.078 191.939 364.318 192.026 364.637 192.026Z"
					fill="black"
				/>
				<rect
					x="386.438"
					y="186.59"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M388.964 190.313V189.62H390.35V194.478H389.584V190.313H388.964ZM391.593 191.986C391.593 191.217 391.722 190.617 391.98 190.187C392.242 189.751 392.69 189.534 393.325 189.534C393.961 189.534 394.407 189.751 394.665 190.187C394.927 190.617 395.058 191.217 395.058 191.986C395.058 192.763 394.927 193.371 394.665 193.811C394.407 194.247 393.961 194.464 393.325 194.464C392.69 194.464 392.242 194.247 391.98 193.811C391.722 193.371 391.593 192.763 391.593 191.986ZM394.312 191.986C394.312 191.626 394.287 191.322 394.238 191.073C394.194 190.824 394.101 190.622 393.958 190.466C393.816 190.307 393.605 190.227 393.325 190.227C393.046 190.227 392.835 190.307 392.693 190.466C392.55 190.622 392.455 190.824 392.406 191.073C392.362 191.322 392.339 191.626 392.339 191.986C392.339 192.359 392.362 192.672 392.406 192.925C392.45 193.178 392.544 193.383 392.686 193.538C392.832 193.694 393.046 193.771 393.325 193.771C393.605 193.771 393.816 193.694 393.958 193.538C394.105 193.383 394.201 193.178 394.245 192.925C394.289 192.672 394.312 192.359 394.312 191.986Z"
					fill="black"
				/>
				<rect
					x="255.398"
					y="202.283"
					width="143.03"
					height="11.9932"
					rx="5.99661"
					fill="#FEC5FF"
				/>
				<rect
					x="255.398"
					y="202.283"
					width="11.9932"
					height="11.9932"
					fill="#FEC5FF"
				/>
				<path
					d="M257.917 206.008V205.315H259.303V210.172H258.537V206.008H257.917ZM260.446 206.008V205.315H261.832V210.172H261.066V206.008H260.446Z"
					fill="black"
				/>
				<rect
					x="281.609"
					y="202.283"
					width="11.9932"
					height="11.9932"
					fill="#FEC5FF"
				/>
				<path
					d="M284.136 206.008V205.315H285.522V210.172H284.755V206.008H284.136ZM287.185 209.139C287.611 208.77 287.947 208.468 288.191 208.233C288.44 207.993 288.646 207.744 288.811 207.487C288.975 207.229 289.057 206.971 289.057 206.714C289.057 206.447 288.993 206.239 288.864 206.088C288.739 205.936 288.542 205.861 288.271 205.861C288.009 205.861 287.804 205.945 287.658 206.114C287.516 206.279 287.44 206.501 287.431 206.78H286.698C286.712 206.274 286.863 205.888 287.151 205.621C287.445 205.35 287.816 205.215 288.264 205.215C288.748 205.215 289.126 205.348 289.397 205.614C289.672 205.881 289.81 206.236 289.81 206.681C289.81 207 289.728 207.309 289.563 207.607C289.404 207.9 289.21 208.164 288.984 208.4C288.762 208.631 288.477 208.899 288.131 209.206L287.831 209.472H289.943V210.105H286.705V209.552L287.185 209.139Z"
					fill="black"
				/>
				<rect
					x="307.812"
					y="202.283"
					width="11.9932"
					height="11.9932"
					fill="#FEC5FF"
				/>
				<path
					d="M310.323 206.008V205.315H311.709V210.172H310.943V206.008H310.323ZM312.939 206.514C312.966 206.101 313.124 205.779 313.412 205.548C313.705 205.317 314.079 205.201 314.532 205.201C314.843 205.201 315.111 205.257 315.338 205.368C315.564 205.479 315.735 205.63 315.851 205.821C315.966 206.012 316.024 206.227 316.024 206.467C316.024 206.743 315.951 206.978 315.804 207.174C315.658 207.369 315.482 207.5 315.278 207.567V207.593C315.54 207.673 315.744 207.82 315.891 208.033C316.037 208.242 316.111 208.511 316.111 208.839C316.111 209.101 316.051 209.335 315.931 209.539C315.811 209.743 315.633 209.905 315.398 210.025C315.162 210.141 314.88 210.199 314.552 210.199C314.072 210.199 313.677 210.076 313.366 209.832C313.059 209.583 312.895 209.228 312.873 208.766H313.605C313.623 209.001 313.714 209.195 313.879 209.346C314.043 209.492 314.265 209.566 314.545 209.566C314.816 209.566 315.025 209.492 315.171 209.346C315.318 209.195 315.391 209.001 315.391 208.766C315.391 208.455 315.291 208.235 315.091 208.106C314.896 207.973 314.594 207.906 314.185 207.906H314.012V207.28H314.192C314.552 207.276 314.825 207.216 315.011 207.1C315.202 206.985 315.298 206.803 315.298 206.554C315.298 206.341 315.229 206.172 315.091 206.048C314.954 205.919 314.758 205.854 314.505 205.854C314.256 205.854 314.063 205.919 313.925 206.048C313.788 206.172 313.705 206.327 313.679 206.514H312.939Z"
					fill="black"
				/>
				<rect
					x="334.023"
					y="202.283"
					width="11.9932"
					height="11.9932"
					fill="#FEC5FF"
				/>
				<path
					d="M336.534 206.008V205.315H337.92V210.172H337.154V206.008H336.534ZM339.07 209.159V208.586L341.309 205.375H342.228V208.499H342.848V209.159H342.228V210.172H341.482V209.159H339.07ZM341.515 206.147L339.943 208.499H341.515V206.147Z"
					fill="black"
				/>
				<rect
					x="360.227"
					y="202.283"
					width="11.9932"
					height="11.9932"
					fill="#FEC5FF"
				/>
				<path
					d="M362.745 206.008V205.315H364.131V210.172H363.365V206.008H362.745ZM368.506 205.968H366.274V207.294C366.367 207.169 366.505 207.065 366.687 206.98C366.874 206.896 367.071 206.854 367.28 206.854C367.653 206.854 367.955 206.934 368.186 207.094C368.422 207.254 368.588 207.456 368.686 207.7C368.788 207.944 368.839 208.202 368.839 208.473C368.839 208.802 368.775 209.095 368.646 209.352C368.521 209.606 368.333 209.805 368.08 209.952C367.831 210.099 367.524 210.172 367.16 210.172C366.676 210.172 366.287 210.052 365.994 209.812C365.701 209.572 365.525 209.255 365.468 208.859H366.207C366.256 209.068 366.365 209.235 366.534 209.359C366.703 209.479 366.914 209.539 367.167 209.539C367.482 209.539 367.718 209.443 367.873 209.252C368.033 209.061 368.113 208.808 368.113 208.493C368.113 208.173 368.033 207.929 367.873 207.76C367.713 207.587 367.478 207.5 367.167 207.5C366.949 207.5 366.765 207.556 366.614 207.667C366.467 207.773 366.36 207.92 366.294 208.106H365.574V205.301H368.506V205.968Z"
					fill="black"
				/>
				<rect
					x="386.438"
					y="202.283"
					width="11.9932"
					height="11.9932"
					fill="#FEC5FF"
				/>
				<path
					d="M388.964 206.008V205.315H390.35V210.172H389.584V206.008H388.964ZM394.205 206.441C394.156 206.236 394.067 206.083 393.938 205.981C393.81 205.879 393.63 205.828 393.399 205.828C393.048 205.828 392.786 205.963 392.613 206.234C392.439 206.501 392.348 206.945 392.339 207.567C392.455 207.371 392.624 207.22 392.846 207.114C393.068 207.007 393.308 206.954 393.565 206.954C393.859 206.954 394.116 207.018 394.338 207.147C394.565 207.271 394.74 207.453 394.865 207.693C394.993 207.933 395.058 208.22 395.058 208.553C395.058 208.864 394.996 209.141 394.871 209.386C394.751 209.63 394.571 209.823 394.332 209.965C394.092 210.103 393.803 210.172 393.465 210.172C393.008 210.172 392.648 210.072 392.386 209.872C392.128 209.668 391.946 209.381 391.84 209.013C391.738 208.644 391.686 208.184 391.686 207.633C391.686 206.008 392.259 205.195 393.405 205.195C393.85 205.195 394.198 205.315 394.452 205.554C394.709 205.794 394.86 206.09 394.905 206.441H394.205ZM393.399 207.593C393.128 207.593 392.897 207.676 392.706 207.84C392.519 208 392.426 208.233 392.426 208.539C392.426 208.846 392.513 209.09 392.686 209.272C392.864 209.45 393.11 209.539 393.425 209.539C393.705 209.539 393.925 209.452 394.085 209.279C394.249 209.106 394.332 208.875 394.332 208.586C394.332 208.284 394.252 208.044 394.092 207.867C393.936 207.684 393.705 207.593 393.399 207.593Z"
					fill="black"
				/>
				<rect
					x="255.398"
					y="217.977"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M257.917 221.7V221.007H259.303V225.864H258.537V221.7H257.917ZM263.625 221.593L261.772 225.864H261.006L262.878 221.673H260.413V221.027H263.625V221.593Z"
					fill="black"
				/>
				<rect
					x="281.609"
					y="217.977"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M284.136 221.7V221.007H285.522V225.864H284.755V221.7H284.136ZM287.585 223.326C287.123 223.095 286.892 222.73 286.892 222.233C286.892 221.993 286.952 221.773 287.072 221.573C287.191 221.373 287.371 221.216 287.611 221.1C287.851 220.98 288.144 220.92 288.491 220.92C288.833 220.92 289.124 220.98 289.364 221.1C289.608 221.216 289.79 221.373 289.91 221.573C290.03 221.773 290.09 221.993 290.09 222.233C290.09 222.482 290.025 222.702 289.897 222.893C289.772 223.079 289.606 223.224 289.397 223.326C289.65 223.419 289.85 223.572 289.997 223.785C290.143 223.994 290.216 224.241 290.216 224.525C290.216 224.814 290.143 225.069 289.997 225.291C289.85 225.513 289.646 225.684 289.384 225.804C289.121 225.924 288.824 225.984 288.491 225.984C288.158 225.984 287.86 225.924 287.598 225.804C287.34 225.684 287.138 225.513 286.992 225.291C286.845 225.069 286.772 224.814 286.772 224.525C286.772 224.236 286.845 223.988 286.992 223.779C287.138 223.57 287.336 223.419 287.585 223.326ZM289.364 222.326C289.364 222.078 289.286 221.887 289.13 221.753C288.975 221.62 288.762 221.553 288.491 221.553C288.224 221.553 288.013 221.62 287.858 221.753C287.702 221.887 287.625 222.08 287.625 222.333C287.625 222.555 287.704 222.737 287.864 222.879C288.029 223.017 288.238 223.086 288.491 223.086C288.744 223.086 288.953 223.015 289.117 222.873C289.281 222.73 289.364 222.548 289.364 222.326ZM288.491 223.659C288.198 223.659 287.958 223.732 287.771 223.879C287.589 224.021 287.498 224.227 287.498 224.498C287.498 224.752 287.587 224.958 287.764 225.118C287.942 225.273 288.184 225.351 288.491 225.351C288.793 225.351 289.03 225.271 289.204 225.111C289.381 224.951 289.47 224.747 289.47 224.498C289.47 224.232 289.379 224.025 289.197 223.879C289.019 223.732 288.784 223.659 288.491 223.659Z"
					fill="black"
				/>
				<rect
					x="307.812"
					y="217.977"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M310.323 221.7V221.007H311.709V225.864H310.943V221.7H310.323ZM313.899 224.545C313.943 224.767 314.039 224.936 314.185 225.051C314.332 225.167 314.529 225.225 314.778 225.225C315.094 225.225 315.325 225.1 315.471 224.851C315.618 224.603 315.691 224.179 315.691 223.579C315.584 223.73 315.433 223.848 315.238 223.932C315.047 224.012 314.838 224.052 314.612 224.052C314.323 224.052 314.061 223.994 313.825 223.879C313.59 223.759 313.403 223.583 313.266 223.352C313.132 223.117 313.066 222.833 313.066 222.499C313.066 222.011 313.208 221.622 313.492 221.333C313.781 221.04 314.176 220.894 314.678 220.894C315.282 220.894 315.711 221.096 315.964 221.5C316.222 221.9 316.351 222.515 316.351 223.346C316.351 223.919 316.302 224.387 316.204 224.752C316.111 225.116 315.946 225.391 315.711 225.578C315.476 225.764 315.149 225.858 314.732 225.858C314.256 225.858 313.89 225.733 313.632 225.484C313.374 225.236 313.23 224.923 313.199 224.545H313.899ZM314.745 223.412C315.011 223.412 315.22 223.33 315.371 223.166C315.527 222.997 315.604 222.775 315.604 222.499C315.604 222.193 315.522 221.955 315.358 221.787C315.198 221.613 314.978 221.527 314.698 221.527C314.418 221.527 314.196 221.616 314.032 221.793C313.872 221.966 313.792 222.195 313.792 222.48C313.792 222.75 313.87 222.975 314.025 223.152C314.185 223.326 314.425 223.412 314.745 223.412Z"
					fill="black"
				/>
				<rect
					x="334.023"
					y="217.977"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M337.054 224.832C337.48 224.463 337.816 224.161 338.06 223.925C338.309 223.685 338.515 223.437 338.68 223.179C338.844 222.921 338.926 222.664 338.926 222.406C338.926 222.14 338.862 221.931 338.733 221.78C338.609 221.629 338.411 221.553 338.14 221.553C337.878 221.553 337.674 221.638 337.527 221.807C337.385 221.971 337.309 222.193 337.3 222.473H336.568C336.581 221.966 336.732 221.58 337.021 221.313C337.314 221.043 337.685 220.907 338.133 220.907C338.617 220.907 338.995 221.04 339.266 221.307C339.541 221.573 339.679 221.929 339.679 222.373C339.679 222.693 339.597 223.001 339.433 223.299C339.273 223.592 339.079 223.857 338.853 224.092C338.631 224.323 338.347 224.592 338 224.898L337.7 225.165H339.812V225.798H336.574V225.245L337.054 224.832ZM340.68 223.372C340.68 222.604 340.808 222.004 341.066 221.573C341.328 221.138 341.777 220.92 342.412 220.92C343.047 220.92 343.493 221.138 343.751 221.573C344.013 222.004 344.144 222.604 344.144 223.372C344.144 224.15 344.013 224.758 343.751 225.198C343.493 225.633 343.047 225.851 342.412 225.851C341.777 225.851 341.328 225.633 341.066 225.198C340.808 224.758 340.68 224.15 340.68 223.372ZM343.398 223.372C343.398 223.013 343.374 222.708 343.325 222.46C343.28 222.211 343.187 222.009 343.045 221.853C342.903 221.693 342.692 221.613 342.412 221.613C342.132 221.613 341.921 221.693 341.779 221.853C341.637 222.009 341.541 222.211 341.492 222.46C341.448 222.708 341.426 223.013 341.426 223.372C341.426 223.745 341.448 224.059 341.492 224.312C341.537 224.565 341.63 224.769 341.772 224.925C341.919 225.08 342.132 225.158 342.412 225.158C342.692 225.158 342.903 225.08 343.045 224.925C343.191 224.769 343.287 224.565 343.331 224.312C343.376 224.059 343.398 223.745 343.398 223.372Z"
					fill="black"
				/>
				<rect
					x="360.227"
					y="217.977"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M363.265 224.832C363.691 224.463 364.027 224.161 364.271 223.925C364.52 223.685 364.726 223.437 364.891 223.179C365.055 222.921 365.137 222.664 365.137 222.406C365.137 222.14 365.073 221.931 364.944 221.78C364.82 221.629 364.622 221.553 364.351 221.553C364.089 221.553 363.884 221.638 363.738 221.807C363.596 221.971 363.52 222.193 363.511 222.473H362.778C362.792 221.966 362.943 221.58 363.232 221.313C363.525 221.043 363.896 220.907 364.344 220.907C364.828 220.907 365.206 221.04 365.477 221.307C365.752 221.573 365.89 221.929 365.89 222.373C365.89 222.693 365.808 223.001 365.644 223.299C365.484 223.592 365.29 223.857 365.064 224.092C364.842 224.323 364.557 224.592 364.211 224.898L363.911 225.165H366.023V225.798H362.785V225.245L363.265 224.832ZM366.791 221.7V221.007H368.176V225.864H367.41V221.7H366.791Z"
					fill="black"
				/>
				<rect
					x="386.438"
					y="217.977"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M389.484 224.832C389.91 224.463 390.245 224.161 390.49 223.925C390.738 223.685 390.945 223.437 391.109 223.179C391.274 222.921 391.356 222.664 391.356 222.406C391.356 222.14 391.291 221.931 391.163 221.78C391.038 221.629 390.841 221.553 390.57 221.553C390.308 221.553 390.103 221.638 389.957 221.807C389.815 221.971 389.739 222.193 389.73 222.473H388.997C389.011 221.966 389.162 221.58 389.45 221.313C389.743 221.043 390.114 220.907 390.563 220.907C391.047 220.907 391.425 221.04 391.696 221.307C391.971 221.573 392.109 221.929 392.109 222.373C392.109 222.693 392.027 223.001 391.862 223.299C391.702 223.592 391.509 223.857 391.283 224.092C391.06 224.323 390.776 224.592 390.43 224.898L390.13 225.165H392.242V225.798H389.004V225.245L389.484 224.832ZM393.529 224.832C393.955 224.463 394.291 224.161 394.535 223.925C394.784 223.685 394.99 223.437 395.155 223.179C395.319 222.921 395.401 222.664 395.401 222.406C395.401 222.14 395.337 221.931 395.208 221.78C395.084 221.629 394.886 221.553 394.615 221.553C394.353 221.553 394.149 221.638 394.002 221.807C393.86 221.971 393.784 222.193 393.775 222.473H393.043C393.056 221.966 393.207 221.58 393.496 221.313C393.789 221.043 394.16 220.907 394.608 220.907C395.093 220.907 395.47 221.04 395.741 221.307C396.016 221.573 396.154 221.929 396.154 222.373C396.154 222.693 396.072 223.001 395.908 223.299C395.748 223.592 395.554 223.857 395.328 224.092C395.106 224.323 394.822 224.592 394.475 224.898L394.175 225.165H396.287V225.798H393.049V225.245L393.529 224.832Z"
					fill="black"
				/>
				<rect
					x="255.398"
					y="233.671"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M258.437 240.527C258.863 240.158 259.199 239.856 259.443 239.621C259.692 239.381 259.898 239.132 260.062 238.874C260.227 238.617 260.309 238.359 260.309 238.102C260.309 237.835 260.245 237.626 260.116 237.475C259.991 237.324 259.794 237.249 259.523 237.249C259.261 237.249 259.056 237.333 258.91 237.502C258.768 237.666 258.692 237.888 258.683 238.168H257.95C257.964 237.662 258.115 237.275 258.403 237.009C258.697 236.738 259.067 236.602 259.516 236.602C260 236.602 260.378 236.736 260.649 237.002C260.924 237.269 261.062 237.624 261.062 238.068C261.062 238.388 260.98 238.697 260.815 238.994C260.655 239.288 260.462 239.552 260.236 239.787C260.014 240.018 259.729 240.287 259.383 240.593L259.083 240.86H261.195V241.493H257.957V240.94L258.437 240.527ZM262.049 237.902C262.076 237.489 262.233 237.166 262.522 236.936C262.815 236.705 263.188 236.589 263.641 236.589C263.952 236.589 264.221 236.645 264.448 236.756C264.674 236.867 264.845 237.018 264.961 237.209C265.076 237.4 265.134 237.615 265.134 237.855C265.134 238.13 265.061 238.366 264.914 238.561C264.767 238.757 264.592 238.888 264.388 238.954V238.981C264.65 239.061 264.854 239.208 265.001 239.421C265.147 239.63 265.221 239.898 265.221 240.227C265.221 240.489 265.161 240.722 265.041 240.927C264.921 241.131 264.743 241.293 264.508 241.413C264.272 241.528 263.99 241.586 263.661 241.586C263.182 241.586 262.786 241.464 262.475 241.22C262.169 240.971 262.005 240.616 261.982 240.154H262.715C262.733 240.389 262.824 240.582 262.988 240.733C263.153 240.88 263.375 240.953 263.655 240.953C263.926 240.953 264.134 240.88 264.281 240.733C264.428 240.582 264.501 240.389 264.501 240.154C264.501 239.843 264.401 239.623 264.201 239.494C264.006 239.361 263.704 239.294 263.295 239.294H263.122V238.668H263.302C263.661 238.663 263.935 238.603 264.121 238.488C264.312 238.372 264.408 238.19 264.408 237.942C264.408 237.728 264.339 237.56 264.201 237.435C264.063 237.306 263.868 237.242 263.615 237.242C263.366 237.242 263.173 237.306 263.035 237.435C262.897 237.56 262.815 237.715 262.789 237.902H262.049Z"
					fill="black"
				/>
				<rect
					x="281.609"
					y="233.672"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M284.655 240.527C285.082 240.158 285.417 239.856 285.662 239.621C285.91 239.381 286.117 239.132 286.281 238.874C286.446 238.617 286.528 238.359 286.528 238.102C286.528 237.835 286.463 237.626 286.335 237.475C286.21 237.324 286.012 237.249 285.742 237.249C285.479 237.249 285.275 237.333 285.129 237.502C284.986 237.666 284.911 237.888 284.902 238.168H284.169C284.182 237.662 284.333 237.275 284.622 237.009C284.915 236.738 285.286 236.602 285.735 236.602C286.219 236.602 286.597 236.736 286.868 237.002C287.143 237.269 287.281 237.624 287.281 238.068C287.281 238.388 287.198 238.697 287.034 238.994C286.874 239.288 286.681 239.552 286.454 239.787C286.232 240.018 285.948 240.287 285.602 240.593L285.302 240.86H287.414V241.493H284.176V240.94L284.655 240.527ZM288.188 240.547V239.974L290.427 236.762H291.346V239.887H291.966V240.547H291.346V241.56H290.6V240.547H288.188ZM290.633 237.535L289.061 239.887H290.633V237.535Z"
					fill="black"
				/>
				<rect
					x="307.812"
					y="233.671"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M310.843 240.527C311.269 240.158 311.605 239.856 311.849 239.621C312.098 239.381 312.304 239.132 312.469 238.874C312.633 238.617 312.715 238.359 312.715 238.102C312.715 237.835 312.651 237.626 312.522 237.475C312.398 237.324 312.2 237.249 311.929 237.249C311.667 237.249 311.463 237.333 311.316 237.502C311.174 237.666 311.098 237.888 311.09 238.168H310.357C310.37 237.662 310.521 237.275 310.81 237.009C311.103 236.738 311.474 236.602 311.922 236.602C312.407 236.602 312.784 236.736 313.055 237.002C313.33 237.269 313.468 237.624 313.468 238.068C313.468 238.388 313.386 238.697 313.222 238.994C313.062 239.288 312.868 239.552 312.642 239.787C312.42 240.018 312.136 240.287 311.789 240.593L311.489 240.86H313.601V241.493H310.363V240.94L310.843 240.527ZM317.6 237.355H315.368V238.681C315.461 238.557 315.599 238.452 315.781 238.368C315.968 238.284 316.165 238.241 316.374 238.241C316.747 238.241 317.049 238.321 317.28 238.481C317.516 238.641 317.682 238.843 317.78 239.088C317.882 239.332 317.933 239.59 317.933 239.861C317.933 240.189 317.869 240.482 317.74 240.74C317.616 240.993 317.427 241.193 317.174 241.34C316.925 241.486 316.618 241.56 316.254 241.56C315.77 241.56 315.381 241.44 315.088 241.2C314.795 240.96 314.62 240.642 314.562 240.247H315.301C315.35 240.456 315.459 240.622 315.628 240.747C315.797 240.867 316.008 240.927 316.261 240.927C316.576 240.927 316.812 240.831 316.967 240.64C317.127 240.449 317.207 240.196 317.207 239.881C317.207 239.561 317.127 239.316 316.967 239.148C316.807 238.974 316.572 238.888 316.261 238.888C316.043 238.888 315.859 238.943 315.708 239.054C315.561 239.161 315.455 239.308 315.388 239.494H314.668V236.689H317.6V237.355Z"
					fill="black"
				/>
				<rect
					x="334.023"
					y="233.671"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M337.054 240.527C337.48 240.158 337.816 239.856 338.06 239.621C338.309 239.381 338.515 239.132 338.68 238.874C338.844 238.617 338.926 238.359 338.926 238.102C338.926 237.835 338.862 237.626 338.733 237.475C338.609 237.324 338.411 237.249 338.14 237.249C337.878 237.249 337.674 237.333 337.527 237.502C337.385 237.666 337.309 237.888 337.3 238.168H336.568C336.581 237.662 336.732 237.275 337.021 237.009C337.314 236.738 337.685 236.602 338.133 236.602C338.617 236.602 338.995 236.736 339.266 237.002C339.541 237.269 339.679 237.624 339.679 238.068C339.679 238.388 339.597 238.697 339.433 238.994C339.273 239.288 339.079 239.552 338.853 239.787C338.631 240.018 338.347 240.287 338 240.593L337.7 240.86H339.812V241.493H336.574V240.94L337.054 240.527ZM343.291 237.828C343.243 237.624 343.154 237.471 343.025 237.369C342.896 237.266 342.716 237.215 342.485 237.215C342.134 237.215 341.872 237.351 341.699 237.622C341.526 237.888 341.435 238.333 341.426 238.954C341.541 238.759 341.71 238.608 341.932 238.501C342.154 238.395 342.394 238.341 342.652 238.341C342.945 238.341 343.203 238.406 343.425 238.535C343.651 238.659 343.827 238.841 343.951 239.081C344.08 239.321 344.144 239.607 344.144 239.94C344.144 240.251 344.082 240.529 343.958 240.773C343.838 241.018 343.658 241.211 343.418 241.353C343.178 241.491 342.889 241.56 342.552 241.56C342.094 241.56 341.734 241.46 341.472 241.26C341.215 241.055 341.033 240.769 340.926 240.4C340.824 240.032 340.773 239.572 340.773 239.021C340.773 237.395 341.346 236.582 342.492 236.582C342.936 236.582 343.285 236.702 343.538 236.942C343.796 237.182 343.947 237.477 343.991 237.828H343.291ZM342.485 238.981C342.214 238.981 341.983 239.063 341.792 239.228C341.606 239.387 341.512 239.621 341.512 239.927C341.512 240.234 341.599 240.478 341.772 240.66C341.95 240.838 342.196 240.927 342.512 240.927C342.792 240.927 343.012 240.84 343.171 240.667C343.336 240.494 343.418 240.263 343.418 239.974C343.418 239.672 343.338 239.432 343.178 239.254C343.023 239.072 342.792 238.981 342.485 238.981Z"
					fill="black"
				/>
				<rect
					x="360.227"
					y="233.672"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M363.265 240.527C363.691 240.158 364.027 239.856 364.271 239.621C364.52 239.381 364.726 239.132 364.891 238.874C365.055 238.617 365.137 238.359 365.137 238.102C365.137 237.835 365.073 237.626 364.944 237.475C364.82 237.324 364.622 237.249 364.351 237.249C364.089 237.249 363.884 237.333 363.738 237.502C363.596 237.666 363.52 237.888 363.511 238.168H362.778C362.792 237.662 362.943 237.275 363.232 237.009C363.525 236.738 363.896 236.602 364.344 236.602C364.828 236.602 365.206 236.736 365.477 237.002C365.752 237.269 365.89 237.624 365.89 238.068C365.89 238.388 365.808 238.697 365.644 238.994C365.484 239.288 365.29 239.552 365.064 239.787C364.842 240.018 364.557 240.287 364.211 240.593L363.911 240.86H366.023V241.493H362.785V240.94L363.265 240.527ZM369.969 237.289L368.116 241.56H367.35L369.222 237.369H366.757V236.722H369.969V237.289Z"
					fill="black"
				/>
				<rect
					x="386.438"
					y="233.672"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M389.484 240.527C389.91 240.158 390.245 239.856 390.49 239.621C390.738 239.381 390.945 239.132 391.109 238.874C391.274 238.617 391.356 238.359 391.356 238.102C391.356 237.835 391.291 237.626 391.163 237.475C391.038 237.324 390.841 237.249 390.57 237.249C390.308 237.249 390.103 237.333 389.957 237.502C389.815 237.666 389.739 237.888 389.73 238.168H388.997C389.011 237.662 389.162 237.275 389.45 237.009C389.743 236.738 390.114 236.602 390.563 236.602C391.047 236.602 391.425 236.736 391.696 237.002C391.971 237.269 392.109 237.624 392.109 238.068C392.109 238.388 392.027 238.697 391.862 238.994C391.702 239.288 391.509 239.552 391.283 239.787C391.06 240.018 390.776 240.287 390.43 240.593L390.13 240.86H392.242V241.493H389.004V240.94L389.484 240.527ZM393.929 239.021C393.467 238.79 393.236 238.426 393.236 237.928C393.236 237.688 393.296 237.469 393.416 237.269C393.536 237.069 393.716 236.911 393.955 236.796C394.195 236.676 394.488 236.616 394.835 236.616C395.177 236.616 395.468 236.676 395.708 236.796C395.952 236.911 396.134 237.069 396.254 237.269C396.374 237.469 396.434 237.688 396.434 237.928C396.434 238.177 396.37 238.397 396.241 238.588C396.116 238.774 395.95 238.919 395.741 239.021C395.994 239.114 396.194 239.268 396.341 239.481C396.487 239.69 396.561 239.936 396.561 240.22C396.561 240.509 396.487 240.764 396.341 240.987C396.194 241.209 395.99 241.38 395.728 241.5C395.466 241.62 395.168 241.68 394.835 241.68C394.502 241.68 394.204 241.62 393.942 241.5C393.684 241.38 393.482 241.209 393.336 240.987C393.189 240.764 393.116 240.509 393.116 240.22C393.116 239.932 393.189 239.683 393.336 239.474C393.482 239.265 393.68 239.114 393.929 239.021ZM395.708 238.022C395.708 237.773 395.63 237.582 395.475 237.449C395.319 237.315 395.106 237.249 394.835 237.249C394.568 237.249 394.357 237.315 394.202 237.449C394.046 237.582 393.969 237.775 393.969 238.028C393.969 238.25 394.049 238.432 394.209 238.575C394.373 238.712 394.582 238.781 394.835 238.781C395.088 238.781 395.297 238.71 395.461 238.568C395.626 238.426 395.708 238.244 395.708 238.022ZM394.835 239.354C394.542 239.354 394.302 239.427 394.115 239.574C393.933 239.716 393.842 239.923 393.842 240.194C393.842 240.447 393.931 240.653 394.109 240.813C394.286 240.969 394.528 241.047 394.835 241.047C395.137 241.047 395.375 240.967 395.548 240.807C395.726 240.647 395.814 240.442 395.814 240.194C395.814 239.927 395.723 239.721 395.541 239.574C395.363 239.427 395.128 239.354 394.835 239.354Z"
					fill="black"
				/>
				<rect
					x="255.398"
					y="249.365"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M258.437 256.22C258.863 255.851 259.199 255.549 259.443 255.314C259.692 255.074 259.898 254.825 260.062 254.568C260.227 254.31 260.309 254.053 260.309 253.795C260.309 253.528 260.245 253.32 260.116 253.169C259.991 253.018 259.794 252.942 259.523 252.942C259.261 252.942 259.056 253.026 258.91 253.195C258.768 253.36 258.692 253.582 258.683 253.862H257.95C257.964 253.355 258.115 252.969 258.403 252.702C258.697 252.431 259.067 252.296 259.516 252.296C260 252.296 260.378 252.429 260.649 252.696C260.924 252.962 261.062 253.317 261.062 253.762C261.062 254.081 260.98 254.39 260.815 254.688C260.655 254.981 260.462 255.245 260.236 255.481C260.014 255.712 259.729 255.98 259.383 256.287L259.083 256.553H261.195V257.186H257.957V256.633L258.437 256.22ZM263.008 255.934C263.053 256.156 263.148 256.325 263.295 256.44C263.442 256.556 263.639 256.613 263.888 256.613C264.203 256.613 264.434 256.489 264.581 256.24C264.727 255.991 264.801 255.567 264.801 254.968C264.694 255.119 264.543 255.236 264.348 255.321C264.157 255.401 263.948 255.441 263.721 255.441C263.433 255.441 263.171 255.383 262.935 255.267C262.7 255.147 262.513 254.972 262.375 254.741C262.242 254.506 262.176 254.221 262.176 253.888C262.176 253.4 262.318 253.011 262.602 252.722C262.891 252.429 263.286 252.282 263.788 252.282C264.392 252.282 264.821 252.485 265.074 252.889C265.332 253.289 265.46 253.904 265.46 254.734C265.46 255.307 265.412 255.776 265.314 256.14C265.221 256.504 265.056 256.78 264.821 256.966C264.585 257.153 264.259 257.246 263.841 257.246C263.366 257.246 263 257.122 262.742 256.873C262.484 256.624 262.34 256.311 262.309 255.934H263.008ZM263.855 254.801C264.121 254.801 264.33 254.719 264.481 254.554C264.636 254.386 264.714 254.164 264.714 253.888C264.714 253.582 264.632 253.344 264.468 253.175C264.308 253.002 264.088 252.915 263.808 252.915C263.528 252.915 263.306 253.004 263.142 253.182C262.982 253.355 262.902 253.584 262.902 253.868C262.902 254.139 262.98 254.363 263.135 254.541C263.295 254.714 263.535 254.801 263.855 254.801Z"
					fill="black"
				/>
				<rect
					x="281.609"
					y="249.365"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M284.222 253.595C284.249 253.182 284.407 252.86 284.695 252.629C284.989 252.398 285.362 252.282 285.815 252.282C286.126 252.282 286.394 252.338 286.621 252.449C286.848 252.56 287.019 252.711 287.134 252.902C287.25 253.093 287.307 253.308 287.307 253.548C287.307 253.824 287.234 254.059 287.087 254.255C286.941 254.45 286.765 254.581 286.561 254.648V254.674C286.823 254.754 287.027 254.901 287.174 255.114C287.321 255.323 287.394 255.592 287.394 255.92C287.394 256.182 287.334 256.416 287.214 256.62C287.094 256.824 286.916 256.986 286.681 257.106C286.446 257.222 286.164 257.28 285.835 257.28C285.355 257.28 284.96 257.157 284.649 256.913C284.342 256.664 284.178 256.309 284.156 255.847H284.889C284.906 256.082 284.998 256.276 285.162 256.427C285.326 256.573 285.548 256.647 285.828 256.647C286.099 256.647 286.308 256.573 286.454 256.427C286.601 256.276 286.674 256.082 286.674 255.847C286.674 255.536 286.574 255.316 286.375 255.187C286.179 255.054 285.877 254.988 285.468 254.988H285.295V254.361H285.475C285.835 254.357 286.108 254.297 286.295 254.181C286.486 254.066 286.581 253.884 286.581 253.635C286.581 253.422 286.512 253.253 286.375 253.129C286.237 253 286.041 252.935 285.788 252.935C285.539 252.935 285.346 253 285.208 253.129C285.071 253.253 284.989 253.408 284.962 253.595H284.222ZM288.392 254.761C288.392 253.993 288.521 253.393 288.778 252.962C289.04 252.527 289.489 252.309 290.124 252.309C290.759 252.309 291.206 252.527 291.463 252.962C291.725 253.393 291.856 253.993 291.856 254.761C291.856 255.538 291.725 256.147 291.463 256.587C291.206 257.022 290.759 257.24 290.124 257.24C289.489 257.24 289.04 257.022 288.778 256.587C288.521 256.147 288.392 255.538 288.392 254.761ZM291.11 254.761C291.11 254.401 291.086 254.097 291.037 253.848C290.992 253.599 290.899 253.397 290.757 253.242C290.615 253.082 290.404 253.002 290.124 253.002C289.844 253.002 289.633 253.082 289.491 253.242C289.349 253.397 289.253 253.599 289.205 253.848C289.16 254.097 289.138 254.401 289.138 254.761C289.138 255.134 289.16 255.447 289.205 255.7C289.249 255.954 289.342 256.158 289.484 256.313C289.631 256.469 289.844 256.547 290.124 256.547C290.404 256.547 290.615 256.469 290.757 256.313C290.904 256.158 290.999 255.954 291.044 255.7C291.088 255.447 291.11 255.134 291.11 254.761Z"
					fill="black"
				/>
				<rect
					x="307.812"
					y="249.365"
					width="11.9932"
					height="11.9932"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M310.41 253.595C310.437 253.182 310.594 252.86 310.883 252.629C311.176 252.398 311.549 252.282 312.002 252.282C312.313 252.282 312.582 252.338 312.809 252.449C313.035 252.56 313.206 252.711 313.322 252.902C313.437 253.093 313.495 253.308 313.495 253.548C313.495 253.824 313.422 254.059 313.275 254.255C313.128 254.45 312.953 254.581 312.749 254.648V254.674C313.011 254.754 313.215 254.901 313.362 255.114C313.508 255.323 313.581 255.592 313.581 255.92C313.581 256.182 313.521 256.416 313.402 256.62C313.282 256.824 313.104 256.986 312.868 257.106C312.633 257.222 312.351 257.28 312.022 257.28C311.543 257.28 311.147 257.157 310.836 256.913C310.53 256.664 310.365 256.309 310.343 255.847H311.076C311.094 256.082 311.185 256.276 311.349 256.427C311.514 256.573 311.736 256.647 312.016 256.647C312.287 256.647 312.495 256.573 312.642 256.427C312.789 256.276 312.862 256.082 312.862 255.847C312.862 255.536 312.762 255.316 312.562 255.187C312.367 255.054 312.065 254.988 311.656 254.988H311.483V254.361H311.663C312.022 254.357 312.295 254.297 312.482 254.181C312.673 254.066 312.769 253.884 312.769 253.635C312.769 253.422 312.7 253.253 312.562 253.129C312.424 253 312.229 252.935 311.976 252.935C311.727 252.935 311.534 253 311.396 253.129C311.258 253.253 311.176 253.408 311.149 253.595H310.41ZM314.479 253.089V252.396H315.865V257.253H315.099V253.089H314.479Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M336.534 253.089V252.396H337.92V257.253H337.154V253.089H336.534Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M363.265 256.22C363.691 255.851 364.027 255.549 364.271 255.314C364.52 255.074 364.726 254.825 364.891 254.568C365.055 254.31 365.137 254.053 365.137 253.795C365.137 253.528 365.073 253.32 364.944 253.169C364.82 253.018 364.622 252.942 364.351 252.942C364.089 252.942 363.884 253.026 363.738 253.195C363.596 253.36 363.52 253.582 363.511 253.862H362.778C362.792 253.355 362.943 252.969 363.232 252.702C363.525 252.431 363.896 252.296 364.344 252.296C364.828 252.296 365.206 252.429 365.477 252.696C365.752 252.962 365.89 253.317 365.89 253.762C365.89 254.081 365.808 254.39 365.644 254.688C365.484 254.981 365.29 255.245 365.064 255.481C364.842 255.712 364.557 255.98 364.211 256.287L363.911 256.553H366.023V257.186H362.785V256.633L363.265 256.22Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M389.051 253.595C389.077 253.182 389.235 252.86 389.524 252.629C389.817 252.398 390.19 252.282 390.643 252.282C390.954 252.282 391.223 252.338 391.449 252.449C391.676 252.56 391.847 252.711 391.962 252.902C392.078 253.093 392.135 253.308 392.135 253.548C392.135 253.824 392.062 254.059 391.916 254.255C391.769 254.45 391.594 254.581 391.389 254.648V254.674C391.651 254.754 391.856 254.901 392.002 255.114C392.149 255.323 392.222 255.592 392.222 255.92C392.222 256.182 392.162 256.416 392.042 256.62C391.922 256.824 391.745 256.986 391.509 257.106C391.274 257.222 390.992 257.28 390.663 257.28C390.183 257.28 389.788 257.157 389.477 256.913C389.17 256.664 389.006 256.309 388.984 255.847H389.717C389.735 256.082 389.826 256.276 389.99 256.427C390.154 256.573 390.376 256.647 390.656 256.647C390.927 256.647 391.136 256.573 391.283 256.427C391.429 256.276 391.502 256.082 391.502 255.847C391.502 255.536 391.403 255.316 391.203 255.187C391.007 255.054 390.705 254.988 390.296 254.988H390.123V254.361H390.303C390.663 254.357 390.936 254.297 391.123 254.181C391.314 254.066 391.409 253.884 391.409 253.635C391.409 253.422 391.34 253.253 391.203 253.129C391.065 253 390.869 252.935 390.616 252.935C390.368 252.935 390.174 253 390.037 253.129C389.899 253.253 389.817 253.408 389.79 253.595H389.051Z"
					fill="black"
				/>
				<rect
					x="390.786"
					y="157.713"
					width="7.12379"
					height="6.0924"
					transform="rotate(-180 390.786 157.713)"
					stroke="#7351FD"
					stroke-opacity="0.2"
					stroke-width="0.444194"
				/>
				<path
					d="M388.164 153.033L386.272 154.668L388.164 156.302"
					stroke="black"
					stroke-width="0.444194"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<rect
					x="395.769"
					y="151.496"
					width="7.12379"
					height="6.0924"
					stroke="#7351FD"
					stroke-opacity="0.2"
					stroke-width="0.444194"
				/>
				<path
					d="M398.391 156.176L400.283 154.541L398.391 152.907"
					stroke="black"
					stroke-width="0.444194"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
		</g>
		<rect
			x="42.2955"
			y="43.2955"
			width="390.714"
			height="320.409"
			rx="7.10507"
			stroke="#D7CFFF"
			stroke-width="0.591006"
		/>
		<defs>
			<filter
				id="filter0_d_4301_3131"
				x="200.757"
				y="113.154"
				width="245.817"
				height="199.174"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx="-2.83851" dy="6.38664" />
				<feGaussianBlur stdDeviation="17.8116" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_4301_3131"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_4301_3131"
					result="shape"
				/>
			</filter>
			<clipPath id="clip0_4301_3131">
				<rect
					x="42"
					y="43"
					width="391.305"
					height="321"
					rx="7.40058"
					fill="white"
				/>
			</clipPath>
			<clipPath id="clip1_4301_3131">
				<rect
					width="68.5675"
					height="68.5675"
					fill="white"
					transform="translate(133.805 142.312)"
				/>
			</clipPath>
		</defs>
	</svg>
);

const ImageThree = (
	<svg
		className="w-full h-auto"
		width="476"
		height="406"
		viewBox="0 0 476 406"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="476" height="406" rx="12" fill="#F4F2FF" />
		<g clip-path="url(#clip0_4301_3187)">
			<rect
				x="53"
				y="51"
				width="369.455"
				height="303.076"
				rx="6.98734"
				fill="white"
			/>
			<mask id="path-4-inside-1_4301_3187" fill="white">
				<path d="M53 55.464C53 52.9986 54.9986 51 57.464 51H461.46C463.925 51 465.924 52.9986 465.924 55.464V74.9942H53V55.464Z" />
			</mask>
			<path
				d="M53 55.464C53 52.9986 54.9986 51 57.464 51H461.46C463.925 51 465.924 52.9986 465.924 55.464V74.9942H53V55.464Z"
				fill="white"
			/>
			<path
				d="M53 51H465.924H53ZM465.924 75.7584H53V74.23H465.924V75.7584ZM53 74.9942V51V74.9942ZM465.924 51V74.9942V51Z"
				fill="#D8D2FB"
				mask="url(#path-4-inside-1_4301_3187)"
			/>
			<circle cx="68.9071" cy="62.9969" r="4.74304" fill="#FF4C4C" />
			<circle cx="84.2587" cy="62.9969" r="4.74304" fill="#FFAB42" />
			<circle cx="99.6259" cy="62.9969" r="4.74304" fill="#00A900" />
			<rect
				x="73.625"
				y="83.8594"
				width="330.127"
				height="68.0123"
				rx="4.5851"
				fill="#E5DFFC"
			/>
			<rect
				x="73.625"
				y="83.8594"
				width="330.127"
				height="68.0123"
				rx="4.5851"
				fill="#C7ADFD"
			/>
			<rect
				x="130.945"
				y="106.785"
				width="215.5"
				height="11.4628"
				rx="5.73138"
				fill="white"
			/>
			<rect
				x="130.945"
				y="123.598"
				width="215.5"
				height="6.11347"
				rx="3.05673"
				fill="white"
			/>
			<rect
				x="73.625"
				y="159.514"
				width="219.321"
				height="51.9645"
				rx="5.34928"
				fill="#E4D8FB"
			/>
			<rect
				x="80.9489"
				y="164.532"
				width="41.1635"
				height="41.1635"
				rx="3.0331"
				fill="white"
			/>
			<rect
				x="80.9489"
				y="164.532"
				width="41.1635"
				height="41.1635"
				rx="3.0331"
				stroke="#9165EA"
				stroke-width="0.8666"
			/>
			<path
				d="M108.569 171.897H94.0544C92.5306 171.897 91.0693 172.503 89.9918 173.58C88.9143 174.657 88.309 176.118 88.309 177.641V192.152C88.3033 192.171 88.3033 192.192 88.309 192.212C88.3249 193.725 88.9373 195.17 90.013 196.235C91.0888 197.299 92.5411 197.896 94.0544 197.895H108.569C110.076 197.892 111.522 197.298 112.595 196.239C113.667 195.18 114.28 193.743 114.303 192.236V177.641C114.303 176.12 113.699 174.661 112.624 173.584C111.549 172.507 110.091 171.901 108.569 171.897ZM112.5 189.733L107.444 183.953C107.123 183.611 106.735 183.339 106.305 183.153C105.874 182.966 105.41 182.87 104.941 182.87C104.471 182.87 104.007 182.966 103.577 183.153C103.146 183.339 102.758 183.611 102.437 183.953L98.9653 187.919L97.8283 186.541C97.515 186.165 97.1229 185.863 96.6798 185.656C96.2366 185.448 95.7533 185.341 95.264 185.341C94.7747 185.341 94.2914 185.448 93.8483 185.656C93.4051 185.863 93.013 186.165 92.6997 186.541L90.1233 189.649V177.641C90.1265 176.6 90.5417 175.602 91.2782 174.866C92.0148 174.13 93.0128 173.714 94.0544 173.711H108.569C109.611 173.714 110.609 174.13 111.345 174.866C112.082 175.602 112.497 176.6 112.5 177.641V189.733Z"
				fill="#7B4DD9"
			/>
			<path
				d="M95.3749 181.418C96.7296 181.418 97.8279 180.319 97.8279 178.965C97.8279 177.61 96.7296 176.512 95.3749 176.512C94.0201 176.512 92.9219 177.61 92.9219 178.965C92.9219 180.319 94.0201 181.418 95.3749 181.418Z"
				fill="#7B4DD9"
			/>
			<rect
				x="127.898"
				y="170.594"
				width="58.0779"
				height="6.87765"
				rx="3.43882"
				fill="white"
			/>
			<rect
				x="127.898"
				y="185.877"
				width="123.034"
				height="4.5851"
				rx="2.29255"
				fill="white"
			/>
			<rect
				x="127.898"
				y="195.047"
				width="96.2871"
				height="4.5851"
				rx="2.29255"
				fill="white"
			/>
			<rect
				x="73.625"
				y="222.177"
				width="219.321"
				height="51.9645"
				rx="5.34928"
				fill="#E4D8FB"
			/>
			<rect
				x="80.9489"
				y="227.195"
				width="41.1635"
				height="41.1635"
				rx="3.0331"
				fill="white"
			/>
			<rect
				x="80.9489"
				y="227.195"
				width="41.1635"
				height="41.1635"
				rx="3.0331"
				stroke="#9165EA"
				stroke-width="0.8666"
			/>
			<path
				d="M108.569 234.561H94.0544C92.5306 234.561 91.0693 235.166 89.9918 236.243C88.9143 237.32 88.309 238.781 88.309 240.304V254.815C88.3033 254.835 88.3033 254.856 88.309 254.875C88.3249 256.388 88.9373 257.834 90.013 258.898C91.0888 259.962 92.5411 260.559 94.0544 260.559H108.569C110.076 260.556 111.522 259.961 112.595 258.902C113.667 257.843 114.28 256.406 114.303 254.899V240.304C114.303 238.783 113.699 237.324 112.624 236.247C111.549 235.17 110.091 234.564 108.569 234.561ZM112.5 252.396L107.444 246.616C107.123 246.274 106.735 246.002 106.305 245.816C105.874 245.629 105.41 245.533 104.941 245.533C104.471 245.533 104.007 245.629 103.577 245.816C103.146 246.002 102.758 246.274 102.437 246.616L98.9653 250.583L97.8283 249.204C97.515 248.828 97.1229 248.526 96.6798 248.319C96.2366 248.111 95.7533 248.004 95.264 248.004C94.7747 248.004 94.2914 248.111 93.8483 248.319C93.4051 248.526 93.013 248.828 92.6997 249.204L90.1233 252.312V240.304C90.1265 239.263 90.5417 238.265 91.2782 237.529C92.0148 236.793 93.0128 236.378 94.0544 236.374H108.569C109.611 236.378 110.609 236.793 111.345 237.529C112.082 238.265 112.497 239.263 112.5 240.304V252.396Z"
				fill="#7B4DD9"
			/>
			<path
				d="M95.3749 244.08C96.7296 244.08 97.8279 242.982 97.8279 241.627C97.8279 240.272 96.7296 239.174 95.3749 239.174C94.0201 239.174 92.9219 240.272 92.9219 241.627C92.9219 242.982 94.0201 244.08 95.3749 244.08Z"
				fill="#7B4DD9"
			/>
			<rect
				x="127.898"
				y="233.257"
				width="58.0779"
				height="6.87765"
				rx="3.43882"
				fill="white"
			/>
			<rect
				x="127.898"
				y="248.54"
				width="123.034"
				height="4.5851"
				rx="2.29255"
				fill="white"
			/>
			<rect
				x="127.898"
				y="257.71"
				width="96.2871"
				height="4.5851"
				rx="2.29255"
				fill="white"
			/>
			<rect
				x="73.625"
				y="284.84"
				width="219.321"
				height="51.9645"
				rx="5.34928"
				fill="#E4D8FB"
			/>
			<rect
				x="80.9489"
				y="289.858"
				width="41.1635"
				height="41.1635"
				rx="3.0331"
				fill="white"
			/>
			<rect
				x="80.9489"
				y="289.858"
				width="41.1635"
				height="41.1635"
				rx="3.0331"
				stroke="#9165EA"
				stroke-width="0.8666"
			/>
			<path
				d="M108.569 297.225H94.0544C92.5306 297.225 91.0693 297.83 89.9918 298.907C88.9143 299.984 88.309 301.445 88.309 302.968V317.479C88.3033 317.499 88.3033 317.52 88.309 317.539C88.3249 319.052 88.9373 320.498 90.013 321.562C91.0888 322.626 92.5411 323.223 94.0544 323.223H108.569C110.076 323.22 111.522 322.625 112.595 321.566C113.667 320.508 114.28 319.07 114.303 317.564V302.968C114.303 301.447 113.699 299.988 112.624 298.911C111.549 297.834 110.091 297.228 108.569 297.225ZM112.5 315.06L107.444 309.28C107.123 308.939 106.735 308.666 106.305 308.48C105.874 308.294 105.41 308.197 104.941 308.197C104.471 308.197 104.007 308.294 103.577 308.48C103.146 308.666 102.758 308.939 102.437 309.28L98.9653 313.247L97.8283 311.868C97.515 311.492 97.1229 311.19 96.6798 310.983C96.2366 310.775 95.7533 310.668 95.264 310.668C94.7747 310.668 94.2914 310.775 93.8483 310.983C93.4051 311.19 93.013 311.492 92.6997 311.868L90.1233 314.976V302.968C90.1265 301.927 90.5417 300.929 91.2782 300.193C92.0148 299.457 93.0128 299.042 94.0544 299.038H108.569C109.611 299.042 110.609 299.457 111.345 300.193C112.082 300.929 112.497 301.927 112.5 302.968V315.06Z"
				fill="#7B4DD9"
			/>
			<path
				d="M95.3749 306.744C96.7296 306.744 97.8279 305.646 97.8279 304.291C97.8279 302.936 96.7296 301.838 95.3749 301.838C94.0201 301.838 92.9219 302.936 92.9219 304.291C92.9219 305.646 94.0201 306.744 95.3749 306.744Z"
				fill="#7B4DD9"
			/>
			<rect
				x="127.898"
				y="295.92"
				width="58.0779"
				height="6.87765"
				rx="3.43882"
				fill="white"
			/>
			<rect
				x="127.898"
				y="311.203"
				width="123.034"
				height="4.5851"
				rx="2.29255"
				fill="white"
			/>
			<rect
				x="127.898"
				y="320.373"
				width="96.2871"
				height="4.5851"
				rx="2.29255"
				fill="white"
			/>
			<rect
				x="310"
				y="285"
				width="94"
				height="52"
				rx="2.92099"
				fill="#FFE2C5"
			/>
			<rect
				x="332.5"
				y="315.5"
				width="50"
				height="13"
				rx="6.5"
				fill="white"
				stroke="#EFD6BE"
			/>
			<rect x="325" y="293" width="67" height="6" rx="3" fill="white" />
			<rect x="333" y="301" width="49" height="4" rx="2" fill="white" />
			<rect x="339" y="319" width="37" height="5" rx="2.5" fill="#FFE2C5" />
			<rect
				x="309.773"
				y="159.514"
				width="93.9946"
				height="103.165"
				rx="2.92099"
				fill="#FEC5FF"
			/>
			<rect
				x="320.461"
				y="177.854"
				width="58.0779"
				height="6.87765"
				rx="3.43882"
				fill="white"
			/>
			<rect
				x="320.461"
				y="193.137"
				width="35.1524"
				height="4.5851"
				rx="2.29255"
				fill="white"
			/>
			<rect
				x="320.461"
				y="202.307"
				width="58.0779"
				height="4.5851"
				rx="2.29255"
				fill="white"
			/>
			<rect
				x="320.461"
				y="212.242"
				width="48.9077"
				height="4.5851"
				rx="2.29255"
				fill="white"
			/>
			<rect
				x="320.461"
				y="221.412"
				width="58.0779"
				height="4.5851"
				rx="2.29255"
				fill="white"
			/>
			<rect
				x="320.461"
				y="231.347"
				width="55.0212"
				height="4.5851"
				rx="2.29255"
				fill="white"
			/>
			<rect
				x="320.461"
				y="240.517"
				width="58.0779"
				height="4.5851"
				rx="2.29255"
				fill="white"
			/>
		</g>
		<rect
			x="53.279"
			y="51.279"
			width="368.897"
			height="302.518"
			rx="6.70833"
			stroke="#D7CFFF"
			stroke-width="0.558005"
		/>
		<defs>
			<clipPath id="clip0_4301_3187">
				<rect
					x="53"
					y="51"
					width="369.455"
					height="303.076"
					rx="6.98734"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
);

const ImageFour = (
	<svg
		className="w-full h-auto"
		width="476"
		height="406"
		viewBox="0 0 476 406"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_4301_3260)">
			<rect width="476" height="406" rx="12" fill="#F4F2FF" />
			<rect
				x="102.259"
				y="63.2587"
				width="342.027"
				height="280.483"
				rx="6.21971"
				fill="white"
			/>
			<rect
				x="102.259"
				y="63.2587"
				width="342.027"
				height="280.483"
				rx="6.21971"
				stroke="#D7CFFF"
				stroke-width="0.517361"
			/>
			<circle cx="116.757" cy="74.1241" r="4.39757" fill="#FF4C4C" />
			<circle cx="130.991" cy="74.1241" r="4.39757" fill="#FFAB42" />
			<circle cx="145.226" cy="74.1241" r="4.39757" fill="#00A900" />
			<rect
				width="342.545"
				height="70.5705"
				transform="translate(102 84.8643)"
				fill="#E5DFFC"
			/>
			<rect
				width="342.545"
				height="70.5705"
				transform="translate(102 84.8643)"
				fill="#C7ADFD"
			/>
			<rect
				x="161.469"
				y="108.652"
				width="223.606"
				height="11.8939"
				rx="5.94696"
				fill="white"
			/>
			<rect
				x="161.469"
				y="126.097"
				width="223.606"
				height="6.34342"
				rx="3.17171"
				fill="white"
			/>
			<mask id="path-8-inside-1_4301_3260" fill="white">
				<path d="M102.805 155.317H178.116V344H102.805V155.317Z" />
			</mask>
			<path d="M102.805 155.317H178.116V344H102.805V155.317Z" fill="white" />
			<path
				d="M178.116 155.317H177.587V344H178.116H178.645V155.317H178.116Z"
				fill="#C7ADFD"
				fill-opacity="0.2"
				mask="url(#path-8-inside-1_4301_3260)"
			/>
			<rect
				x="109.297"
				y="165.845"
				width="62.9443"
				height="6.34732"
				rx="3.17366"
				fill="#D9D0FF"
			/>
			<rect
				x="109.297"
				y="177.481"
				width="53.9522"
				height="6.34732"
				rx="3.17366"
				fill="#D9D0FF"
			/>
			<rect
				x="109.297"
				y="189.118"
				width="28.034"
				height="6.34732"
				rx="3.17366"
				fill="#D9D0FF"
			/>
			<rect
				x="109.297"
				y="201.134"
				width="62.9443"
				height="6.34732"
				rx="3.17366"
				fill="#D9D0FF"
			/>
			<rect
				x="109.297"
				y="212.771"
				width="46.547"
				height="6.34732"
				rx="3.17366"
				fill="#D9D0FF"
			/>
			<rect
				x="109.297"
				y="224.407"
				width="59.2417"
				height="6.34732"
				rx="3.17366"
				fill="#D9D0FF"
			/>
			<rect
				x="109.297"
				y="237.233"
				width="62.9443"
				height="6.34732"
				rx="3.17366"
				fill="#D9D0FF"
			/>
			<rect
				x="109.297"
				y="248.87"
				width="46.547"
				height="6.34732"
				rx="3.17366"
				fill="#D9D0FF"
			/>
			<rect
				x="109.297"
				y="260.507"
				width="59.2417"
				height="6.34732"
				rx="3.17366"
				fill="#D9D0FF"
			/>
			<rect
				x="199.984"
				y="162.605"
				width="69.4507"
				height="81.7896"
				rx="5.28812"
				fill="white"
			/>
			<rect
				x="200.513"
				y="163.134"
				width="68.3931"
				height="80.732"
				rx="4.75931"
				stroke="#7351FD"
				stroke-opacity="0.2"
				stroke-width="1.05762"
			/>
			<rect
				x="214.008"
				y="171.476"
				width="41.4831"
				height="37.4358"
				rx="2.98073"
				fill="white"
			/>
			<rect
				x="214.008"
				y="171.476"
				width="41.4831"
				height="37.4358"
				rx="2.98073"
				stroke="#C5B8FB"
				stroke-width="0.516923"
			/>
			<path
				d="M241.304 178.062H227.847C226.434 178.062 225.079 178.624 224.08 179.622C223.081 180.621 222.52 181.975 222.52 183.388V196.841C222.514 196.86 222.514 196.879 222.52 196.898C222.534 198.3 223.102 199.64 224.1 200.627C225.097 201.614 226.443 202.167 227.847 202.167H241.304C242.702 202.164 244.042 201.612 245.036 200.631C246.031 199.65 246.599 198.317 246.62 196.92V183.388C246.62 181.977 246.06 180.625 245.064 179.626C244.067 178.628 242.715 178.065 241.304 178.062ZM244.949 194.599L240.261 189.24C239.963 188.923 239.604 188.671 239.204 188.498C238.805 188.325 238.375 188.236 237.94 188.236C237.505 188.236 237.074 188.325 236.675 188.498C236.276 188.671 235.916 188.923 235.618 189.24L232.4 192.917L231.346 191.639C231.055 191.291 230.692 191.011 230.281 190.818C229.87 190.626 229.422 190.526 228.968 190.526C228.514 190.526 228.066 190.626 227.655 190.818C227.245 191.011 226.881 191.291 226.591 191.639L224.202 194.521V183.388C224.205 182.422 224.59 181.497 225.273 180.815C225.955 180.132 226.881 179.747 227.847 179.744H241.304C242.27 179.747 243.195 180.132 243.878 180.815C244.561 181.497 244.946 182.422 244.949 183.388V194.599Z"
				fill="#F377F5"
			/>
			<path
				d="M234.71 183.099C234.909 183.099 235.069 182.938 235.069 182.74C235.069 182.542 234.909 182.381 234.71 182.381C234.512 182.381 234.352 182.542 234.352 182.74C234.352 182.938 234.512 183.099 234.71 183.099Z"
				fill="#7351FD"
			/>
			<rect
				x="214.453"
				y="217.114"
				width="41.2997"
				height="2.46779"
				rx="1.2339"
				fill="#C5B8FB"
			/>
			<rect
				x="214.453"
				y="224.165"
				width="29.6135"
				height="2.46779"
				rx="1.2339"
				fill="#C5B8FB"
			/>
			<rect
				x="213.35"
				y="232.654"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				fill="white"
			/>
			<rect
				x="213.35"
				y="232.654"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				stroke="#CEBCF3"
				stroke-width="0.809798"
			/>
			<rect
				x="237.639"
				y="232.654"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				fill="#CEBCF3"
			/>
			<rect
				x="237.639"
				y="232.654"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				stroke="#CEBCF3"
				stroke-width="0.809798"
			/>
			<rect
				x="278.344"
				y="162.605"
				width="69.4507"
				height="81.7896"
				rx="5.28812"
				fill="white"
			/>
			<rect
				x="278.873"
				y="163.134"
				width="68.3931"
				height="80.732"
				rx="4.75931"
				stroke="#7351FD"
				stroke-opacity="0.2"
				stroke-width="1.05762"
			/>
			<rect
				x="292.36"
				y="171.476"
				width="41.4831"
				height="37.4358"
				rx="2.98073"
				fill="white"
			/>
			<rect
				x="292.36"
				y="171.476"
				width="41.4831"
				height="37.4358"
				rx="2.98073"
				stroke="#C5B8FB"
				stroke-width="0.516923"
			/>
			<path
				d="M319.656 178.062H306.198C304.785 178.062 303.43 178.624 302.431 179.622C301.432 180.621 300.871 181.975 300.871 183.388V196.841C300.866 196.86 300.866 196.879 300.871 196.898C300.886 198.3 301.454 199.64 302.451 200.627C303.448 201.614 304.795 202.167 306.198 202.167H319.656C321.053 202.164 322.393 201.612 323.388 200.631C324.382 199.65 324.951 198.317 324.972 196.92V183.388C324.972 181.977 324.412 180.625 323.415 179.626C322.419 178.628 321.067 178.065 319.656 178.062ZM323.301 194.599L318.613 189.24C318.315 188.923 317.955 188.671 317.556 188.498C317.157 188.325 316.726 188.236 316.291 188.236C315.856 188.236 315.426 188.325 315.027 188.498C314.627 188.671 314.268 188.923 313.97 189.24L310.751 192.917L309.697 191.639C309.407 191.291 309.043 191.011 308.632 190.818C308.221 190.626 307.773 190.526 307.32 190.526C306.866 190.526 306.418 190.626 306.007 190.818C305.596 191.011 305.233 191.291 304.942 191.639L302.553 194.521V183.388C302.556 182.422 302.941 181.497 303.624 180.815C304.307 180.132 305.232 179.747 306.198 179.744H319.656C320.622 179.747 321.547 180.132 322.23 180.815C322.913 181.497 323.298 182.422 323.301 183.388V194.599Z"
				fill="#7B4DD9"
			/>
			<path
				d="M313.062 183.099C313.26 183.099 313.421 182.938 313.421 182.74C313.421 182.542 313.26 182.381 313.062 182.381C312.864 182.381 312.703 182.542 312.703 182.74C312.703 182.938 312.864 183.099 313.062 183.099Z"
				fill="#7351FD"
			/>
			<rect
				x="292.805"
				y="217.114"
				width="41.2997"
				height="2.46779"
				rx="1.2339"
				fill="#C5B8FB"
			/>
			<rect
				x="292.805"
				y="224.165"
				width="29.6135"
				height="2.46779"
				rx="1.2339"
				fill="#C5B8FB"
			/>
			<rect
				x="291.702"
				y="232.654"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				fill="white"
			/>
			<rect
				x="291.702"
				y="232.654"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				stroke="#CEBCF3"
				stroke-width="0.809798"
			/>
			<rect
				x="315.999"
				y="232.654"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				fill="#CEBCF3"
			/>
			<rect
				x="315.999"
				y="232.654"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				stroke="#CEBCF3"
				stroke-width="0.809798"
			/>
			<rect
				x="356.703"
				y="162.605"
				width="69.4507"
				height="81.7896"
				rx="5.28812"
				fill="white"
			/>
			<rect
				x="357.232"
				y="163.134"
				width="68.3931"
				height="80.732"
				rx="4.75931"
				stroke="#7351FD"
				stroke-opacity="0.2"
				stroke-width="1.05762"
			/>
			<rect
				x="370.719"
				y="171.476"
				width="41.4831"
				height="37.4358"
				rx="2.98073"
				fill="white"
			/>
			<rect
				x="370.719"
				y="171.476"
				width="41.4831"
				height="37.4358"
				rx="2.98073"
				stroke="#C5B8FB"
				stroke-width="0.516923"
			/>
			<path
				d="M398.171 177.992H384.714C383.301 177.992 381.946 178.553 380.947 179.552C379.948 180.551 379.387 181.905 379.387 183.318V196.771C379.381 196.789 379.381 196.809 379.387 196.827C379.402 198.23 379.969 199.57 380.967 200.557C381.964 201.543 383.311 202.097 384.714 202.097H398.171C399.569 202.094 400.909 201.542 401.903 200.561C402.898 199.579 403.467 198.246 403.487 196.85V183.318C403.487 181.907 402.927 180.554 401.931 179.556C400.934 178.558 399.582 177.995 398.171 177.992ZM401.816 194.529L397.128 189.17C396.831 188.853 396.471 188.6 396.072 188.428C395.672 188.255 395.242 188.166 394.807 188.166C394.372 188.166 393.942 188.255 393.542 188.428C393.143 188.6 392.783 188.853 392.486 189.17L389.267 192.847L388.213 191.569C387.922 191.221 387.559 190.94 387.148 190.748C386.737 190.556 386.289 190.456 385.835 190.456C385.382 190.456 384.933 190.556 384.523 190.748C384.112 190.94 383.748 191.221 383.458 191.569L381.069 194.45V183.318C381.072 182.352 381.457 181.427 382.14 180.744C382.823 180.062 383.748 179.677 384.714 179.674H398.171C399.137 179.677 400.062 180.062 400.745 180.744C401.428 181.427 401.813 182.352 401.816 183.318V194.529Z"
				fill="#FFBE7D"
			/>
			<rect
				x="371.164"
				y="217.114"
				width="41.2997"
				height="2.46779"
				rx="1.2339"
				fill="#C5B8FB"
			/>
			<rect
				x="371.164"
				y="224.165"
				width="29.6135"
				height="2.46779"
				rx="1.2339"
				fill="#C5B8FB"
			/>
			<rect
				x="370.061"
				y="232.654"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				fill="white"
			/>
			<rect
				x="370.061"
				y="232.654"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				stroke="#CEBCF3"
				stroke-width="0.809798"
			/>
			<rect
				x="394.358"
				y="232.654"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				fill="#CEBCF3"
			/>
			<rect
				x="394.358"
				y="232.654"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				stroke="#CEBCF3"
				stroke-width="0.809798"
			/>
			<rect
				x="199.984"
				y="252.396"
				width="69.4507"
				height="81.7896"
				rx="5.28812"
				fill="white"
			/>
			<rect
				x="200.513"
				y="252.924"
				width="68.3931"
				height="80.732"
				rx="4.75931"
				stroke="#7351FD"
				stroke-opacity="0.2"
				stroke-width="1.05762"
			/>
			<rect
				x="214.008"
				y="261.265"
				width="41.4831"
				height="37.4358"
				rx="2.98073"
				fill="white"
			/>
			<rect
				x="214.008"
				y="261.265"
				width="41.4831"
				height="37.4358"
				rx="2.98073"
				stroke="#C5B8FB"
				stroke-width="0.516923"
			/>
			<path
				d="M241.304 267.852H227.847C226.434 267.852 225.079 268.413 224.08 269.411C223.081 270.41 222.52 271.765 222.52 273.177V286.631C222.514 286.649 222.514 286.668 222.52 286.687C222.534 288.089 223.102 289.429 224.1 290.416C225.097 291.403 226.443 291.956 227.847 291.956H241.304C242.702 291.953 244.042 291.402 245.036 290.42C246.031 289.439 246.599 288.106 246.62 286.709V273.177C246.62 271.767 246.06 270.414 245.064 269.415C244.067 268.417 242.715 267.855 241.304 267.852ZM244.949 284.388L240.261 279.029C239.963 278.712 239.604 278.46 239.204 278.287C238.805 278.114 238.375 278.025 237.94 278.025C237.505 278.025 237.074 278.114 236.675 278.287C236.276 278.46 235.916 278.712 235.618 279.029L232.4 282.707L231.346 281.428C231.055 281.08 230.692 280.8 230.281 280.608C229.87 280.415 229.422 280.315 228.968 280.315C228.514 280.315 228.066 280.415 227.655 280.608C227.245 280.8 226.881 281.08 226.591 281.428L224.202 284.31V273.177C224.205 272.211 224.59 271.286 225.273 270.604C225.955 269.921 226.881 269.536 227.847 269.533H241.304C242.27 269.536 243.195 269.921 243.878 270.604C244.561 271.286 244.946 272.211 244.949 273.177V284.388Z"
				fill="#4DCBD9"
			/>
			<path
				d="M234.71 272.888C234.909 272.888 235.069 272.727 235.069 272.529C235.069 272.331 234.909 272.17 234.71 272.17C234.512 272.17 234.352 272.331 234.352 272.529C234.352 272.727 234.512 272.888 234.71 272.888Z"
				fill="#7351FD"
			/>
			<rect
				x="214.453"
				y="306.903"
				width="41.2997"
				height="2.46779"
				rx="1.2339"
				fill="#C5B8FB"
			/>
			<rect
				x="214.453"
				y="313.954"
				width="29.6135"
				height="2.46779"
				rx="1.2339"
				fill="#C5B8FB"
			/>
			<rect
				x="213.35"
				y="322.443"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				fill="white"
			/>
			<rect
				x="213.35"
				y="322.443"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				stroke="#CEBCF3"
				stroke-width="0.809798"
			/>
			<rect
				x="237.639"
				y="322.443"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				fill="#CEBCF3"
			/>
			<rect
				x="237.639"
				y="322.443"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				stroke="#CEBCF3"
				stroke-width="0.809798"
			/>
			<rect
				x="278.344"
				y="252.396"
				width="69.4507"
				height="81.7896"
				rx="5.28812"
				fill="white"
			/>
			<rect
				x="278.873"
				y="252.924"
				width="68.3931"
				height="80.732"
				rx="4.75931"
				stroke="#7351FD"
				stroke-opacity="0.2"
				stroke-width="1.05762"
			/>
			<rect
				x="292.36"
				y="261.265"
				width="41.4831"
				height="37.4358"
				rx="2.98073"
				fill="white"
			/>
			<rect
				x="292.36"
				y="261.265"
				width="41.4831"
				height="37.4358"
				rx="2.98073"
				stroke="#C5B8FB"
				stroke-width="0.516923"
			/>
			<path
				d="M319.656 267.852H306.198C304.785 267.852 303.43 268.413 302.431 269.411C301.432 270.41 300.871 271.765 300.871 273.177V286.631C300.866 286.649 300.866 286.668 300.871 286.687C300.886 288.089 301.454 289.429 302.451 290.416C303.448 291.403 304.795 291.956 306.198 291.956H319.656C321.053 291.953 322.393 291.402 323.388 290.42C324.382 289.439 324.951 288.106 324.972 286.709V273.177C324.972 271.767 324.412 270.414 323.415 269.415C322.419 268.417 321.067 267.855 319.656 267.852ZM323.301 284.388L318.613 279.029C318.315 278.712 317.955 278.46 317.556 278.287C317.157 278.114 316.726 278.025 316.291 278.025C315.856 278.025 315.426 278.114 315.027 278.287C314.627 278.46 314.268 278.712 313.97 279.029L310.751 282.707L309.697 281.428C309.407 281.08 309.043 280.8 308.632 280.608C308.221 280.415 307.773 280.315 307.32 280.315C306.866 280.315 306.418 280.415 306.007 280.608C305.596 280.8 305.233 281.08 304.942 281.428L302.553 284.31V273.177C302.556 272.211 302.941 271.286 303.624 270.604C304.307 269.921 305.232 269.536 306.198 269.533H319.656C320.622 269.536 321.547 269.921 322.23 270.604C322.913 271.286 323.298 272.211 323.301 273.177V284.388Z"
				fill="#4DD94D"
			/>
			<path
				d="M313.062 272.888C313.26 272.888 313.421 272.727 313.421 272.529C313.421 272.331 313.26 272.17 313.062 272.17C312.864 272.17 312.703 272.331 312.703 272.529C312.703 272.727 312.864 272.888 313.062 272.888Z"
				fill="#7351FD"
			/>
			<rect
				x="294.969"
				y="306.903"
				width="39.1321"
				height="2.46779"
				rx="1.2339"
				fill="#C5B8FB"
			/>
			<rect
				x="294.969"
				y="313.954"
				width="29.6135"
				height="2.46779"
				rx="1.2339"
				fill="#C5B8FB"
			/>
			<rect
				x="291.702"
				y="322.443"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				fill="white"
			/>
			<rect
				x="291.702"
				y="322.443"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				stroke="#CEBCF3"
				stroke-width="0.809798"
			/>
			<rect
				x="315.999"
				y="322.443"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				fill="#CEBCF3"
			/>
			<rect
				x="315.999"
				y="322.443"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				stroke="#CEBCF3"
				stroke-width="0.809798"
			/>
			<rect
				x="356.703"
				y="252.396"
				width="69.4507"
				height="81.7896"
				rx="5.28812"
				fill="white"
			/>
			<rect
				x="357.232"
				y="252.924"
				width="68.3931"
				height="80.732"
				rx="4.75931"
				stroke="#7351FD"
				stroke-opacity="0.2"
				stroke-width="1.05762"
			/>
			<rect
				x="370.719"
				y="261.265"
				width="41.4831"
				height="37.4358"
				rx="2.98073"
				fill="white"
			/>
			<rect
				x="370.719"
				y="261.265"
				width="41.4831"
				height="37.4358"
				rx="2.98073"
				stroke="#C5B8FB"
				stroke-width="0.516923"
			/>
			<path
				d="M398.156 267.998H384.698C383.285 267.998 381.93 268.559 380.931 269.558C379.932 270.557 379.371 271.911 379.371 273.323V286.777C379.366 286.795 379.366 286.815 379.371 286.833C379.386 288.236 379.954 289.576 380.951 290.562C381.948 291.549 383.295 292.102 384.698 292.102H398.156C399.553 292.1 400.893 291.548 401.888 290.567C402.882 289.585 403.451 288.252 403.472 286.855V273.323C403.472 271.913 402.912 270.56 401.915 269.562C400.919 268.563 399.567 268.001 398.156 267.998ZM401.801 284.535L397.113 279.176C396.815 278.859 396.455 278.606 396.056 278.433C395.657 278.261 395.226 278.172 394.791 278.172C394.356 278.172 393.926 278.261 393.527 278.433C393.127 278.606 392.768 278.859 392.47 279.176L389.251 282.853L388.197 281.575C387.907 281.227 387.543 280.946 387.132 280.754C386.721 280.562 386.273 280.462 385.82 280.462C385.366 280.462 384.918 280.562 384.507 280.754C384.096 280.946 383.733 281.227 383.442 281.575L381.053 284.456V273.323C381.056 272.358 381.441 271.433 382.124 270.75C382.807 270.068 383.732 269.683 384.698 269.68H398.156C399.122 269.683 400.047 270.068 400.73 270.75C401.413 271.433 401.798 272.358 401.801 273.323V284.535Z"
				fill="#A14DD9"
			/>
			<rect
				x="371.164"
				y="306.903"
				width="41.2997"
				height="2.46779"
				rx="1.2339"
				fill="#C5B8FB"
			/>
			<rect
				x="371.164"
				y="313.954"
				width="29.6135"
				height="2.46779"
				rx="1.2339"
				fill="#C5B8FB"
			/>
			<rect
				x="370.061"
				y="322.443"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				fill="white"
			/>
			<rect
				x="370.061"
				y="322.443"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				stroke="#CEBCF3"
				stroke-width="0.809798"
			/>
			<rect
				x="394.358"
				y="322.443"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				fill="#CEBCF3"
			/>
			<rect
				x="394.358"
				y="322.443"
				width="17.8156"
				height="6.47839"
				rx="1.2147"
				stroke="#CEBCF3"
				stroke-width="0.809798"
			/>
			<g filter="url(#filter0_d_4301_3260)">
				<g clip-path="url(#clip1_4301_3260)">
					<rect
						x="35.5938"
						y="212.812"
						width="194.352"
						height="140.095"
						rx="8.90778"
						fill="white"
					/>
					<rect
						x="44.7193"
						y="223.559"
						width="35.1926"
						height="31.7591"
						rx="2.52873"
						fill="white"
					/>
					<rect
						x="44.7193"
						y="223.559"
						width="35.1926"
						height="31.7591"
						rx="2.52873"
						stroke="#C5B8FB"
						stroke-width="0.438537"
					/>
					<path
						d="M69.2282 227.389H56.1608C54.7889 227.389 53.4733 227.933 52.5032 228.903C51.5332 229.873 50.9882 231.188 50.9882 232.56V245.623C50.9831 245.641 50.9831 245.66 50.9882 245.678C51.0026 247.04 51.5539 248.341 52.5223 249.299C53.4908 250.257 54.7983 250.794 56.1608 250.794H69.2282C70.585 250.791 71.8865 250.256 72.852 249.303C73.8176 248.35 74.3698 247.056 74.3898 245.699V232.56C74.3898 231.19 73.8464 229.876 72.8787 228.907C71.911 227.938 70.5982 227.392 69.2282 227.389ZM72.7673 243.446L68.2155 238.242C67.9263 237.934 67.5771 237.689 67.1894 237.521C66.8017 237.354 66.3838 237.267 65.9613 237.267C65.5389 237.267 65.121 237.354 64.7333 237.521C64.3456 237.689 63.9964 237.934 63.7072 238.242L60.5819 241.813L59.5583 240.572C59.2762 240.234 58.9232 239.962 58.5243 239.775C58.1254 239.588 57.6902 239.491 57.2497 239.491C56.8092 239.491 56.3741 239.588 55.9751 239.775C55.5762 239.962 55.2232 240.234 54.9411 240.572L52.6217 243.37V232.56C52.6245 231.622 52.9983 230.724 53.6614 230.061C54.3245 229.398 55.223 229.024 56.1608 229.022H69.2282C70.1659 229.024 71.0645 229.398 71.7275 230.061C72.3906 230.724 72.7644 231.622 72.7673 232.56V243.446Z"
						fill="#7B4DD9"
					/>
					<rect
						x="84.1875"
						y="226.579"
						width="65.5937"
						height="4.7904"
						rx="2.3952"
						fill="#C5B8FB"
					/>
					<rect
						x="84.1875"
						y="236.16"
						width="49.7004"
						height="3.5928"
						rx="1.7964"
						fill="#C5B8FB"
					/>
					<mask id="path-76-inside-2_4301_3260" fill="white">
						<path d="M35.5938 264.64H229.945V288.934H35.5938V264.64Z" />
					</mask>
					<path
						d="M35.5938 264.64V265.449H229.945V264.64V263.83H35.5938V264.64ZM229.945 288.934V288.124H35.5938V288.934V289.743H229.945V288.934Z"
						fill="#F3EFFA"
						mask="url(#path-76-inside-2_4301_3260)"
					/>
					<rect
						x="45.625"
						y="270.309"
						width="17.9955"
						height="4.49888"
						rx="2.24944"
						fill="#C5B8FB"
					/>
					<rect
						x="45.625"
						y="279.243"
						width="46.0189"
						height="3.32667"
						rx="1.66333"
						fill="#C5B8FB"
					/>
					<rect
						x="170.831"
						y="272.48"
						width="21.7746"
						height="7.91803"
						rx="1.48463"
						fill="white"
					/>
					<rect
						x="170.831"
						y="272.48"
						width="21.7746"
						height="7.91803"
						rx="1.48463"
						stroke="#CEBCF3"
						stroke-width="0.989753"
					/>
					<rect
						x="200.886"
						y="272.48"
						width="21.7746"
						height="7.91803"
						rx="1.48463"
						fill="#CEBCF3"
					/>
					<rect
						x="200.886"
						y="272.48"
						width="21.7746"
						height="7.91803"
						rx="1.48463"
						stroke="#CEBCF3"
						stroke-width="0.989753"
					/>
					<rect
						x="201.284"
						y="227.074"
						width="21.7746"
						height="7.91803"
						rx="1.48463"
						fill="#CEBCF3"
					/>
					<rect
						x="201.284"
						y="227.074"
						width="21.7746"
						height="7.91803"
						rx="1.48463"
						stroke="#CEBCF3"
						stroke-width="0.989753"
					/>
					<mask id="path-83-inside-3_4301_3260" fill="white">
						<path d="M35.5938 288.124H229.945V312.418H35.5938V288.124Z" />
					</mask>
					<path
						d="M35.5938 288.124V288.934H229.945V288.124V287.314H35.5938V288.124ZM229.945 312.418V311.608H35.5938V312.418V313.228H229.945V312.418Z"
						fill="#F3EFFA"
						mask="url(#path-83-inside-3_4301_3260)"
					/>
					<rect
						x="45.625"
						y="293.793"
						width="17.9955"
						height="4.49888"
						rx="2.24944"
						fill="#C5B8FB"
					/>
					<rect
						x="45.625"
						y="302.728"
						width="46.0189"
						height="3.32667"
						rx="1.66333"
						fill="#C5B8FB"
					/>
					<rect
						x="170.831"
						y="295.965"
						width="21.7746"
						height="7.91803"
						rx="1.48463"
						fill="white"
					/>
					<rect
						x="170.831"
						y="295.965"
						width="21.7746"
						height="7.91803"
						rx="1.48463"
						stroke="#CEBCF3"
						stroke-width="0.989753"
					/>
					<rect
						x="200.886"
						y="295.965"
						width="21.7746"
						height="7.91803"
						rx="1.48463"
						fill="#CEBCF3"
					/>
					<rect
						x="200.886"
						y="295.965"
						width="21.7746"
						height="7.91803"
						rx="1.48463"
						stroke="#CEBCF3"
						stroke-width="0.989753"
					/>
					<mask id="path-89-inside-4_4301_3260" fill="white">
						<path d="M35.5938 311.607H229.945V335.901H35.5938V311.607Z" />
					</mask>
					<path
						d="M35.5938 311.607V312.417H229.945V311.607V310.798H35.5938V311.607ZM229.945 335.901V335.092H35.5938V335.901V336.711H229.945V335.901Z"
						fill="#F3EFFA"
						mask="url(#path-89-inside-4_4301_3260)"
					/>
					<rect
						x="45.625"
						y="317.276"
						width="17.9955"
						height="4.49888"
						rx="2.24944"
						fill="#C5B8FB"
					/>
					<rect
						x="45.625"
						y="326.211"
						width="46.0189"
						height="3.32667"
						rx="1.66333"
						fill="#C5B8FB"
					/>
					<rect
						x="170.831"
						y="319.448"
						width="21.7746"
						height="7.91803"
						rx="1.48463"
						fill="white"
					/>
					<rect
						x="170.831"
						y="319.448"
						width="21.7746"
						height="7.91803"
						rx="1.48463"
						stroke="#CEBCF3"
						stroke-width="0.989753"
					/>
					<rect
						x="200.886"
						y="319.448"
						width="21.7746"
						height="7.91803"
						rx="1.48463"
						fill="#CEBCF3"
					/>
					<rect
						x="200.886"
						y="319.448"
						width="21.7746"
						height="7.91803"
						rx="1.48463"
						stroke="#CEBCF3"
						stroke-width="0.989753"
					/>
				</g>
			</g>
		</g>
		<defs>
			<filter
				id="filter0_d_4301_3260"
				x="-10.5648"
				y="169.893"
				width="286.669"
				height="232.412"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="3.23919" />
				<feGaussianBlur stdDeviation="23.0793" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_4301_3260"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_4301_3260"
					result="shape"
				/>
			</filter>
			<clipPath id="clip0_4301_3260">
				<rect width="476" height="406" rx="12" fill="white" />
			</clipPath>
			<clipPath id="clip1_4301_3260">
				<rect
					x="35.5938"
					y="212.812"
					width="194.352"
					height="140.095"
					rx="8.90778"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
);

const ImageFive = (
	<svg
		className="w-full h-auto"
		width="476"
		height="406"
		viewBox="0 0 476 406"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_4305_3373)">
			<rect width="476" height="406" rx="12" fill="#F4F2FF" />
			<rect
				x="53.279"
				y="51.279"
				width="368.897"
				height="302.518"
				rx="6.70833"
				fill="white"
			/>
			<rect
				x="53.279"
				y="51.279"
				width="368.897"
				height="302.518"
				rx="6.70833"
				stroke="#D7CFFF"
				stroke-width="0.558005"
			/>
			<mask id="path-3-inside-1_4305_3373" fill="white">
				<path d="M53 55.464C53 52.9986 54.9986 51 57.464 51H415C418.866 51 422 54.134 422 58V75H53V55.464Z" />
			</mask>
			<path
				d="M53 55.464C53 52.9986 54.9986 51 57.464 51H415C418.866 51 422 54.134 422 58V75H53V55.464Z"
				fill="white"
			/>
			<path
				d="M52.24 55.464C52.24 52.5789 54.5789 50.24 57.464 50.24H414.24C418.526 50.24 422 53.7143 422 58C422 54.5537 418.866 51.76 415 51.76H57.464C55.4184 51.76 53.76 53.4184 53.76 55.464L52.24 55.464ZM422 75.7642H52.24L53.76 74.2358H422V75.7642ZM52.24 75.7642V55.464C52.24 52.5789 54.5789 50.24 57.464 50.24L57.464 51.76C55.4184 51.76 53.76 53.4184 53.76 55.464V74.2358L52.24 75.7642ZM422 51V75V51Z"
				fill="#D8D2FB"
				mask="url(#path-3-inside-1_4305_3373)"
			/>
			<circle cx="68.9071" cy="62.9969" r="4.74304" fill="#FF4C4C" />
			<circle cx="84.2587" cy="62.9969" r="4.74304" fill="#FFAB42" />
			<circle cx="99.6259" cy="62.9969" r="4.74304" fill="#00A900" />
			<rect
				x="69.4612"
				y="107.461"
				width="156.796"
				height="189.078"
				rx="9.53883"
				stroke="#C5B8FB"
				stroke-opacity="0.28"
				stroke-width="0.92233"
			/>
			<rect
				x="81.9141"
				y="115.301"
				width="131.893"
				height="89.466"
				rx="10"
				fill="#F0EDF8"
				fill-opacity="0.85"
			/>
			<rect
				x="82.3752"
				y="115.762"
				width="130.971"
				height="88.5437"
				rx="9.53883"
				stroke="#7B4DD9"
				stroke-opacity="0.07"
				stroke-width="0.92233"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M139.023 149.607L139.019 149.627C134.598 149.858 132.356 140.297 137.733 142.294C138.61 138.401 139.583 135.659 140.653 134.068C146.942 141.837 152.887 145.834 158.487 146.059C158.688 144.891 158.824 143.636 158.883 142.294C164.26 140.297 162.018 149.858 157.597 149.627L157.594 149.607C153.788 160.723 142.831 160.721 139.023 149.607ZM148.308 192.745C138.421 192.745 129.938 190.335 128.122 187.008L129.162 174.637C129.187 174.325 129.088 174.016 128.886 173.777C128.683 173.538 128.394 173.39 128.082 173.364C127.77 173.338 127.461 173.438 127.222 173.64C126.983 173.842 126.834 174.131 126.808 174.443L125.731 187.26L125.843 187.262C124.454 187.242 123.087 186.907 121.846 186.282C120.605 185.657 119.523 184.758 118.68 183.654C119.882 177.221 120.902 169.881 125.376 165.632C127.893 163.243 131.964 162.086 135.792 161.19V169.635C134.401 169.726 133.144 170.332 132.211 171.264L132.208 171.266L132.206 171.269C131.192 172.283 130.565 173.681 130.565 175.216V179.052C130.562 179.209 130.59 179.365 130.648 179.511C130.706 179.657 130.793 179.79 130.903 179.902C131.013 180.014 131.144 180.103 131.289 180.164C131.434 180.225 131.589 180.256 131.746 180.256C131.903 180.256 132.059 180.225 132.203 180.164C132.348 180.103 132.479 180.014 132.589 179.902C132.699 179.79 132.786 179.657 132.844 179.511C132.902 179.365 132.93 179.209 132.927 179.052V175.216C132.927 174.792 133.01 174.373 133.172 173.981C133.334 173.589 133.572 173.233 133.871 172.934L133.876 172.93C134.176 172.63 134.531 172.392 134.923 172.23C135.315 172.068 135.735 171.985 136.158 171.985H137.788C138.212 171.985 138.632 172.068 139.023 172.23C139.415 172.392 139.771 172.63 140.07 172.93V172.934C140.656 173.52 141.019 174.328 141.019 175.216V178.957C141.019 179.609 141.548 180.138 142.2 180.138C142.853 180.138 143.382 179.609 143.382 178.957V175.216C143.382 173.675 142.754 172.277 141.741 171.264L141.738 171.266C140.805 170.333 139.546 169.726 138.154 169.635V160.65C138.788 160.505 139.403 160.362 139.99 160.217L148.308 183.643V192.745ZM156.626 160.217C157.236 160.367 157.848 160.511 158.461 160.65V170.329C158.181 170.463 157.926 170.644 157.706 170.864L157.702 170.869C157.205 171.366 156.898 172.051 156.898 172.805C156.898 173.56 157.205 174.245 157.702 174.741L157.706 174.745C158.203 175.242 158.888 175.55 159.642 175.55C160.397 175.55 161.082 175.243 161.579 174.745L161.584 174.741C162.08 174.245 162.388 173.56 162.388 172.805C162.388 172.047 162.08 171.361 161.584 170.864H161.579C161.359 170.644 161.104 170.463 160.823 170.329V161.19C164.651 162.086 168.721 163.244 171.24 165.632C175.713 169.881 176.734 177.221 177.936 183.654C176.228 185.893 173.62 187.186 170.889 187.26L169.811 174.444C169.798 174.289 169.755 174.139 169.685 174.001C169.614 173.863 169.516 173.74 169.398 173.64C169.28 173.54 169.143 173.464 168.995 173.417C168.848 173.369 168.692 173.351 168.538 173.364C168.383 173.377 168.233 173.42 168.095 173.491C167.957 173.561 167.834 173.659 167.734 173.777C167.634 173.895 167.558 174.032 167.511 174.18C167.463 174.327 167.445 174.483 167.458 174.637L168.498 187.009L168.5 187.009L168.494 187.008C166.825 190.066 159.52 192.35 150.67 192.699V183.236L148.498 177.12L156.626 160.217ZM159.785 158.52C165.089 156.012 168.066 151.892 167.307 146.09C166.167 136.225 159.029 121.855 148.308 121.864C137.587 121.855 130.449 136.225 129.309 146.09C128.546 151.918 131.665 155.986 137.059 158.466L138.154 158.21V158.226C138.578 158.128 139.002 158.027 139.424 157.923L140.1 157.756L140.229 157.591C140.347 157.443 140.417 157.074 140.458 156.698C142.514 158.872 145.222 160.308 148.312 160.307C151.366 160.307 154.094 158.888 156.159 156.701C156.2 157.08 156.27 157.449 156.388 157.593L156.519 157.755L157.197 157.924C157.618 158.029 158.039 158.129 158.461 158.226V158.21L159.785 158.52Z"
				fill="#7351FD"
			/>
			<path
				d="M97.3317 195.752L96.0048 195.56C95.9321 195.549 95.8686 195.504 95.8365 195.438L95.2427 194.241C95.1686 194.093 95.0196 194 94.8527 194C94.6859 194 94.5368 194.092 94.4627 194.241L93.8683 195.439C93.8363 195.505 93.7728 195.55 93.7001 195.561L92.3731 195.753C92.2077 195.777 92.0729 195.89 92.0216 196.048C91.9704 196.206 92.0116 196.376 92.1314 196.493L93.0912 197.424C93.1439 197.475 93.1689 197.55 93.1561 197.622L92.9294 198.937C92.901 199.101 92.9673 199.263 93.1026 199.362C93.238 199.459 93.4135 199.472 93.5611 199.394L94.7478 198.773C94.8135 198.739 94.8912 198.739 94.9561 198.773L96.1427 199.394C96.2068 199.428 96.2767 199.444 96.3452 199.444C96.4352 199.444 96.5249 199.416 96.6012 199.361C96.7366 199.263 96.8023 199.101 96.7745 198.936L96.5477 197.621C96.5349 197.549 96.56 197.475 96.6126 197.423L97.5725 196.492C97.6923 196.375 97.7338 196.205 97.6823 196.047C97.6321 195.889 97.4973 195.776 97.3318 195.752L97.3317 195.752Z"
				fill="#F99D1D"
			/>
			<path
				d="M105.691 195.752L104.364 195.56C104.291 195.549 104.228 195.504 104.196 195.438L103.602 194.241C103.528 194.093 103.379 194 103.212 194C103.045 194 102.896 194.092 102.822 194.241L102.228 195.439C102.196 195.505 102.132 195.55 102.059 195.561L100.733 195.753C100.567 195.777 100.432 195.89 100.381 196.048C100.33 196.206 100.371 196.376 100.491 196.493L101.451 197.424C101.503 197.475 101.528 197.55 101.516 197.622L101.289 198.937C101.26 199.101 101.327 199.263 101.462 199.362C101.597 199.459 101.773 199.472 101.921 199.394L103.107 198.773C103.173 198.739 103.251 198.739 103.315 198.773L104.502 199.394C104.566 199.428 104.636 199.444 104.705 199.444C104.795 199.444 104.884 199.416 104.961 199.361C105.096 199.263 105.162 199.101 105.134 198.936L104.907 197.621C104.894 197.549 104.919 197.475 104.972 197.423L105.932 196.492C106.052 196.375 106.093 196.205 106.042 196.047C105.991 195.889 105.857 195.776 105.691 195.752L105.691 195.752Z"
				fill="#F99D1D"
			/>
			<path
				d="M114.043 195.752L112.716 195.56C112.643 195.549 112.58 195.504 112.547 195.438L111.954 194.241C111.88 194.093 111.731 194 111.564 194C111.397 194 111.248 194.092 111.174 194.241L110.579 195.439C110.547 195.505 110.484 195.55 110.411 195.561L109.084 195.753C108.919 195.777 108.784 195.89 108.733 196.048C108.681 196.206 108.723 196.376 108.842 196.493L109.802 197.424C109.855 197.475 109.88 197.55 109.867 197.622L109.64 198.937C109.612 199.101 109.678 199.263 109.814 199.362C109.949 199.459 110.124 199.472 110.272 199.394L111.459 198.773C111.524 198.739 111.602 198.739 111.667 198.773L112.854 199.394C112.918 199.428 112.988 199.444 113.056 199.444C113.146 199.444 113.236 199.416 113.312 199.361C113.448 199.263 113.513 199.101 113.485 198.936L113.259 197.621C113.246 197.549 113.271 197.475 113.324 197.423L114.283 196.492C114.403 196.375 114.445 196.205 114.393 196.047C114.343 195.889 114.208 195.776 114.043 195.752L114.043 195.752Z"
				fill="#F99D1D"
			/>
			<path
				d="M122.402 195.752L121.075 195.56C121.002 195.549 120.939 195.504 120.907 195.438L120.313 194.241C120.239 194.093 120.09 194 119.923 194C119.756 194 119.607 194.092 119.533 194.241L118.939 195.439C118.907 195.505 118.843 195.55 118.77 195.561L117.443 195.753C117.278 195.777 117.143 195.89 117.092 196.048C117.041 196.206 117.082 196.376 117.202 196.493L118.162 197.424C118.214 197.475 118.239 197.55 118.226 197.622L118 198.937C117.971 199.101 118.038 199.263 118.173 199.362C118.308 199.459 118.484 199.472 118.631 199.394L119.818 198.773C119.884 198.739 119.962 198.739 120.026 198.773L121.213 199.394C121.277 199.428 121.347 199.444 121.416 199.444C121.506 199.444 121.595 199.416 121.672 199.361C121.807 199.263 121.873 199.101 121.845 198.936L121.618 197.621C121.605 197.549 121.63 197.475 121.683 197.423L122.643 196.492C122.763 196.375 122.804 196.205 122.753 196.047C122.702 195.889 122.568 195.776 122.402 195.752L122.402 195.752Z"
				fill="#F99D1D"
			/>
			<path
				d="M130.629 195.752L129.302 195.56C129.229 195.549 129.165 195.504 129.133 195.438L128.54 194.241C128.465 194.093 128.316 194 128.15 194C127.983 194 127.834 194.092 127.76 194.241L127.165 195.439C127.133 195.505 127.07 195.55 126.997 195.561L125.67 195.753C125.505 195.777 125.37 195.89 125.318 196.048C125.267 196.206 125.308 196.376 125.428 196.493L126.388 197.424C126.441 197.475 126.466 197.55 126.453 197.622L126.226 198.937C126.198 199.101 126.264 199.263 126.4 199.362C126.535 199.459 126.71 199.472 126.858 199.394L128.045 198.773C128.11 198.739 128.188 198.739 128.253 198.773L129.44 199.394C129.504 199.428 129.574 199.444 129.642 199.444C129.732 199.444 129.822 199.416 129.898 199.361C130.033 199.263 130.099 199.101 130.071 198.936L129.845 197.621C129.832 197.549 129.857 197.475 129.91 197.423L130.869 196.492C130.989 196.375 131.031 196.205 130.979 196.047C130.929 195.889 130.794 195.776 130.629 195.752L130.629 195.752Z"
				fill="#F99D1D"
			/>
			<rect
				x="88.3672"
				y="220.446"
				width="118.981"
				height="8.30097"
				rx="3.29896"
				fill="#C5B8FB"
			/>
			<rect
				x="88.3672"
				y="237.048"
				width="106.99"
				height="4.80037"
				rx="2.40018"
				fill="#C5B8FB"
			/>
			<rect
				x="88.3672"
				y="247.448"
				width="106.99"
				height="4.80037"
				rx="2.40018"
				fill="#C5B8FB"
			/>
			<rect
				x="88.3672"
				y="260.551"
				width="106.99"
				height="4.80037"
				rx="2.40018"
				fill="#C5B8FB"
			/>
			<rect
				x="88.3672"
				y="270.951"
				width="106.99"
				height="4.80037"
				rx="2.40018"
				fill="#C5B8FB"
			/>
			<g filter="url(#filter0_d_4305_3373)">
				<rect
					x="21.0391"
					y="220.446"
					width="113.274"
					height="83.0097"
					rx="4.80208"
					fill="white"
				/>
				<rect
					x="21.1832"
					y="220.59"
					width="112.985"
					height="82.7215"
					rx="4.65797"
					stroke="#7351FD"
					stroke-opacity="0.45"
					stroke-width="0.288228"
				/>
				<mask
					id="path-25-outside-2_4305_3373"
					maskUnits="userSpaceOnUse"
					x="26.1016"
					y="224.748"
					width="19"
					height="7"
					fill="black"
				>
					<rect fill="white" x="26.1016" y="224.748" width="19" height="7" />
					<path d="M26.9879 229.631C27.449 229.232 27.8117 228.906 28.0759 228.651C28.3449 228.392 28.5683 228.123 28.7461 227.844C28.9238 227.566 29.0127 227.287 29.0127 227.008C29.0127 226.72 28.943 226.494 28.8037 226.331C28.6692 226.168 28.4554 226.086 28.1624 226.086C27.879 226.086 27.658 226.177 27.4995 226.36C27.3457 226.538 27.2641 226.778 27.2545 227.08H26.4618C26.4763 226.533 26.6396 226.115 26.9518 225.827C27.2689 225.534 27.67 225.387 28.1552 225.387C28.6788 225.387 29.0871 225.531 29.3802 225.819C29.678 226.108 29.8269 226.492 29.8269 226.972C29.8269 227.318 29.738 227.652 29.5603 227.974C29.3874 228.291 29.1784 228.577 28.9334 228.831C28.6932 229.081 28.3858 229.372 28.0111 229.703L27.6868 229.991H29.971V230.676H26.4691V230.078L26.9879 229.631ZM30.9088 228.053C30.9088 227.222 31.0481 226.574 31.3268 226.108C31.6102 225.637 32.0954 225.401 32.7823 225.401C33.4693 225.401 33.952 225.637 34.2307 226.108C34.5141 226.574 34.6558 227.222 34.6558 228.053C34.6558 228.894 34.5141 229.552 34.2307 230.027C33.952 230.498 33.4693 230.734 32.7823 230.734C32.0954 230.734 31.6102 230.498 31.3268 230.027C31.0481 229.552 30.9088 228.894 30.9088 228.053ZM33.8488 228.053C33.8488 227.664 33.8223 227.335 33.7695 227.066C33.7215 226.797 33.6206 226.578 33.4669 226.41C33.3131 226.237 33.085 226.151 32.7823 226.151C32.4797 226.151 32.2515 226.237 32.0978 226.41C31.9441 226.578 31.8408 226.797 31.7879 227.066C31.7399 227.335 31.7159 227.664 31.7159 228.053C31.7159 228.457 31.7399 228.795 31.7879 229.069C31.836 229.343 31.9368 229.564 32.0906 229.732C32.2491 229.9 32.4797 229.984 32.7823 229.984C33.085 229.984 33.3131 229.9 33.4669 229.732C33.6254 229.564 33.7287 229.343 33.7767 229.069C33.8247 228.795 33.8488 228.457 33.8488 228.053ZM36.1951 229.631C36.6563 229.232 37.019 228.906 37.2832 228.651C37.5522 228.392 37.7756 228.123 37.9533 227.844C38.1311 227.566 38.2199 227.287 38.2199 227.008C38.2199 226.72 38.1503 226.494 38.011 226.331C37.8765 226.168 37.6627 226.086 37.3696 226.086C37.0862 226.086 36.8652 226.177 36.7067 226.36C36.553 226.538 36.4713 226.778 36.4617 227.08H35.6691C35.6835 226.533 35.8468 226.115 36.1591 225.827C36.4761 225.534 36.8773 225.387 37.3624 225.387C37.8861 225.387 38.2944 225.531 38.5874 225.819C38.8852 226.108 39.0342 226.492 39.0342 226.972C39.0342 227.318 38.9453 227.652 38.7676 227.974C38.5946 228.291 38.3857 228.577 38.1407 228.831C37.9005 229.081 37.593 229.372 37.2183 229.703L36.8941 229.991H39.1783V230.676H35.6763V230.078L36.1951 229.631ZM43.5028 226.201H41.0889V227.635C41.1897 227.501 41.3387 227.388 41.5356 227.297C41.7374 227.205 41.9511 227.16 42.1769 227.16C42.5804 227.16 42.9071 227.246 43.1569 227.419C43.4115 227.592 43.5916 227.811 43.6973 228.075C43.8078 228.339 43.8631 228.618 43.8631 228.911C43.8631 229.266 43.7934 229.583 43.6541 229.862C43.5196 230.136 43.3154 230.352 43.0416 230.51C42.7726 230.669 42.4411 230.748 42.0472 230.748C41.5236 230.748 41.1033 230.618 40.7862 230.359C40.4692 230.1 40.2794 229.756 40.217 229.329H41.0168C41.0696 229.554 41.1873 229.734 41.3699 229.869C41.5524 229.999 41.7806 230.064 42.0544 230.064C42.3955 230.064 42.6501 229.96 42.8182 229.754C42.9912 229.547 43.0776 229.273 43.0776 228.932C43.0776 228.586 42.9912 228.322 42.8182 228.14C42.6453 227.952 42.3907 227.859 42.0544 227.859C41.819 227.859 41.6197 227.919 41.4564 228.039C41.2978 228.154 41.1825 228.313 41.1105 228.514H40.3323V225.481H43.5028V226.201Z" />
				</mask>
				<path
					d="M26.9879 229.631C27.449 229.232 27.8117 228.906 28.0759 228.651C28.3449 228.392 28.5683 228.123 28.7461 227.844C28.9238 227.566 29.0127 227.287 29.0127 227.008C29.0127 226.72 28.943 226.494 28.8037 226.331C28.6692 226.168 28.4554 226.086 28.1624 226.086C27.879 226.086 27.658 226.177 27.4995 226.36C27.3457 226.538 27.2641 226.778 27.2545 227.08H26.4618C26.4763 226.533 26.6396 226.115 26.9518 225.827C27.2689 225.534 27.67 225.387 28.1552 225.387C28.6788 225.387 29.0871 225.531 29.3802 225.819C29.678 226.108 29.8269 226.492 29.8269 226.972C29.8269 227.318 29.738 227.652 29.5603 227.974C29.3874 228.291 29.1784 228.577 28.9334 228.831C28.6932 229.081 28.3858 229.372 28.0111 229.703L27.6868 229.991H29.971V230.676H26.4691V230.078L26.9879 229.631ZM30.9088 228.053C30.9088 227.222 31.0481 226.574 31.3268 226.108C31.6102 225.637 32.0954 225.401 32.7823 225.401C33.4693 225.401 33.952 225.637 34.2307 226.108C34.5141 226.574 34.6558 227.222 34.6558 228.053C34.6558 228.894 34.5141 229.552 34.2307 230.027C33.952 230.498 33.4693 230.734 32.7823 230.734C32.0954 230.734 31.6102 230.498 31.3268 230.027C31.0481 229.552 30.9088 228.894 30.9088 228.053ZM33.8488 228.053C33.8488 227.664 33.8223 227.335 33.7695 227.066C33.7215 226.797 33.6206 226.578 33.4669 226.41C33.3131 226.237 33.085 226.151 32.7823 226.151C32.4797 226.151 32.2515 226.237 32.0978 226.41C31.9441 226.578 31.8408 226.797 31.7879 227.066C31.7399 227.335 31.7159 227.664 31.7159 228.053C31.7159 228.457 31.7399 228.795 31.7879 229.069C31.836 229.343 31.9368 229.564 32.0906 229.732C32.2491 229.9 32.4797 229.984 32.7823 229.984C33.085 229.984 33.3131 229.9 33.4669 229.732C33.6254 229.564 33.7287 229.343 33.7767 229.069C33.8247 228.795 33.8488 228.457 33.8488 228.053ZM36.1951 229.631C36.6563 229.232 37.019 228.906 37.2832 228.651C37.5522 228.392 37.7756 228.123 37.9533 227.844C38.1311 227.566 38.2199 227.287 38.2199 227.008C38.2199 226.72 38.1503 226.494 38.011 226.331C37.8765 226.168 37.6627 226.086 37.3696 226.086C37.0862 226.086 36.8652 226.177 36.7067 226.36C36.553 226.538 36.4713 226.778 36.4617 227.08H35.6691C35.6835 226.533 35.8468 226.115 36.1591 225.827C36.4761 225.534 36.8773 225.387 37.3624 225.387C37.8861 225.387 38.2944 225.531 38.5874 225.819C38.8852 226.108 39.0342 226.492 39.0342 226.972C39.0342 227.318 38.9453 227.652 38.7676 227.974C38.5946 228.291 38.3857 228.577 38.1407 228.831C37.9005 229.081 37.593 229.372 37.2183 229.703L36.8941 229.991H39.1783V230.676H35.6763V230.078L36.1951 229.631ZM43.5028 226.201H41.0889V227.635C41.1897 227.501 41.3387 227.388 41.5356 227.297C41.7374 227.205 41.9511 227.16 42.1769 227.16C42.5804 227.16 42.9071 227.246 43.1569 227.419C43.4115 227.592 43.5916 227.811 43.6973 228.075C43.8078 228.339 43.8631 228.618 43.8631 228.911C43.8631 229.266 43.7934 229.583 43.6541 229.862C43.5196 230.136 43.3154 230.352 43.0416 230.51C42.7726 230.669 42.4411 230.748 42.0472 230.748C41.5236 230.748 41.1033 230.618 40.7862 230.359C40.4692 230.1 40.2794 229.756 40.217 229.329H41.0168C41.0696 229.554 41.1873 229.734 41.3699 229.869C41.5524 229.999 41.7806 230.064 42.0544 230.064C42.3955 230.064 42.6501 229.96 42.8182 229.754C42.9912 229.547 43.0776 229.273 43.0776 228.932C43.0776 228.586 42.9912 228.322 42.8182 228.14C42.6453 227.952 42.3907 227.859 42.0544 227.859C41.819 227.859 41.6197 227.919 41.4564 228.039C41.2978 228.154 41.1825 228.313 41.1105 228.514H40.3323V225.481H43.5028V226.201Z"
					fill="#7351FD"
				/>
				<path
					d="M26.9879 229.631L27.1759 229.85L27.1764 229.849L26.9879 229.631ZM28.0759 228.651L28.2759 228.859L28.276 228.859L28.0759 228.651ZM28.8037 226.331L28.5812 226.514L28.5844 226.518L28.8037 226.331ZM27.4995 226.36L27.2818 226.171L27.2815 226.171L27.4995 226.36ZM27.2545 227.08V227.369H27.5337L27.5426 227.089L27.2545 227.08ZM26.4618 227.08L26.1737 227.073L26.1659 227.369H26.4618V227.08ZM26.9518 225.827L27.1473 226.038L27.1475 226.038L26.9518 225.827ZM29.3802 225.819L29.178 226.025L29.1797 226.026L29.3802 225.819ZM29.5603 227.974L29.308 227.835L29.3073 227.836L29.5603 227.974ZM28.9334 228.831L28.7257 228.631L28.7256 228.632L28.9334 228.831ZM28.0111 229.703L27.8201 229.487L27.8196 229.488L28.0111 229.703ZM27.6868 229.991L27.4953 229.776L26.9287 230.28H27.6868V229.991ZM29.971 229.991H30.2593V229.703H29.971V229.991ZM29.971 230.676V230.964H30.2593V230.676H29.971ZM26.4691 230.676H26.1808V230.964H26.4691V230.676ZM26.4691 230.078L26.281 229.86L26.1808 229.946V230.078H26.4691ZM26.9879 229.631L27.1764 229.849C27.6393 229.449 28.0064 229.119 28.2759 228.859L28.0759 228.651L27.8759 228.444C27.6171 228.693 27.2588 229.016 26.7994 229.413L26.9879 229.631ZM28.0759 228.651L28.276 228.859C28.5592 228.586 28.7976 228.299 28.989 227.999L28.7461 227.844L28.5031 227.689C28.339 227.946 28.1306 228.198 27.8759 228.444L28.0759 228.651ZM28.7461 227.844L28.989 227.999C29.1908 227.683 29.3009 227.351 29.3009 227.008H29.0127H28.7244C28.7244 227.222 28.6568 227.448 28.5031 227.689L28.7461 227.844ZM29.0127 227.008H29.3009C29.3009 226.675 29.2201 226.375 29.023 226.144L28.8037 226.331L28.5844 226.518C28.666 226.614 28.7244 226.765 28.7244 227.008H29.0127ZM28.8037 226.331L29.0262 226.148C28.8181 225.895 28.5067 225.798 28.1624 225.798V226.086V226.374C28.4042 226.374 28.5203 226.44 28.5812 226.514L28.8037 226.331ZM28.1624 226.086V225.798C27.8114 225.798 27.5047 225.914 27.2818 226.171L27.4995 226.36L27.7171 226.549C27.8113 226.44 27.9466 226.374 28.1624 226.374V226.086ZM27.4995 226.36L27.2815 226.171C27.0733 226.412 26.9775 226.722 26.9664 227.071L27.2545 227.08L27.5426 227.089C27.5507 226.834 27.6181 226.663 27.7175 226.548L27.4995 226.36ZM27.2545 227.08V226.792H26.4618V227.08V227.369H27.2545V227.08ZM26.4618 227.08L26.75 227.088C26.763 226.594 26.9076 226.26 27.1473 226.038L26.9518 225.827L26.7563 225.615C26.3716 225.97 26.1896 226.471 26.1737 227.073L26.4618 227.08ZM26.9518 225.827L27.1475 226.038C27.4046 225.801 27.7328 225.675 28.1552 225.675V225.387V225.099C27.6072 225.099 27.1332 225.266 26.7562 225.615L26.9518 225.827ZM28.1552 225.387V225.675C28.6249 225.675 28.9526 225.803 29.178 226.025L29.3802 225.819L29.5823 225.614C29.2216 225.259 28.7327 225.099 28.1552 225.099V225.387ZM29.3802 225.819L29.1797 226.026C29.4124 226.252 29.5387 226.556 29.5387 226.972H29.8269H30.1151C30.1151 226.427 29.9436 225.963 29.5806 225.612L29.3802 225.819ZM29.8269 226.972H29.5387C29.5387 227.266 29.4637 227.553 29.308 227.835L29.5603 227.974L29.8126 228.113C30.0124 227.751 30.1151 227.37 30.1151 226.972H29.8269ZM29.5603 227.974L29.3073 227.836C29.1463 228.131 28.9525 228.396 28.7257 228.631L28.9334 228.831L29.1411 229.031C29.4043 228.758 29.6284 228.451 29.8133 228.112L29.5603 227.974ZM28.9334 228.831L28.7256 228.632C28.4926 228.874 28.1913 229.159 27.8201 229.487L28.0111 229.703L28.202 229.919C28.5803 229.585 28.8938 229.288 29.1412 229.031L28.9334 228.831ZM28.0111 229.703L27.8196 229.488L27.4953 229.776L27.6868 229.991L27.8783 230.207L28.2026 229.919L28.0111 229.703ZM27.6868 229.991V230.28H29.971V229.991V229.703H27.6868V229.991ZM29.971 229.991H29.6828V230.676H29.971H30.2593V229.991H29.971ZM29.971 230.676V230.388H26.4691V230.676V230.964H29.971V230.676ZM26.4691 230.676H26.7573V230.078H26.4691H26.1808V230.676H26.4691ZM26.4691 230.078L26.6571 230.296L27.1759 229.85L26.9879 229.631L26.7998 229.413L26.281 229.86L26.4691 230.078ZM31.3268 226.108L31.0798 225.959L31.0794 225.96L31.3268 226.108ZM34.2307 226.108L33.9826 226.254L33.9844 226.257L34.2307 226.108ZM34.2307 230.027L33.9831 229.88L33.9826 229.881L34.2307 230.027ZM31.3268 230.027L31.0781 230.173L31.0798 230.176L31.3268 230.027ZM33.7695 227.066L33.4857 227.117L33.4867 227.121L33.7695 227.066ZM33.4669 226.41L33.2514 226.602L33.2541 226.605L33.4669 226.41ZM32.0978 226.41L32.3105 226.605L32.3132 226.602L32.0978 226.41ZM31.7879 227.066L31.5051 227.01L31.5042 227.015L31.7879 227.066ZM31.7879 229.069L32.0718 229.019L31.7879 229.069ZM32.0906 229.732L31.8778 229.927L31.8809 229.93L32.0906 229.732ZM33.4669 229.732L33.2571 229.534L33.2541 229.538L33.4669 229.732ZM33.7767 229.069L34.0606 229.119L33.7767 229.069ZM30.9088 228.053H31.1971C31.1971 227.249 31.3328 226.659 31.5741 226.255L31.3268 226.108L31.0794 225.96C30.7634 226.488 30.6206 227.195 30.6206 228.053H30.9088ZM31.3268 226.108L31.5737 226.256C31.7915 225.894 32.1672 225.69 32.7823 225.69V225.401V225.113C32.0235 225.113 31.4289 225.379 31.0798 225.959L31.3268 226.108ZM32.7823 225.401V225.69C33.3976 225.69 33.7696 225.894 33.9826 226.254L34.2307 226.108L34.4787 225.961C34.1345 225.379 33.541 225.113 32.7823 225.113V225.401ZM34.2307 226.108L33.9844 226.257C34.2296 226.66 34.3676 227.249 34.3676 228.053H34.6558H34.944C34.944 227.195 34.7986 226.487 34.4769 225.958L34.2307 226.108ZM34.6558 228.053H34.3676C34.3676 228.867 34.2295 229.466 33.9831 229.88L34.2307 230.027L34.4783 230.175C34.7986 229.637 34.944 228.921 34.944 228.053H34.6558ZM34.2307 230.027L33.9826 229.881C33.7696 230.241 33.3976 230.445 32.7823 230.445V230.734V231.022C33.541 231.022 34.1345 230.756 34.4787 230.174L34.2307 230.027ZM32.7823 230.734V230.445C32.1672 230.445 31.7915 230.241 31.5737 229.879L31.3268 230.027L31.0798 230.176C31.4289 230.756 32.0235 231.022 32.7823 231.022V230.734ZM31.3268 230.027L31.5755 229.882C31.3329 229.468 31.1971 228.867 31.1971 228.053H30.9088H30.6206C30.6206 228.92 30.7634 229.636 31.0781 230.173L31.3268 230.027ZM33.8488 228.053H34.137C34.137 227.652 34.1099 227.304 34.0523 227.01L33.7695 227.066L33.4867 227.121C33.5348 227.366 33.5605 227.676 33.5605 228.053H33.8488ZM33.7695 227.066L34.0532 227.015C33.9975 226.703 33.8769 226.432 33.6796 226.216L33.4669 226.41L33.2541 226.605C33.3643 226.725 33.4454 226.89 33.4858 227.117L33.7695 227.066ZM33.4669 226.41L33.6823 226.219C33.4582 225.967 33.1404 225.863 32.7823 225.863V226.151V226.439C33.0295 226.439 33.168 226.508 33.2514 226.602L33.4669 226.41ZM32.7823 226.151V225.863C32.4242 225.863 32.1064 225.967 31.8824 226.219L32.0978 226.41L32.3132 226.602C32.3966 226.508 32.5351 226.439 32.7823 226.439V226.151ZM32.0978 226.41L31.8851 226.216C31.689 226.43 31.5661 226.7 31.5051 227.01L31.7879 227.066L32.0708 227.121C32.1155 226.894 32.1991 226.727 32.3105 226.605L32.0978 226.41ZM31.7879 227.066L31.5042 227.015C31.4522 227.306 31.4276 227.654 31.4276 228.053H31.7159H32.0041C32.0041 227.674 32.0276 227.364 32.0717 227.117L31.7879 227.066ZM31.7159 228.053H31.4276C31.4276 228.467 31.4521 228.823 31.504 229.119L31.7879 229.069L32.0718 229.019C32.0276 228.767 32.0041 228.447 32.0041 228.053H31.7159ZM31.7879 229.069L31.504 229.119C31.5595 229.435 31.6797 229.71 31.8779 229.927L32.0906 229.732L32.3033 229.538C32.194 229.418 32.1125 229.251 32.0718 229.019L31.7879 229.069ZM32.0906 229.732L31.8809 229.93C32.1093 230.172 32.4261 230.272 32.7823 230.272V229.984V229.696C32.5333 229.696 32.3889 229.628 32.3003 229.534L32.0906 229.732ZM32.7823 229.984V230.272C33.138 230.272 33.4549 230.172 33.6796 229.927L33.4669 229.732L33.2541 229.538C33.1714 229.628 33.0319 229.696 32.7823 229.696V229.984ZM33.4669 229.732L33.6766 229.93C33.881 229.713 34.0048 229.437 34.0606 229.119L33.7767 229.069L33.4928 229.019C33.4525 229.249 33.3698 229.415 33.2571 229.534L33.4669 229.732ZM33.7767 229.069L34.0606 229.119C34.1125 228.823 34.137 228.467 34.137 228.053H33.8488H33.5605C33.5605 228.447 33.537 228.767 33.4928 229.019L33.7767 229.069ZM36.1951 229.631L36.3832 229.85L36.3836 229.849L36.1951 229.631ZM37.2832 228.651L37.4832 228.859L37.4832 228.859L37.2832 228.651ZM38.011 226.331L37.7884 226.514L37.7917 226.518L38.011 226.331ZM36.7067 226.36L36.4891 226.171L36.4887 226.171L36.7067 226.36ZM36.4617 227.08V227.369H36.741L36.7498 227.089L36.4617 227.08ZM35.6691 227.08L35.381 227.073L35.3732 227.369H35.6691V227.08ZM36.1591 225.827L36.3546 226.038L36.3547 226.038L36.1591 225.827ZM38.5874 225.819L38.3853 226.025L38.387 226.026L38.5874 225.819ZM38.7676 227.974L38.5152 227.835L38.5145 227.836L38.7676 227.974ZM38.1407 228.831L37.933 228.631L37.9329 228.632L38.1407 228.831ZM37.2183 229.703L37.0274 229.487L37.0268 229.488L37.2183 229.703ZM36.8941 229.991L36.7026 229.776L36.136 230.28H36.8941V229.991ZM39.1783 229.991H39.4665V229.703H39.1783V229.991ZM39.1783 230.676V230.964H39.4665V230.676H39.1783ZM35.6763 230.676H35.3881V230.964H35.6763V230.676ZM35.6763 230.078L35.4882 229.86L35.3881 229.946V230.078H35.6763ZM36.1951 229.631L36.3836 229.849C36.8465 229.449 37.2136 229.119 37.4832 228.859L37.2832 228.651L37.0832 228.444C36.8243 228.693 36.466 229.016 36.0066 229.413L36.1951 229.631ZM37.2832 228.651L37.4832 228.859C37.7665 228.586 38.0049 228.299 38.1963 227.999L37.9533 227.844L37.7103 227.689C37.5462 227.946 37.3379 228.198 37.0831 228.444L37.2832 228.651ZM37.9533 227.844L38.1963 227.999C38.398 227.683 38.5082 227.351 38.5082 227.008H38.2199H37.9317C37.9317 227.222 37.8641 227.448 37.7103 227.689L37.9533 227.844ZM38.2199 227.008H38.5082C38.5082 226.675 38.4273 226.375 38.2303 226.144L38.011 226.331L37.7917 226.518C37.8732 226.614 37.9317 226.765 37.9317 227.008H38.2199ZM38.011 226.331L38.2334 226.148C38.0253 225.895 37.7139 225.798 37.3696 225.798V226.086V226.374C37.6114 226.374 37.7276 226.44 37.7885 226.514L38.011 226.331ZM37.3696 226.086V225.798C37.0186 225.798 36.712 225.914 36.4891 226.171L36.7067 226.36L36.9243 226.549C37.0185 226.44 37.1538 226.374 37.3696 226.374V226.086ZM36.7067 226.36L36.4887 226.171C36.2806 226.412 36.1847 226.722 36.1736 227.071L36.4617 227.08L36.7498 227.089C36.7579 226.834 36.8254 226.663 36.9247 226.548L36.7067 226.36ZM36.4617 227.08V226.792H35.6691V227.08V227.369H36.4617V227.08ZM35.6691 227.08L35.9572 227.088C35.9702 226.594 36.1148 226.26 36.3546 226.038L36.1591 225.827L35.9636 225.615C35.5789 225.97 35.3968 226.471 35.381 227.073L35.6691 227.08ZM36.1591 225.827L36.3547 226.038C36.6118 225.801 36.9401 225.675 37.3624 225.675V225.387V225.099C36.8144 225.099 36.3405 225.266 35.9635 225.615L36.1591 225.827ZM37.3624 225.387V225.675C37.8321 225.675 38.1599 225.803 38.3853 226.025L38.5874 225.819L38.7895 225.614C38.4289 225.259 37.94 225.099 37.3624 225.099V225.387ZM38.5874 225.819L38.387 226.026C38.6197 226.252 38.7459 226.556 38.7459 226.972H39.0342H39.3224C39.3224 226.427 39.1508 225.963 38.7879 225.612L38.5874 225.819ZM39.0342 226.972H38.7459C38.7459 227.266 38.671 227.553 38.5152 227.835L38.7676 227.974L39.0199 228.113C39.2196 227.751 39.3224 227.37 39.3224 226.972H39.0342ZM38.7676 227.974L38.5145 227.836C38.3536 228.131 38.1598 228.396 37.933 228.631L38.1407 228.831L38.3483 229.031C38.6115 228.758 38.8356 228.451 39.0206 228.112L38.7676 227.974ZM38.1407 228.831L37.9329 228.632C37.6999 228.874 37.3985 229.159 37.0274 229.487L37.2183 229.703L37.4093 229.919C37.7875 229.585 38.1011 229.288 38.3484 229.031L38.1407 228.831ZM37.2183 229.703L37.0268 229.488L36.7026 229.776L36.8941 229.991L37.0856 230.207L37.4098 229.919L37.2183 229.703ZM36.8941 229.991V230.28H39.1783V229.991V229.703H36.8941V229.991ZM39.1783 229.991H38.8901V230.676H39.1783H39.4665V229.991H39.1783ZM39.1783 230.676V230.388H35.6763V230.676V230.964H39.1783V230.676ZM35.6763 230.676H35.9645V230.078H35.6763H35.3881V230.676H35.6763ZM35.6763 230.078L35.8644 230.296L36.3832 229.85L36.1951 229.631L36.007 229.413L35.4882 229.86L35.6763 230.078ZM43.5028 226.201V226.489H43.791V226.201H43.5028ZM41.0889 226.201V225.913H40.8006V226.201H41.0889ZM41.0889 227.635H40.8006V228.5L41.3194 227.808L41.0889 227.635ZM41.5356 227.297L41.4168 227.034L41.4144 227.035L41.5356 227.297ZM43.1569 227.419L42.9928 227.656L42.9949 227.657L43.1569 227.419ZM43.6973 228.075L43.4297 228.182L43.4314 228.186L43.6973 228.075ZM43.6541 229.862L43.3963 229.733L43.3954 229.735L43.6541 229.862ZM43.0416 230.51L42.8972 230.261L42.8953 230.262L43.0416 230.51ZM40.7862 230.359L40.9687 230.136L40.7862 230.359ZM40.217 229.329V229.04H39.8836L39.9318 229.37L40.217 229.329ZM41.0168 229.329L41.2974 229.263L41.2454 229.04H41.0168V229.329ZM41.3699 229.869L41.1989 230.101L41.2029 230.104L41.3699 229.869ZM42.8182 229.754L42.5972 229.569L42.5947 229.572L42.8182 229.754ZM42.8182 228.14L42.6064 228.335L42.609 228.338L42.8182 228.14ZM41.4564 228.039L41.6259 228.272L41.6271 228.271L41.4564 228.039ZM41.1105 228.514V228.803H41.3136L41.3819 228.611L41.1105 228.514ZM40.3323 228.514H40.044V228.803H40.3323V228.514ZM40.3323 225.481V225.192H40.044V225.481H40.3323ZM43.5028 225.481H43.791V225.192H43.5028V225.481ZM43.5028 226.201V225.913H41.0889V226.201V226.489H43.5028V226.201ZM41.0889 226.201H40.8006V227.635H41.0889H41.3771V226.201H41.0889ZM41.0889 227.635L41.3194 227.808C41.3846 227.721 41.4908 227.635 41.6568 227.558L41.5356 227.297L41.4144 227.035C41.1865 227.141 40.9949 227.28 40.8583 227.462L41.0889 227.635ZM41.5356 227.297L41.6544 227.559C41.8181 227.485 41.9913 227.448 42.1769 227.448V227.16V226.871C41.911 226.871 41.6566 226.925 41.4168 227.034L41.5356 227.297ZM42.1769 227.16V227.448C42.5408 227.448 42.8048 227.526 42.9928 227.656L43.1569 227.419L43.321 227.182C43.0094 226.966 42.6201 226.871 42.1769 226.871V227.16ZM43.1569 227.419L42.9949 227.657C43.2061 227.801 43.3471 227.975 43.4297 228.182L43.6973 228.075L43.9649 227.968C43.8362 227.646 43.6169 227.383 43.3188 227.181L43.1569 227.419ZM43.6973 228.075L43.4314 228.186C43.5268 228.414 43.5748 228.655 43.5748 228.911H43.8631H44.1513C44.1513 228.58 44.0888 228.264 43.9632 227.964L43.6973 228.075ZM43.8631 228.911H43.5748C43.5748 229.228 43.5129 229.5 43.3963 229.733L43.6541 229.862L43.9119 229.991C44.0739 229.667 44.1513 229.304 44.1513 228.911H43.8631ZM43.6541 229.862L43.3954 229.735C43.287 229.955 43.1236 230.13 42.8972 230.261L43.0416 230.51L43.186 230.76C43.5073 230.574 43.7522 230.316 43.9128 229.989L43.6541 229.862ZM43.0416 230.51L42.8953 230.262C42.6808 230.388 42.403 230.46 42.0472 230.46V230.748V231.036C42.4793 231.036 42.8644 230.949 43.1879 230.759L43.0416 230.51ZM42.0472 230.748V230.46C41.5713 230.46 41.2214 230.343 40.9687 230.136L40.7862 230.359L40.6037 230.582C40.9852 230.894 41.4759 231.036 42.0472 231.036V230.748ZM40.7862 230.359L40.9687 230.136C40.7106 229.925 40.5549 229.648 40.5022 229.287L40.217 229.329L39.9318 229.37C40.004 229.865 40.2277 230.274 40.6037 230.582L40.7862 230.359ZM40.217 229.329V229.617H41.0168V229.329V229.04H40.217V229.329ZM41.0168 229.329L40.7362 229.394C40.8042 229.685 40.9598 229.925 41.1989 230.101L41.3699 229.869L41.5409 229.637C41.4148 229.544 41.3351 229.424 41.2974 229.263L41.0168 229.329ZM41.3699 229.869L41.2029 230.104C41.4442 230.275 41.7343 230.352 42.0544 230.352V230.064V229.775C41.8269 229.775 41.6606 229.722 41.5368 229.634L41.3699 229.869ZM42.0544 230.064V230.352C42.4558 230.352 42.8042 230.228 43.0418 229.936L42.8182 229.754L42.5947 229.572C42.496 229.693 42.3352 229.775 42.0544 229.775V230.064ZM42.8182 229.754L43.0392 229.939C43.2661 229.668 43.3659 229.322 43.3659 228.932H43.0776H42.7894C42.7894 229.224 42.7162 229.427 42.5972 229.569L42.8182 229.754ZM43.0776 228.932H43.3659C43.3659 228.541 43.2676 228.195 43.0275 227.941L42.8182 228.14L42.609 228.338C42.7147 228.449 42.7894 228.632 42.7894 228.932H43.0776ZM42.8182 228.14L43.03 227.944C42.7866 227.68 42.4442 227.57 42.0544 227.57V227.859V228.147C42.3372 228.147 42.504 228.224 42.6064 228.335L42.8182 228.14ZM42.0544 227.859V227.57C41.7679 227.57 41.5061 227.644 41.2856 227.806L41.4564 228.039L41.6271 228.271C41.7333 228.193 41.8702 228.147 42.0544 228.147V227.859ZM41.4564 228.039L41.2868 227.806C41.077 227.958 40.9287 228.166 40.839 228.417L41.1105 228.514L41.3819 228.611C41.4364 228.459 41.5186 228.35 41.6259 228.272L41.4564 228.039ZM41.1105 228.514V228.226H40.3323V228.514V228.803H41.1105V228.514ZM40.3323 228.514H40.6205V225.481H40.3323H40.044V228.514H40.3323ZM40.3323 225.481V225.769H43.5028V225.481V225.192H40.3323V225.481ZM43.5028 225.481H43.2145V226.201H43.5028H43.791V225.481H43.5028Z"
					fill="#7351FD"
					fill-opacity="0.2"
					mask="url(#path-25-outside-2_4305_3373)"
				/>
				<rect
					x="25.3863"
					y="239.326"
					width="105.128"
					height="57.9339"
					rx="5.62045"
					stroke="#7351FD"
					stroke-opacity="0.2"
					stroke-width="0.288228"
				/>
				<path
					opacity="0.2"
					d="M33.5162 243.849C33.7929 243.61 34.0105 243.414 34.169 243.261C34.3304 243.106 34.4644 242.944 34.5711 242.777C34.6777 242.61 34.731 242.443 34.731 242.276C34.731 242.103 34.6892 241.967 34.6057 241.869C34.525 241.771 34.3967 241.722 34.2209 241.722C34.0508 241.722 33.9182 241.777 33.8231 241.887C33.7309 241.993 33.6819 242.137 33.6761 242.319H33.2005C33.2092 241.99 33.3072 241.74 33.4945 241.567C33.6848 241.391 33.9254 241.303 34.2166 241.303C34.5307 241.303 34.7757 241.389 34.9515 241.562C35.1302 241.735 35.2196 241.966 35.2196 242.254C35.2196 242.462 35.1663 242.662 35.0596 242.855C34.9559 243.045 34.8305 243.217 34.6835 243.37C34.5394 243.519 34.3549 243.694 34.1301 243.893L33.9355 244.066H35.3061V244.476H33.2049V244.117L33.5162 243.849ZM37.8662 241.748L36.6642 244.52H36.1671L37.3819 241.8H35.7823V241.381H37.8662V241.748Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M50.5396 243.849C50.8163 243.61 51.0339 243.414 51.1924 243.261C51.3538 243.106 51.4879 242.944 51.5945 242.777C51.7012 242.61 51.7545 242.443 51.7545 242.276C51.7545 242.103 51.7127 241.967 51.6291 241.869C51.5484 241.771 51.4201 241.722 51.2443 241.722C51.0743 241.722 50.9417 241.777 50.8466 241.887C50.7543 241.993 50.7053 242.137 50.6996 242.319H50.224C50.2326 241.99 50.3306 241.74 50.518 241.567C50.7082 241.391 50.9489 241.303 51.24 241.303C51.5542 241.303 51.7992 241.389 51.975 241.562C52.1537 241.735 52.243 241.966 52.243 242.254C52.243 242.462 52.1897 242.662 52.0831 242.855C51.9793 243.045 51.8539 243.217 51.7069 243.37C51.5628 243.519 51.3783 243.694 51.1535 243.893L50.959 244.066H52.3295V244.476H50.2283V244.117L50.5396 243.849ZM53.424 242.872C53.1242 242.722 52.9743 242.486 52.9743 242.163C52.9743 242.008 53.0132 241.865 53.0911 241.735C53.1689 241.606 53.2856 241.503 53.4413 241.428C53.5969 241.35 53.7871 241.312 54.0119 241.312C54.2339 241.312 54.4227 241.35 54.5783 241.428C54.7368 241.503 54.855 241.606 54.9328 241.735C55.0107 241.865 55.0496 242.008 55.0496 242.163C55.0496 242.325 55.0078 242.467 54.9242 242.591C54.8435 242.712 54.7354 242.806 54.5999 242.872C54.7642 242.933 54.8939 243.032 54.989 243.171C55.0842 243.306 55.1317 243.466 55.1317 243.651C55.1317 243.838 55.0842 244.004 54.989 244.148C54.8939 244.292 54.7613 244.403 54.5913 244.481C54.4212 244.558 54.2281 244.597 54.0119 244.597C53.7958 244.597 53.6027 244.558 53.4326 244.481C53.2654 244.403 53.1343 244.292 53.0392 244.148C52.9441 244.004 52.8965 243.838 52.8965 243.651C52.8965 243.463 52.9441 243.302 53.0392 243.166C53.1343 243.031 53.2625 242.933 53.424 242.872ZM54.5783 242.224C54.5783 242.062 54.5279 241.938 54.427 241.852C54.3261 241.766 54.1878 241.722 54.0119 241.722C53.839 241.722 53.7021 241.766 53.6012 241.852C53.5003 241.938 53.4499 242.064 53.4499 242.228C53.4499 242.372 53.5018 242.49 53.6055 242.583C53.7122 242.672 53.8477 242.717 54.0119 242.717C54.1762 242.717 54.3117 242.671 54.4183 242.578C54.525 242.486 54.5783 242.368 54.5783 242.224ZM54.0119 243.088C53.8217 243.088 53.6661 243.136 53.545 243.231C53.4268 243.323 53.3678 243.457 53.3678 243.633C53.3678 243.798 53.4254 243.932 53.5407 244.035C53.656 244.136 53.8131 244.187 54.0119 244.187C54.2079 244.187 54.3621 244.135 54.4745 244.031C54.5898 243.927 54.6475 243.795 54.6475 243.633C54.6475 243.46 54.5884 243.326 54.4702 243.231C54.3549 243.136 54.2022 243.088 54.0119 243.088Z"
					fill="black"
				/>
				<rect
					x="65.5547"
					y="238.942"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M67.1867 241.817V241.368H68.086V244.52H67.5888V241.817H67.1867Z"
					fill="black"
				/>
				<rect
					x="82.5625"
					y="238.942"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M84.524 243.849C84.8007 243.61 85.0183 243.414 85.1768 243.261C85.3382 243.106 85.4722 242.944 85.5789 242.777C85.6855 242.61 85.7388 242.443 85.7388 242.276C85.7388 242.103 85.6971 241.967 85.6135 241.869C85.5328 241.771 85.4045 241.722 85.2287 241.722C85.0586 241.722 84.926 241.777 84.8309 241.887C84.7387 241.993 84.6897 242.137 84.6839 242.319H84.2084C84.217 241.99 84.315 241.74 84.5024 241.567C84.6926 241.391 84.9333 241.303 85.2244 241.303C85.5385 241.303 85.7835 241.389 85.9593 241.562C86.138 241.735 86.2274 241.966 86.2274 242.254C86.2274 242.462 86.1741 242.662 86.0674 242.855C85.9637 243.045 85.8383 243.217 85.6913 243.37C85.5472 243.519 85.3627 243.694 85.1379 243.893L84.9433 244.066H86.3139V244.476H84.2127V244.117L84.524 243.849Z"
					fill="black"
				/>
				<rect
					x="99.5703"
					y="238.942"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M101.259 242.146C101.276 241.878 101.378 241.669 101.566 241.519C101.756 241.369 101.998 241.294 102.292 241.294C102.494 241.294 102.668 241.33 102.815 241.402C102.962 241.474 103.073 241.572 103.148 241.696C103.223 241.82 103.26 241.96 103.26 242.116C103.26 242.294 103.213 242.447 103.118 242.574C103.023 242.701 102.909 242.786 102.776 242.829V242.846C102.946 242.898 103.079 242.993 103.174 243.132C103.269 243.267 103.317 243.442 103.317 243.655C103.317 243.825 103.278 243.976 103.2 244.109C103.122 244.241 103.007 244.347 102.854 244.424C102.701 244.499 102.518 244.537 102.305 244.537C101.994 244.537 101.737 244.458 101.535 244.299C101.336 244.138 101.23 243.907 101.215 243.607H101.691C101.702 243.76 101.762 243.885 101.868 243.983C101.975 244.079 102.119 244.126 102.301 244.126C102.476 244.126 102.612 244.079 102.707 243.983C102.802 243.885 102.85 243.76 102.85 243.607C102.85 243.406 102.785 243.263 102.655 243.179C102.528 243.093 102.332 243.05 102.067 243.05H101.955V242.643H102.071C102.305 242.64 102.482 242.601 102.603 242.526C102.727 242.451 102.789 242.333 102.789 242.172C102.789 242.034 102.744 241.924 102.655 241.843C102.566 241.76 102.439 241.718 102.275 241.718C102.113 241.718 101.988 241.76 101.898 241.843C101.809 241.924 101.756 242.025 101.738 242.146H101.259Z"
					fill="black"
				/>
				<rect
					x="116.57"
					y="238.942"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M118.222 243.862V243.491L119.675 241.407H120.272V243.434H120.674V243.862H120.272V244.52H119.787V243.862H118.222ZM119.809 241.908L118.789 243.434H119.809V241.908Z"
					fill="black"
				/>
				<rect
					x="31.5469"
					y="249.127"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M35.2758 251.975H33.8274V252.835C33.888 252.755 33.9773 252.687 34.0955 252.632C34.2166 252.577 34.3448 252.55 34.4803 252.55C34.7224 252.55 34.9184 252.602 35.0683 252.706C35.221 252.809 35.3291 252.941 35.3925 253.099C35.4588 253.258 35.492 253.425 35.492 253.601C35.492 253.814 35.4502 254.004 35.3666 254.171C35.2859 254.336 35.1634 254.465 34.9991 254.56C34.8377 254.656 34.6388 254.703 34.4025 254.703C34.0883 254.703 33.8361 254.625 33.6459 254.47C33.4556 254.314 33.3418 254.108 33.3043 253.851H33.7842C33.8159 253.987 33.8865 254.095 33.9961 254.176C34.1056 254.253 34.2425 254.292 34.4068 254.292C34.6114 254.292 34.7642 254.23 34.8651 254.106C34.9688 253.983 35.0207 253.818 35.0207 253.614C35.0207 253.406 34.9688 253.248 34.8651 253.138C34.7613 253.026 34.6085 252.969 34.4068 252.969C34.2655 252.969 34.1459 253.005 34.0479 253.078C33.9528 253.147 33.8836 253.242 33.8404 253.363H33.3735V251.543H35.2758V251.975Z"
					fill="black"
				/>
				<rect
					x="48.5547"
					y="249.127"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M51.962 252.282C51.9303 252.149 51.8726 252.05 51.7891 251.984C51.7055 251.917 51.5887 251.884 51.4389 251.884C51.2112 251.884 51.0411 251.972 50.9287 252.148C50.8163 252.321 50.7572 252.609 50.7514 253.013C50.8264 252.886 50.9359 252.788 51.08 252.719C51.2241 252.649 51.3798 252.615 51.547 252.615C51.7372 252.615 51.9044 252.657 52.0485 252.74C52.1955 252.821 52.3093 252.939 52.39 253.095C52.4736 253.25 52.5154 253.436 52.5154 253.653C52.5154 253.854 52.475 254.034 52.3943 254.193C52.3165 254.351 52.1998 254.477 52.0441 254.569C51.8885 254.658 51.7012 254.703 51.4821 254.703C51.1852 254.703 50.9518 254.638 50.7817 254.509C50.6145 254.376 50.4964 254.19 50.4272 253.951C50.3609 253.712 50.3277 253.413 50.3277 253.056C50.3277 252.001 50.6996 251.474 51.4432 251.474C51.7314 251.474 51.9577 251.551 52.122 251.707C52.2891 251.863 52.3871 252.054 52.416 252.282H51.962ZM51.4389 253.03C51.263 253.03 51.1132 253.083 50.9892 253.19C50.8682 253.294 50.8076 253.445 50.8076 253.644C50.8076 253.843 50.8638 254.001 50.9763 254.119C51.0916 254.235 51.2515 254.292 51.4562 254.292C51.6377 254.292 51.7804 254.236 51.8842 254.124C51.9908 254.011 52.0441 253.861 52.0441 253.674C52.0441 253.478 51.9923 253.323 51.8885 253.207C51.7876 253.089 51.6377 253.03 51.4389 253.03Z"
					fill="black"
				/>
				<rect
					x="65.5547"
					y="249.127"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M69.249 251.932L68.0471 254.703H67.5499L68.7648 251.984H67.1651V251.564H69.249V251.932Z"
					fill="black"
				/>
				<rect
					x="82.5625"
					y="249.127"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M84.7834 253.056C84.4836 252.906 84.3337 252.67 84.3337 252.347C84.3337 252.191 84.3726 252.049 84.4505 251.919C84.5283 251.789 84.645 251.687 84.8007 251.612C84.9563 251.534 85.1465 251.495 85.3714 251.495C85.5933 251.495 85.7821 251.534 85.9377 251.612C86.0963 251.687 86.2144 251.789 86.2922 251.919C86.3701 252.049 86.409 252.191 86.409 252.347C86.409 252.508 86.3672 252.651 86.2836 252.775C86.2029 252.896 86.0948 252.99 85.9593 253.056C86.1236 253.116 86.2533 253.216 86.3485 253.354C86.4436 253.49 86.4911 253.65 86.4911 253.834C86.4911 254.021 86.4436 254.187 86.3485 254.331C86.2533 254.475 86.1208 254.586 85.9507 254.664C85.7806 254.742 85.5875 254.781 85.3714 254.781C85.1552 254.781 84.9621 254.742 84.792 254.664C84.6248 254.586 84.4937 254.475 84.3986 254.331C84.3035 254.187 84.2559 254.021 84.2559 253.834C84.2559 253.647 84.3035 253.485 84.3986 253.35C84.4937 253.214 84.622 253.116 84.7834 253.056ZM85.9377 252.407C85.9377 252.246 85.8873 252.122 85.7864 252.036C85.6855 251.949 85.5472 251.906 85.3714 251.906C85.1984 251.906 85.0615 251.949 84.9606 252.036C84.8598 252.122 84.8093 252.247 84.8093 252.412C84.8093 252.556 84.8612 252.674 84.965 252.766C85.0716 252.856 85.2071 252.9 85.3714 252.9C85.5356 252.9 85.6711 252.854 85.7778 252.762C85.8844 252.67 85.9377 252.552 85.9377 252.407ZM85.3714 253.272C85.1811 253.272 85.0255 253.32 84.9044 253.415C84.7863 253.507 84.7272 253.641 84.7272 253.817C84.7272 253.981 84.7848 254.115 84.9001 254.219C85.0154 254.32 85.1725 254.37 85.3714 254.37C85.5674 254.37 85.7216 254.318 85.834 254.215C85.9493 254.111 86.0069 253.978 86.0069 253.817C86.0069 253.644 85.9478 253.51 85.8296 253.415C85.7144 253.32 85.5616 253.272 85.3714 253.272Z"
					fill="black"
				/>
				<rect
					x="99.5703"
					y="249.126"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M101.881 253.847C101.91 253.991 101.972 254.101 102.067 254.176C102.162 254.251 102.29 254.288 102.452 254.288C102.656 254.288 102.806 254.207 102.901 254.046C102.997 253.885 103.044 253.609 103.044 253.22C102.975 253.318 102.877 253.395 102.75 253.449C102.626 253.501 102.491 253.527 102.344 253.527C102.156 253.527 101.986 253.49 101.834 253.415C101.681 253.337 101.56 253.223 101.47 253.073C101.384 252.92 101.341 252.736 101.341 252.52C101.341 252.203 101.433 251.951 101.617 251.763C101.805 251.573 102.061 251.478 102.387 251.478C102.779 251.478 103.057 251.609 103.221 251.871C103.389 252.131 103.472 252.53 103.472 253.069C103.472 253.441 103.44 253.745 103.377 253.981C103.317 254.217 103.21 254.396 103.057 254.517C102.904 254.638 102.693 254.699 102.422 254.699C102.113 254.699 101.875 254.618 101.708 254.457C101.541 254.295 101.447 254.092 101.427 253.847H101.881ZM102.43 253.112C102.603 253.112 102.739 253.059 102.837 252.952C102.937 252.843 102.988 252.698 102.988 252.52C102.988 252.321 102.935 252.167 102.828 252.057C102.724 251.945 102.582 251.889 102.4 251.889C102.218 251.889 102.074 251.946 101.968 252.062C101.864 252.174 101.812 252.322 101.812 252.507C101.812 252.683 101.862 252.828 101.963 252.943C102.067 253.056 102.223 253.112 102.43 253.112Z"
					fill="black"
				/>
				<rect
					x="116.57"
					y="249.127"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M118.218 252.001V251.551H119.117V254.703H118.62V252.001H118.218ZM119.924 253.086C119.924 252.588 120.008 252.198 120.175 251.919C120.345 251.636 120.636 251.495 121.048 251.495C121.46 251.495 121.75 251.636 121.917 251.919C122.087 252.198 122.172 252.588 122.172 253.086C122.172 253.591 122.087 253.985 121.917 254.271C121.75 254.553 121.46 254.694 121.048 254.694C120.636 254.694 120.345 254.553 120.175 254.271C120.008 253.985 119.924 253.591 119.924 253.086ZM121.688 253.086C121.688 252.853 121.672 252.655 121.64 252.494C121.612 252.332 121.551 252.201 121.459 252.1C121.367 251.997 121.23 251.945 121.048 251.945C120.867 251.945 120.73 251.997 120.637 252.1C120.545 252.201 120.483 252.332 120.452 252.494C120.423 252.655 120.408 252.853 120.408 253.086C120.408 253.328 120.423 253.531 120.452 253.696C120.48 253.86 120.541 253.993 120.633 254.094C120.728 254.194 120.867 254.245 121.048 254.245C121.23 254.245 121.367 254.194 121.459 254.094C121.554 253.993 121.616 253.86 121.645 253.696C121.674 253.531 121.688 253.328 121.688 253.086Z"
					fill="black"
				/>
				<rect
					x="31.5469"
					y="259.31"
					width="2.59552"
					height="7.78216"
					rx="1.29776"
					fill="#C5B8FB"
				/>
				<rect
					x="31.5469"
					y="259.31"
					width="7.78216"
					height="7.78216"
					fill="white"
				/>
				<path
					d="M33.1789 262.184V261.734H34.0782V264.886H33.581V262.184H33.1789ZM34.8201 262.184V261.734H35.7194V264.886H35.2222V262.184H34.8201Z"
					fill="black"
				/>
				<rect
					x="48.5547"
					y="259.31"
					width="7.78216"
					height="7.78216"
					fill="white"
				/>
				<path
					d="M50.2024 262.184V261.734H51.1016V264.886H50.6044V262.184H50.2024ZM52.1808 264.216C52.4575 263.976 52.6751 263.78 52.8336 263.628C52.995 263.472 53.1291 263.311 53.2357 263.143C53.3424 262.976 53.3957 262.809 53.3957 262.642C53.3957 262.469 53.3539 262.333 53.2703 262.235C53.1896 262.137 53.0613 262.088 52.8855 262.088C52.7155 262.088 52.5829 262.143 52.4878 262.253C52.3955 262.359 52.3465 262.504 52.3408 262.685H51.8652C51.8738 262.357 51.9718 262.106 52.1592 261.933C52.3494 261.757 52.5901 261.669 52.8812 261.669C53.1954 261.669 53.4404 261.756 53.6162 261.929C53.7949 262.101 53.8842 262.332 53.8842 262.62C53.8842 262.828 53.8309 263.028 53.7243 263.221C53.6205 263.411 53.4951 263.583 53.3481 263.736C53.204 263.886 53.0195 264.06 52.7947 264.259L52.6002 264.432H53.9707V264.843H51.8695V264.484L52.1808 264.216Z"
					fill="black"
				/>
				<rect
					x="65.5547"
					y="259.31"
					width="7.78216"
					height="7.78216"
					fill="white"
				/>
				<path
					d="M67.1867 262.184V261.734H68.086V264.886H67.5888V262.184H67.1867ZM68.8842 262.512C68.9015 262.244 69.0038 262.035 69.1911 261.885C69.3814 261.735 69.6235 261.66 69.9175 261.66C70.1192 261.66 70.2936 261.696 70.4406 261.769C70.5876 261.841 70.6986 261.939 70.7735 262.063C70.8484 262.186 70.8859 262.326 70.8859 262.482C70.8859 262.661 70.8383 262.813 70.7432 262.94C70.6481 263.067 70.5343 263.152 70.4017 263.195V263.213C70.5717 263.264 70.7043 263.36 70.7994 263.498C70.8945 263.633 70.9421 263.808 70.9421 264.021C70.9421 264.191 70.9032 264.342 70.8254 264.475C70.7476 264.608 70.6323 264.713 70.4795 264.791C70.3267 264.866 70.1437 264.903 69.9304 264.903C69.6191 264.903 69.3626 264.824 69.1609 264.665C68.962 264.504 68.8553 264.273 68.8409 263.974H69.3165C69.328 264.126 69.3871 264.252 69.4938 264.35C69.6004 264.445 69.7445 264.492 69.9261 264.492C70.1019 264.492 70.2374 264.445 70.3325 264.35C70.4276 264.252 70.4752 264.126 70.4752 263.974C70.4752 263.772 70.4103 263.629 70.2806 263.545C70.1538 263.459 69.9578 263.416 69.6926 263.416H69.5802V263.009H69.697C69.9304 263.006 70.1077 262.968 70.2287 262.893C70.3527 262.818 70.4146 262.7 70.4146 262.538C70.4146 262.4 70.37 262.29 70.2806 262.21C70.1913 262.126 70.0645 262.084 69.9002 262.084C69.7388 262.084 69.6134 262.126 69.524 262.21C69.4347 262.29 69.3814 262.391 69.3641 262.512H68.8842Z"
					fill="black"
				/>
				<rect
					x="82.5625"
					y="259.31"
					width="7.78216"
					height="7.78216"
					fill="white"
				/>
				<path
					d="M84.1867 262.184V261.734H85.086V264.886H84.5888V262.184H84.1867ZM85.8323 264.229V263.857L87.2849 261.773H87.8816V263.801H88.2837V264.229H87.8816V264.886H87.3974V264.229H85.8323ZM87.419 262.274L86.3986 263.801H87.419V262.274Z"
					fill="black"
				/>
				<rect
					x="99.5703"
					y="259.31"
					width="7.78216"
					height="7.78216"
					fill="white"
				/>
				<path
					d="M101.202 262.184V261.734H102.102V264.886H101.604V262.184H101.202ZM104.94 262.158H103.492V263.018C103.553 262.937 103.642 262.87 103.76 262.815C103.881 262.76 104.009 262.733 104.145 262.733C104.387 262.733 104.583 262.785 104.733 262.888C104.886 262.992 104.994 263.123 105.057 263.282C105.123 263.44 105.157 263.607 105.157 263.783C105.157 263.997 105.115 264.187 105.031 264.354C104.951 264.518 104.828 264.648 104.664 264.743C104.502 264.838 104.303 264.886 104.067 264.886C103.753 264.886 103.501 264.808 103.311 264.652C103.12 264.497 103.006 264.291 102.969 264.034H103.449C103.481 264.169 103.551 264.278 103.661 264.358C103.77 264.436 103.907 264.475 104.071 264.475C104.276 264.475 104.429 264.413 104.53 264.289C104.633 264.165 104.685 264.001 104.685 263.796C104.685 263.589 104.633 263.43 104.53 263.321C104.426 263.208 104.273 263.152 104.071 263.152C103.93 263.152 103.811 263.188 103.713 263.26C103.617 263.329 103.548 263.424 103.505 263.545H103.038V261.725H104.94V262.158Z"
					fill="black"
				/>
				<rect
					x="116.57"
					y="259.31"
					width="7.78216"
					height="7.78216"
					fill="#C5B8FB"
				/>
				<path
					d="M118.218 262.184V261.734H119.117V264.886H118.62V262.184H118.218ZM121.619 262.465C121.587 262.332 121.529 262.233 121.446 262.166C121.362 262.1 121.246 262.067 121.096 262.067C120.868 262.067 120.698 262.155 120.586 262.331C120.473 262.504 120.414 262.792 120.408 263.195C120.483 263.068 120.593 262.97 120.737 262.901C120.881 262.832 121.037 262.798 121.204 262.798C121.394 262.798 121.561 262.839 121.705 262.923C121.852 263.004 121.966 263.122 122.047 263.277C122.13 263.433 122.172 263.619 122.172 263.835C122.172 264.037 122.132 264.217 122.051 264.376C121.973 264.534 121.857 264.659 121.701 264.752C121.545 264.841 121.358 264.886 121.139 264.886C120.842 264.886 120.609 264.821 120.439 264.691C120.271 264.559 120.153 264.373 120.084 264.133C120.018 263.894 119.985 263.596 119.985 263.239C119.985 262.184 120.356 261.656 121.1 261.656C121.388 261.656 121.615 261.734 121.779 261.89C121.946 262.045 122.044 262.237 122.073 262.465H121.619ZM121.096 263.213C120.92 263.213 120.77 263.266 120.646 263.373C120.525 263.476 120.464 263.628 120.464 263.827C120.464 264.025 120.521 264.184 120.633 264.302C120.748 264.417 120.908 264.475 121.113 264.475C121.295 264.475 121.437 264.419 121.541 264.306C121.648 264.194 121.701 264.044 121.701 263.857C121.701 263.661 121.649 263.505 121.545 263.39C121.444 263.272 121.295 263.213 121.096 263.213Z"
					fill="black"
				/>
				<rect
					x="31.5469"
					y="269.493"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M33.1789 272.366V271.917H34.0782V275.068H33.581V272.366H33.1789ZM36.8824 272.297L35.6805 275.068H35.1833L36.3982 272.349H34.7985V271.93H36.8824V272.297Z"
					fill="black"
				/>
				<rect
					x="48.5547"
					y="269.493"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M50.2024 272.366V271.917H51.1016V275.068H50.6044V272.366H50.2024ZM52.4402 273.421C52.1405 273.271 51.9906 273.035 51.9906 272.712C51.9906 272.556 52.0295 272.414 52.1073 272.284C52.1851 272.154 52.3019 272.052 52.4575 271.977C52.6131 271.899 52.8034 271.86 53.0282 271.86C53.2501 271.86 53.4389 271.899 53.5946 271.977C53.7531 272.052 53.8713 272.154 53.9491 272.284C54.0269 272.414 54.0658 272.556 54.0658 272.712C54.0658 272.874 54.024 273.016 53.9404 273.14C53.8597 273.261 53.7516 273.355 53.6162 273.421C53.7805 273.482 53.9102 273.581 54.0053 273.719C54.1004 273.855 54.148 274.015 54.148 274.199C54.148 274.387 54.1004 274.552 54.0053 274.697C53.9102 274.841 53.7776 274.952 53.6075 275.029C53.4375 275.107 53.2444 275.146 53.0282 275.146C52.812 275.146 52.6189 275.107 52.4489 275.029C52.2817 274.952 52.1505 274.841 52.0554 274.697C51.9603 274.552 51.9128 274.387 51.9128 274.199C51.9128 274.012 51.9603 273.851 52.0554 273.715C52.1505 273.58 52.2788 273.482 52.4402 273.421ZM53.5946 272.773C53.5946 272.611 53.5441 272.487 53.4432 272.401C53.3424 272.314 53.204 272.271 53.0282 272.271C52.8553 272.271 52.7184 272.314 52.6175 272.401C52.5166 272.487 52.4662 272.613 52.4662 272.777C52.4662 272.921 52.518 273.039 52.6218 273.131C52.7284 273.221 52.8639 273.265 53.0282 273.265C53.1925 273.265 53.328 273.219 53.4346 273.127C53.5412 273.035 53.5946 272.917 53.5946 272.773ZM53.0282 273.637C52.838 273.637 52.6823 273.685 52.5613 273.78C52.4431 273.872 52.384 274.006 52.384 274.182C52.384 274.346 52.4417 274.48 52.5569 274.584C52.6722 274.685 52.8293 274.735 53.0282 274.735C53.2242 274.735 53.3784 274.684 53.4908 274.58C53.6061 274.476 53.6637 274.343 53.6637 274.182C53.6637 274.009 53.6047 273.875 53.4865 273.78C53.3712 273.685 53.2184 273.637 53.0282 273.637Z"
					fill="black"
				/>
				<rect
					x="65.5547"
					y="269.493"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M67.1867 272.366V271.917H68.086V275.068H67.5888V272.366H67.1867ZM69.5067 274.212C69.5356 274.356 69.5975 274.466 69.6926 274.541C69.7878 274.616 69.916 274.653 70.0774 274.653C70.2821 274.653 70.4319 274.573 70.5271 274.411C70.6222 274.25 70.6697 273.975 70.6697 273.585C70.6006 273.683 70.5026 273.76 70.3757 273.815C70.2518 273.866 70.1163 273.892 69.9693 273.892C69.782 273.892 69.6119 273.855 69.4592 273.78C69.3064 273.702 69.1854 273.588 69.096 273.438C69.0095 273.286 68.9663 273.101 68.9663 272.885C68.9663 272.568 69.0585 272.316 69.243 272.128C69.4303 271.938 69.6869 271.843 70.0126 271.843C70.4046 271.843 70.6827 271.974 70.847 272.237C71.0142 272.496 71.0977 272.895 71.0977 273.434C71.0977 273.806 71.066 274.11 71.0026 274.346C70.9421 274.583 70.8355 274.761 70.6827 274.882C70.5299 275.004 70.3181 275.064 70.0472 275.064C69.7388 275.064 69.501 274.983 69.3338 274.822C69.1666 274.661 69.0729 274.457 69.0528 274.212H69.5067ZM70.0558 273.477C70.2287 273.477 70.3642 273.424 70.4622 273.317C70.5631 273.208 70.6135 273.064 70.6135 272.885C70.6135 272.686 70.5602 272.532 70.4536 272.422C70.3498 272.31 70.2071 272.254 70.0255 272.254C69.844 272.254 69.6998 272.311 69.5932 272.427C69.4894 272.539 69.4376 272.688 69.4376 272.872C69.4376 273.048 69.488 273.193 69.5889 273.309C69.6926 273.421 69.8483 273.477 70.0558 273.477Z"
					fill="black"
				/>
				<rect
					x="82.5625"
					y="269.493"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M84.524 274.398C84.8007 274.159 85.0183 273.963 85.1768 273.81C85.3382 273.655 85.4722 273.493 85.5789 273.326C85.6855 273.159 85.7388 272.992 85.7388 272.825C85.7388 272.652 85.6971 272.516 85.6135 272.418C85.5328 272.32 85.4045 272.271 85.2287 272.271C85.0586 272.271 84.926 272.326 84.8309 272.435C84.7387 272.542 84.6897 272.686 84.6839 272.868H84.2084C84.217 272.539 84.315 272.288 84.5024 272.115C84.6926 271.94 84.9333 271.852 85.2244 271.852C85.5385 271.852 85.7835 271.938 85.9593 272.111C86.138 272.284 86.2274 272.515 86.2274 272.803C86.2274 273.01 86.1741 273.211 86.0674 273.404C85.9637 273.594 85.8383 273.766 85.6913 273.918C85.5472 274.068 85.3627 274.243 85.1379 274.441L84.9433 274.614H86.3139V275.025H84.2127V274.666L84.524 274.398ZM86.8766 273.451C86.8766 272.953 86.9601 272.564 87.1273 272.284C87.2974 272.002 87.5885 271.86 88.0006 271.86C88.4128 271.86 88.7025 272.002 88.8696 272.284C89.0397 272.564 89.1247 272.953 89.1247 273.451C89.1247 273.956 89.0397 274.351 88.8696 274.636C88.7025 274.918 88.4128 275.06 88.0006 275.06C87.5885 275.06 87.2974 274.918 87.1273 274.636C86.9601 274.351 86.8766 273.956 86.8766 273.451ZM88.6405 273.451C88.6405 273.218 88.6247 273.02 88.5929 272.859C88.5641 272.698 88.5036 272.567 88.4114 272.466C88.3191 272.362 88.1822 272.31 88.0006 272.31C87.8191 272.31 87.6821 272.362 87.5899 272.466C87.4977 272.567 87.4357 272.698 87.404 272.859C87.3752 273.02 87.3608 273.218 87.3608 273.451C87.3608 273.694 87.3752 273.897 87.404 274.061C87.4328 274.225 87.4934 274.358 87.5856 274.459C87.6807 274.56 87.8191 274.61 88.0006 274.61C88.1822 274.61 88.3191 274.56 88.4114 274.459C88.5065 274.358 88.5685 274.225 88.5973 274.061C88.6261 273.897 88.6405 273.694 88.6405 273.451Z"
					fill="black"
				/>
				<rect
					x="99.5703"
					y="269.493"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M101.54 274.398C101.816 274.159 102.034 273.963 102.192 273.81C102.354 273.655 102.488 273.493 102.595 273.326C102.701 273.159 102.754 272.992 102.754 272.825C102.754 272.652 102.713 272.516 102.629 272.418C102.548 272.32 102.42 272.271 102.244 272.271C102.074 272.271 101.942 272.326 101.847 272.435C101.754 272.542 101.705 272.686 101.7 272.868H101.224C101.233 272.539 101.331 272.288 101.518 272.115C101.708 271.94 101.949 271.852 102.24 271.852C102.554 271.852 102.799 271.938 102.975 272.111C103.154 272.284 103.243 272.515 103.243 272.803C103.243 273.01 103.19 273.211 103.083 273.404C102.979 273.594 102.854 273.766 102.707 273.918C102.563 274.068 102.378 274.243 102.154 274.441L101.959 274.614H103.329V275.025H101.228V274.666L101.54 274.398ZM103.827 272.366V271.917H104.727V275.068H104.229V272.366H103.827Z"
					fill="black"
				/>
				<rect
					x="116.57"
					y="269.493"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M118.555 274.398C118.832 274.159 119.05 273.963 119.208 273.81C119.369 273.655 119.503 273.493 119.61 273.326C119.717 273.159 119.77 272.992 119.77 272.825C119.77 272.652 119.728 272.516 119.645 272.418C119.564 272.32 119.436 272.271 119.26 272.271C119.09 272.271 118.957 272.326 118.862 272.435C118.77 272.542 118.721 272.686 118.715 272.868H118.24C118.248 272.539 118.346 272.288 118.534 272.115C118.724 271.94 118.965 271.852 119.256 271.852C119.57 271.852 119.815 271.938 119.991 272.111C120.169 272.284 120.259 272.515 120.259 272.803C120.259 273.01 120.205 273.211 120.099 273.404C119.995 273.594 119.87 273.766 119.723 273.918C119.578 274.068 119.394 274.243 119.169 274.441L118.975 274.614H120.345V275.025H118.244V274.666L118.555 274.398ZM121.18 274.398C121.457 274.159 121.674 273.963 121.833 273.81C121.994 273.655 122.128 273.493 122.235 273.326C122.342 273.159 122.395 272.992 122.395 272.825C122.395 272.652 122.353 272.516 122.27 272.418C122.189 272.32 122.061 272.271 121.885 272.271C121.715 272.271 121.582 272.326 121.487 272.435C121.395 272.542 121.346 272.686 121.34 272.868H120.865C120.873 272.539 120.971 272.288 121.159 272.115C121.349 271.94 121.589 271.852 121.881 271.852C122.195 271.852 122.44 271.938 122.616 272.111C122.794 272.284 122.884 272.515 122.884 272.803C122.884 273.01 122.83 273.211 122.724 273.404C122.62 273.594 122.494 273.766 122.348 273.918C122.203 274.068 122.019 274.243 121.794 274.441L121.6 274.614H122.97V275.025H120.869V274.666L121.18 274.398Z"
					fill="black"
				/>
				<rect
					x="31.5469"
					y="279.676"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M33.5162 284.582C33.7929 284.343 34.0105 284.147 34.169 283.994C34.3304 283.838 34.4644 283.677 34.5711 283.51C34.6777 283.342 34.731 283.175 34.731 283.008C34.731 282.835 34.6892 282.7 34.6057 282.602C34.525 282.504 34.3967 282.455 34.2209 282.455C34.0508 282.455 33.9182 282.509 33.8231 282.619C33.7309 282.726 33.6819 282.87 33.6761 283.051H33.2005C33.2092 282.723 33.3072 282.472 33.4945 282.299C33.6848 282.123 33.9254 282.035 34.2166 282.035C34.5307 282.035 34.7757 282.122 34.9515 282.295C35.1302 282.468 35.2196 282.698 35.2196 282.986C35.2196 283.194 35.1663 283.394 35.0596 283.587C34.9559 283.778 34.8305 283.949 34.6835 284.102C34.5394 284.252 34.3549 284.426 34.1301 284.625L33.9355 284.798H35.3061V285.209H33.2049V284.85L33.5162 284.582ZM35.8601 282.878C35.8774 282.61 35.9797 282.401 36.1671 282.251C36.3573 282.102 36.5994 282.027 36.8934 282.027C37.0951 282.027 37.2695 282.063 37.4165 282.135C37.5635 282.207 37.6745 282.305 37.7494 282.429C37.8244 282.553 37.8618 282.692 37.8618 282.848C37.8618 283.027 37.8143 283.18 37.7192 283.306C37.624 283.433 37.5102 283.518 37.3776 283.561V283.579C37.5477 283.631 37.6803 283.726 37.7754 283.864C37.8705 284 37.918 284.174 37.918 284.387C37.918 284.557 37.8791 284.709 37.8013 284.841C37.7235 284.974 37.6082 285.079 37.4554 285.157C37.3027 285.232 37.1196 285.269 36.9064 285.269C36.5951 285.269 36.3386 285.19 36.1368 285.031C35.9379 284.87 35.8313 284.639 35.8169 284.34H36.2924C36.304 284.492 36.3631 284.618 36.4697 284.716C36.5763 284.811 36.7205 284.859 36.902 284.859C37.0779 284.859 37.2133 284.811 37.3084 284.716C37.4036 284.618 37.4511 284.492 37.4511 284.34C37.4511 284.138 37.3863 283.995 37.2566 283.912C37.1297 283.825 36.9337 283.782 36.6686 283.782H36.5562V283.376H36.6729C36.9064 283.373 37.0836 283.334 37.2047 283.259C37.3286 283.184 37.3906 283.066 37.3906 282.904C37.3906 282.766 37.3459 282.656 37.2566 282.576C37.1672 282.492 37.0404 282.45 36.8761 282.45C36.7147 282.45 36.5893 282.492 36.5 282.576C36.4106 282.656 36.3573 282.757 36.34 282.878H35.8601Z"
					fill="black"
				/>
				<rect
					x="48.5547"
					y="279.676"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M50.5396 284.582C50.8163 284.343 51.0339 284.147 51.1924 283.994C51.3538 283.838 51.4879 283.677 51.5945 283.51C51.7012 283.342 51.7545 283.175 51.7545 283.008C51.7545 282.835 51.7127 282.7 51.6291 282.602C51.5484 282.504 51.4201 282.455 51.2443 282.455C51.0743 282.455 50.9417 282.509 50.8466 282.619C50.7543 282.726 50.7053 282.87 50.6996 283.051H50.224C50.2326 282.723 50.3306 282.472 50.518 282.299C50.7082 282.123 50.9489 282.035 51.24 282.035C51.5542 282.035 51.7992 282.122 51.975 282.295C52.1537 282.468 52.243 282.698 52.243 282.986C52.243 283.194 52.1897 283.394 52.0831 283.587C51.9793 283.778 51.8539 283.949 51.7069 284.102C51.5628 284.252 51.3783 284.426 51.1535 284.625L50.959 284.798H52.3295V285.209H50.2283V284.85L50.5396 284.582ZM52.8316 284.595V284.223L54.2843 282.139H54.881V284.167H55.283V284.595H54.881V285.252H54.3967V284.595H52.8316ZM54.4183 282.641L53.398 284.167H54.4183V282.641Z"
					fill="black"
				/>
				<rect
					x="65.5547"
					y="279.676"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M67.524 284.582C67.8007 284.343 68.0183 284.147 68.1768 283.994C68.3382 283.838 68.4722 283.677 68.5789 283.51C68.6855 283.342 68.7388 283.175 68.7388 283.008C68.7388 282.835 68.6971 282.7 68.6135 282.602C68.5328 282.504 68.4045 282.455 68.2287 282.455C68.0586 282.455 67.926 282.509 67.8309 282.619C67.7387 282.726 67.6897 282.87 67.6839 283.051H67.2084C67.217 282.723 67.315 282.472 67.5024 282.299C67.6926 282.123 67.9333 282.035 68.2244 282.035C68.5385 282.035 68.7835 282.122 68.9593 282.295C69.138 282.468 69.2274 282.698 69.2274 282.986C69.2274 283.194 69.1741 283.394 69.0674 283.587C68.9637 283.778 68.8383 283.949 68.6913 284.102C68.5472 284.252 68.3627 284.426 68.1379 284.625L67.9433 284.798H69.3139V285.209H67.2127V284.85L67.524 284.582ZM71.9086 282.524H70.4602V283.384C70.5207 283.304 70.6101 283.236 70.7283 283.181C70.8493 283.126 70.9776 283.099 71.113 283.099C71.3552 283.099 71.5512 283.151 71.701 283.255C71.8538 283.358 71.9619 283.489 72.0253 283.648C72.0916 283.806 72.1247 283.974 72.1247 284.149C72.1247 284.363 72.0829 284.553 71.9994 284.72C71.9186 284.884 71.7962 285.014 71.6319 285.109C71.4705 285.204 71.2716 285.252 71.0352 285.252C70.7211 285.252 70.4689 285.174 70.2786 285.018C70.0884 284.863 69.9745 284.657 69.9371 284.4H70.417C70.4487 284.536 70.5193 284.644 70.6288 284.724C70.7384 284.802 70.8753 284.841 71.0396 284.841C71.2442 284.841 71.397 284.779 71.4978 284.655C71.6016 284.531 71.6535 284.367 71.6535 284.162C71.6535 283.955 71.6016 283.796 71.4978 283.687C71.3941 283.574 71.2413 283.518 71.0396 283.518C70.8983 283.518 70.7787 283.554 70.6807 283.626C70.5856 283.696 70.5164 283.791 70.4732 283.912H70.0063V282.092H71.9086V282.524Z"
					fill="black"
				/>
				<rect
					x="82.5625"
					y="279.676"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M84.524 284.582C84.8007 284.343 85.0183 284.147 85.1768 283.994C85.3382 283.838 85.4722 283.677 85.5789 283.51C85.6855 283.342 85.7388 283.175 85.7388 283.008C85.7388 282.835 85.6971 282.7 85.6135 282.602C85.5328 282.504 85.4045 282.455 85.2287 282.455C85.0586 282.455 84.926 282.509 84.8309 282.619C84.7387 282.726 84.6897 282.87 84.6839 283.051H84.2084C84.217 282.723 84.315 282.472 84.5024 282.299C84.6926 282.123 84.9333 282.035 85.2244 282.035C85.5385 282.035 85.7835 282.122 85.9593 282.295C86.138 282.468 86.2274 282.698 86.2274 282.986C86.2274 283.194 86.1741 283.394 86.0674 283.587C85.9637 283.778 85.8383 283.949 85.6913 284.102C85.5472 284.252 85.3627 284.426 85.1379 284.625L84.9433 284.798H86.3139V285.209H84.2127V284.85L84.524 284.582ZM88.5713 282.831C88.5396 282.698 88.482 282.599 88.3984 282.533C88.3148 282.466 88.1981 282.433 88.0482 282.433C87.8205 282.433 87.6504 282.521 87.538 282.697C87.4256 282.87 87.3665 283.158 87.3608 283.561C87.4357 283.435 87.5452 283.337 87.6894 283.268C87.8335 283.198 87.9891 283.164 88.1563 283.164C88.3465 283.164 88.5137 283.206 88.6578 283.289C88.8048 283.37 88.9186 283.488 88.9994 283.644C89.0829 283.799 89.1247 283.985 89.1247 284.201C89.1247 284.403 89.0844 284.583 89.0037 284.742C88.9259 284.9 88.8091 285.026 88.6535 285.118C88.4978 285.207 88.3105 285.252 88.0914 285.252C87.7946 285.252 87.5611 285.187 87.391 285.057C87.2239 284.925 87.1057 284.739 87.0365 284.5C86.9702 284.26 86.9371 283.962 86.9371 283.605C86.9371 282.55 87.3089 282.022 88.0525 282.022C88.3408 282.022 88.567 282.1 88.7313 282.256C88.8985 282.411 88.9965 282.603 89.0253 282.831H88.5713ZM88.0482 283.579C87.8724 283.579 87.7225 283.632 87.5986 283.739C87.4775 283.843 87.417 283.994 87.417 284.193C87.417 284.392 87.4732 284.55 87.5856 284.668C87.7009 284.784 87.8609 284.841 88.0655 284.841C88.2471 284.841 88.3897 284.785 88.4935 284.673C88.6002 284.56 88.6535 284.41 88.6535 284.223C88.6535 284.027 88.6016 283.871 88.4978 283.756C88.397 283.638 88.2471 283.579 88.0482 283.579Z"
					fill="black"
				/>
				<rect
					x="99.5703"
					y="279.676"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M101.54 284.582C101.816 284.343 102.034 284.147 102.192 283.994C102.354 283.838 102.488 283.677 102.595 283.51C102.701 283.342 102.754 283.175 102.754 283.008C102.754 282.835 102.713 282.7 102.629 282.602C102.548 282.504 102.42 282.455 102.244 282.455C102.074 282.455 101.942 282.509 101.847 282.619C101.754 282.726 101.705 282.87 101.7 283.051H101.224C101.233 282.723 101.331 282.472 101.518 282.299C101.708 282.123 101.949 282.035 102.24 282.035C102.554 282.035 102.799 282.122 102.975 282.295C103.154 282.468 103.243 282.698 103.243 282.986C103.243 283.194 103.19 283.394 103.083 283.587C102.979 283.778 102.854 283.949 102.707 284.102C102.563 284.252 102.378 284.426 102.154 284.625L101.959 284.798H103.329V285.209H101.228V284.85L101.54 284.582ZM105.89 282.481L104.688 285.252H104.19L105.405 282.533H103.806V282.113H105.89V282.481Z"
					fill="black"
				/>
				<rect
					x="116.57"
					y="279.676"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M118.555 284.582C118.832 284.343 119.05 284.147 119.208 283.994C119.369 283.838 119.503 283.677 119.61 283.51C119.717 283.342 119.77 283.175 119.77 283.008C119.77 282.835 119.728 282.7 119.645 282.602C119.564 282.504 119.436 282.455 119.26 282.455C119.09 282.455 118.957 282.509 118.862 282.619C118.77 282.726 118.721 282.87 118.715 283.051H118.24C118.248 282.723 118.346 282.472 118.534 282.299C118.724 282.123 118.965 282.035 119.256 282.035C119.57 282.035 119.815 282.122 119.991 282.295C120.169 282.468 120.259 282.698 120.259 282.986C120.259 283.194 120.205 283.394 120.099 283.587C119.995 283.778 119.87 283.949 119.723 284.102C119.578 284.252 119.394 284.426 119.169 284.625L118.975 284.798H120.345V285.209H118.244V284.85L118.555 284.582ZM121.44 283.605C121.14 283.455 120.99 283.219 120.99 282.896C120.99 282.74 121.029 282.597 121.107 282.468C121.185 282.338 121.301 282.236 121.457 282.161C121.613 282.083 121.803 282.044 122.028 282.044C122.25 282.044 122.438 282.083 122.594 282.161C122.752 282.236 122.871 282.338 122.948 282.468C123.026 282.597 123.065 282.74 123.065 282.896C123.065 283.057 123.023 283.2 122.94 283.324C122.859 283.445 122.751 283.538 122.616 283.605C122.78 283.665 122.91 283.765 123.005 283.903C123.1 284.039 123.147 284.198 123.147 284.383C123.147 284.57 123.1 284.736 123.005 284.88C122.91 285.024 122.777 285.135 122.607 285.213C122.437 285.291 122.244 285.33 122.028 285.33C121.811 285.33 121.618 285.291 121.448 285.213C121.281 285.135 121.15 285.024 121.055 284.88C120.96 284.736 120.912 284.57 120.912 284.383C120.912 284.196 120.96 284.034 121.055 283.899C121.15 283.763 121.278 283.665 121.44 283.605ZM122.594 282.956C122.594 282.795 122.543 282.671 122.443 282.584C122.342 282.498 122.203 282.455 122.028 282.455C121.855 282.455 121.718 282.498 121.617 282.584C121.516 282.671 121.466 282.796 121.466 282.961C121.466 283.105 121.517 283.223 121.621 283.315C121.728 283.404 121.863 283.449 122.028 283.449C122.192 283.449 122.327 283.403 122.434 283.311C122.541 283.219 122.594 283.1 122.594 282.956ZM122.028 283.821C121.837 283.821 121.682 283.868 121.561 283.964C121.442 284.056 121.383 284.19 121.383 284.366C121.383 284.53 121.441 284.664 121.556 284.768C121.672 284.869 121.829 284.919 122.028 284.919C122.224 284.919 122.378 284.867 122.49 284.763C122.605 284.66 122.663 284.527 122.663 284.366C122.663 284.193 122.604 284.059 122.486 283.964C122.371 283.868 122.218 283.821 122.028 283.821Z"
					fill="black"
				/>
				<rect
					x="31.5469"
					y="289.859"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M33.5162 294.765C33.7929 294.526 34.0105 294.33 34.169 294.177C34.3304 294.022 34.4644 293.86 34.5711 293.693C34.6777 293.526 34.731 293.359 34.731 293.192C34.731 293.019 34.6892 292.883 34.6057 292.785C34.525 292.687 34.3967 292.638 34.2209 292.638C34.0508 292.638 33.9182 292.693 33.8231 292.803C33.7309 292.909 33.6819 293.053 33.6761 293.235H33.2005C33.2092 292.906 33.3072 292.656 33.4945 292.483C33.6848 292.307 33.9254 292.219 34.2166 292.219C34.5307 292.219 34.7757 292.305 34.9515 292.478C35.1302 292.651 35.2196 292.882 35.2196 293.17C35.2196 293.378 35.1663 293.578 35.0596 293.771C34.9559 293.961 34.8305 294.133 34.6835 294.286C34.5394 294.435 34.3549 294.61 34.1301 294.809L33.9355 294.982H35.3061V295.392H33.2049V295.033L33.5162 294.765ZM36.4827 294.58C36.5115 294.724 36.5735 294.833 36.6686 294.908C36.7637 294.983 36.8919 295.02 37.0534 295.02C37.258 295.02 37.4079 294.94 37.503 294.778C37.5981 294.617 37.6457 294.342 37.6457 293.953C37.5765 294.051 37.4785 294.127 37.3517 294.182C37.2277 294.234 37.0923 294.26 36.9453 294.26C36.7579 294.26 36.5879 294.222 36.4351 294.147C36.2823 294.069 36.1613 293.955 36.0719 293.806C35.9855 293.653 35.9422 293.468 35.9422 293.252C35.9422 292.935 36.0345 292.683 36.2189 292.496C36.4063 292.305 36.6628 292.21 36.9885 292.21C37.3805 292.21 37.6586 292.341 37.8229 292.604C37.9901 292.863 38.0737 293.262 38.0737 293.801C38.0737 294.173 38.042 294.477 37.9786 294.714C37.918 294.95 37.8114 295.129 37.6586 295.25C37.5059 295.371 37.294 295.431 37.0231 295.431C36.7147 295.431 36.4769 295.351 36.3097 295.189C36.1426 295.028 36.0489 294.825 36.0287 294.58H36.4827ZM37.0317 293.845C37.2047 293.845 37.3401 293.791 37.4381 293.685C37.539 293.575 37.5895 293.431 37.5895 293.252C37.5895 293.053 37.5361 292.899 37.4295 292.79C37.3257 292.677 37.1831 292.621 37.0015 292.621C36.8199 292.621 36.6758 292.679 36.5691 292.794C36.4654 292.906 36.4135 293.055 36.4135 293.239C36.4135 293.415 36.4639 293.561 36.5648 293.676C36.6686 293.788 36.8242 293.845 37.0317 293.845Z"
					fill="black"
				/>
				<rect
					x="48.5547"
					y="289.859"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M50.2586 293.062C50.2759 292.794 50.3782 292.585 50.5655 292.435C50.7558 292.285 50.9979 292.21 51.2919 292.21C51.4936 292.21 51.668 292.246 51.815 292.318C51.962 292.39 52.073 292.488 52.1479 292.612C52.2228 292.736 52.2603 292.876 52.2603 293.032C52.2603 293.21 52.2128 293.363 52.1176 293.49C52.0225 293.617 51.9087 293.702 51.7761 293.745V293.762C51.9461 293.814 52.0787 293.909 52.1738 294.048C52.269 294.183 52.3165 294.358 52.3165 294.571C52.3165 294.741 52.2776 294.892 52.1998 295.025C52.122 295.157 52.0067 295.263 51.8539 295.34C51.7012 295.415 51.5181 295.453 51.3048 295.453C50.9936 295.453 50.737 295.374 50.5353 295.215C50.3364 295.054 50.2297 294.823 50.2153 294.523H50.6909C50.7024 294.676 50.7615 294.801 50.8682 294.899C50.9748 294.995 51.1189 295.042 51.3005 295.042C51.4763 295.042 51.6118 294.995 51.7069 294.899C51.802 294.801 51.8496 294.676 51.8496 294.523C51.8496 294.322 51.7847 294.179 51.655 294.095C51.5282 294.009 51.3322 293.966 51.0671 293.966H50.9546V293.559H51.0714C51.3048 293.556 51.4821 293.517 51.6032 293.442C51.7271 293.368 51.7891 293.249 51.7891 293.088C51.7891 292.95 51.7444 292.84 51.655 292.759C51.5657 292.676 51.4389 292.634 51.2746 292.634C51.1132 292.634 50.9878 292.676 50.8984 292.759C50.8091 292.84 50.7558 292.941 50.7385 293.062H50.2586ZM52.964 293.819C52.964 293.32 53.0475 292.931 53.2147 292.651C53.3848 292.369 53.6759 292.228 54.088 292.228C54.5002 292.228 54.7899 292.369 54.957 292.651C55.1271 292.931 55.2121 293.32 55.2121 293.819C55.2121 294.323 55.1271 294.718 54.957 295.003C54.7899 295.286 54.5002 295.427 54.088 295.427C53.6759 295.427 53.3848 295.286 53.2147 295.003C53.0475 294.718 52.964 294.323 52.964 293.819ZM54.7279 293.819C54.7279 293.585 54.7121 293.388 54.6804 293.226C54.6515 293.065 54.591 292.934 54.4988 292.833C54.4065 292.729 54.2696 292.677 54.088 292.677C53.9065 292.677 53.7695 292.729 53.6773 292.833C53.5851 292.934 53.5231 293.065 53.4914 293.226C53.4626 293.388 53.4482 293.585 53.4482 293.819C53.4482 294.061 53.4626 294.264 53.4914 294.428C53.5202 294.592 53.5808 294.725 53.673 294.826C53.7681 294.927 53.9065 294.977 54.088 294.977C54.2696 294.977 54.4065 294.927 54.4988 294.826C54.5939 294.725 54.6559 294.592 54.6847 294.428C54.7135 294.264 54.7279 294.061 54.7279 293.819Z"
					fill="black"
				/>
				<rect
					x="65.5547"
					y="289.859"
					width="7.78216"
					height="7.78216"
					fill="#FAFAFA"
					fill-opacity="0.5"
				/>
				<path
					d="M67.2429 293.062C67.2602 292.794 67.3626 292.585 67.5499 292.435C67.7401 292.285 67.9823 292.21 68.2762 292.21C68.478 292.21 68.6524 292.246 68.7994 292.318C68.9464 292.39 69.0573 292.488 69.1323 292.612C69.2072 292.736 69.2447 292.876 69.2447 293.032C69.2447 293.21 69.1971 293.363 69.102 293.49C69.0069 293.617 68.8931 293.702 68.7605 293.745V293.762C68.9305 293.814 69.0631 293.909 69.1582 294.048C69.2533 294.183 69.3009 294.358 69.3009 294.571C69.3009 294.741 69.262 294.892 69.1842 295.025C69.1063 295.157 68.991 295.263 68.8383 295.34C68.6855 295.415 68.5025 295.453 68.2892 295.453C67.9779 295.453 67.7214 295.374 67.5196 295.215C67.3208 295.054 67.2141 294.823 67.1997 294.523H67.6753C67.6868 294.676 67.7459 294.801 67.8525 294.899C67.9592 294.995 68.1033 295.042 68.2849 295.042C68.4607 295.042 68.5962 294.995 68.6913 294.899C68.7864 294.801 68.834 294.676 68.834 294.523C68.834 294.322 68.7691 294.179 68.6394 294.095C68.5126 294.009 68.3166 293.966 68.0514 293.966H67.939V293.559H68.0557C68.2892 293.556 68.4665 293.517 68.5875 293.442C68.7115 293.368 68.7734 293.249 68.7734 293.088C68.7734 292.95 68.7288 292.84 68.6394 292.759C68.5501 292.676 68.4232 292.634 68.259 292.634C68.0975 292.634 67.9722 292.676 67.8828 292.759C67.7935 292.84 67.7401 292.941 67.7228 293.062H67.2429ZM69.8835 292.733V292.284H70.7827V295.436H70.2856V292.733H69.8835Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M84.1867 292.733V292.284H85.086V295.436H84.5888V292.733H84.1867Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M101.54 294.765C101.816 294.526 102.034 294.33 102.192 294.177C102.354 294.022 102.488 293.86 102.595 293.693C102.701 293.526 102.754 293.359 102.754 293.192C102.754 293.019 102.713 292.883 102.629 292.785C102.548 292.687 102.42 292.638 102.244 292.638C102.074 292.638 101.942 292.693 101.847 292.803C101.754 292.909 101.705 293.053 101.7 293.235H101.224C101.233 292.906 101.331 292.656 101.518 292.483C101.708 292.307 101.949 292.219 102.24 292.219C102.554 292.219 102.799 292.305 102.975 292.478C103.154 292.651 103.243 292.882 103.243 293.17C103.243 293.378 103.19 293.578 103.083 293.771C102.979 293.961 102.854 294.133 102.707 294.286C102.563 294.435 102.378 294.61 102.154 294.809L101.959 294.982H103.329V295.392H101.228V295.033L101.54 294.765Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M118.274 293.062C118.291 292.794 118.394 292.585 118.581 292.435C118.771 292.285 119.014 292.21 119.307 292.21C119.509 292.21 119.684 292.246 119.831 292.318C119.978 292.39 120.089 292.488 120.164 292.612C120.238 292.736 120.276 292.876 120.276 293.032C120.276 293.21 120.228 293.363 120.133 293.49C120.038 293.617 119.924 293.702 119.792 293.745V293.762C119.962 293.814 120.094 293.909 120.189 294.048C120.285 294.183 120.332 294.358 120.332 294.571C120.332 294.741 120.293 294.892 120.215 295.025C120.138 295.157 120.022 295.263 119.87 295.34C119.717 295.415 119.534 295.453 119.32 295.453C119.009 295.453 118.753 295.374 118.551 295.215C118.352 295.054 118.245 294.823 118.231 294.523H118.707C118.718 294.676 118.777 294.801 118.884 294.899C118.99 294.995 119.135 295.042 119.316 295.042C119.492 295.042 119.627 294.995 119.723 294.899C119.818 294.801 119.865 294.676 119.865 294.523C119.865 294.322 119.8 294.179 119.671 294.095C119.544 294.009 119.348 293.966 119.083 293.966H118.97V293.559H119.087C119.32 293.556 119.498 293.517 119.619 293.442C119.743 293.368 119.805 293.249 119.805 293.088C119.805 292.95 119.76 292.84 119.671 292.759C119.581 292.676 119.454 292.634 119.29 292.634C119.129 292.634 119.003 292.676 118.914 292.759C118.825 292.84 118.771 292.941 118.754 293.062H118.274Z"
					fill="black"
				/>
				<rect
					x="119.387"
					y="230.389"
					width="4.62248"
					height="3.95323"
					transform="rotate(-180 119.387 230.389)"
					stroke="#7351FD"
					stroke-opacity="0.2"
					stroke-width="0.288228"
				/>
				<path
					d="M117.688 227.353L116.46 228.413L117.688 229.474"
					stroke="black"
					stroke-width="0.288228"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<rect
					x="122.613"
					y="226.355"
					width="4.62248"
					height="3.95323"
					stroke="#7351FD"
					stroke-opacity="0.2"
					stroke-width="0.288228"
				/>
				<path
					d="M124.32 229.392L125.548 228.332L124.32 227.271"
					stroke="black"
					stroke-width="0.288228"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<rect x="234.5" y="83.5" width="181" height="261" rx="9.5" fill="white" />
			<rect
				x="234.5"
				y="83.5"
				width="181"
				height="261"
				rx="9.5"
				stroke="#F2F2F4"
			/>
			<rect x="249" y="104" width="35" height="11" rx="5.5" fill="#8D71FF" />
			<rect
				x="249.5"
				y="125.5"
				width="151"
				height="21"
				rx="3.5"
				stroke="#D0CDFF"
			/>
			<rect x="256" y="133" width="36" height="5" rx="2.5" fill="#C5B8FB" />
			<rect x="356" y="133" width="36" height="5" rx="2.5" fill="#C5B8FB" />
			<rect x="249" y="156" width="35" height="11" rx="5.5" fill="#8D71FF" />
			<rect
				x="249.5"
				y="177.5"
				width="151"
				height="21"
				rx="3.5"
				stroke="#D0CDFF"
			/>
			<rect x="256" y="185" width="36" height="5" rx="2.5" fill="#C5B8FB" />
			<rect x="356" y="185" width="36" height="5" rx="2.5" fill="#C5B8FB" />
			<rect
				x="249"
				y="208"
				width="116"
				height="5.20461"
				rx="2.60231"
				fill="#C5B8FB"
			/>
			<rect
				x="249"
				y="219.276"
				width="100"
				height="5"
				rx="2.5"
				fill="#C5B8FB"
			/>
			<rect
				x="249"
				y="231.276"
				width="116"
				height="5.20461"
				rx="2.60231"
				fill="#C5B8FB"
			/>
			<rect
				x="249"
				y="242.553"
				width="100"
				height="5"
				rx="2.5"
				fill="#C5B8FB"
			/>
			<rect
				x="249"
				y="252.554"
				width="116"
				height="5.20461"
				rx="2.60231"
				fill="#C5B8FB"
			/>
			<rect x="249" y="263.83" width="100" height="5" rx="2.5" fill="#C5B8FB" />
			<rect
				x="249"
				y="275.83"
				width="116"
				height="5.20461"
				rx="2.60231"
				fill="#C5B8FB"
			/>
			<rect
				x="249"
				y="287.106"
				width="100"
				height="5"
				rx="2.5"
				fill="#C5B8FB"
			/>
			<rect x="249" y="301.106" width="152" height="22" rx="4" fill="#8D71FF" />
		</g>
		<defs>
			<filter
				id="filter0_d_4305_3373"
				x="-3.91798"
				y="201.475"
				width="159.504"
				height="129.24"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx="-1.84185" dy="4.14416" />
				<feGaussianBlur stdDeviation="11.5576" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_4305_3373"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_4305_3373"
					result="shape"
				/>
			</filter>
			<clipPath id="clip0_4305_3373">
				<rect width="476" height="406" rx="12" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

const ContentGrid = () => {
	const [showFeedback, setShowFeedback] = useState(false);
	const contents = [
		{
			image: ImageOne,
			title: 'Free AI Credits + BYOK',
			desc: 'Up to 10,000 free AI Credits, plus the BYOK feature where you can use your own OpenAI, DeepSeek or Claude API key.',
			comingSoon: false,
		},
		{
			image: ImageTwo,
			title: 'Manage Subscriptions',
			desc: 'Offer recurring payments with automatic renewals to keep your revenue consistent and predictable.',
			comingSoon: false,
		},
		{
			image: ImageOne,
			title: 'Sell Licensed Products',
			desc: 'Automate license generation, activation, and renewals. It’s perfect for digital products and software sales.',
			comingSoon: false,
		},
		{
			image: ImageThree,
			title: 'Create Membership Plans',
			desc: 'Build exclusive access areas, manage tiers, and reward loyal members with premium content.',
			comingSoon: true,
		},
		{
			image: ImageFour,
			title: 'Run an LMS',
			desc: 'Sell online courses, manage lessons, and track student progress - all from your EasyCommerce dashboard.',
			comingSoon: true,
		},
		{
			image: ImageFive,
			title: 'Handle Bookings',
			desc: 'Accept appointments, manage schedules, and let customers book services directly from your store.',
			comingSoon: true,
		},
	];

	return (
		<div className="grid grid-cols-4 gap-7 mt-[60px]">
			{contents.map((item) => {
				return (
					<Item
						image={item.image}
						title={item.title}
						desc={item.desc}
						comingSoon={item.comingSoon}
					/>
				);
			})}

			<div
				className="rounded-xl"
				style={{
					backgroundImage: `url(${EASYCOMMERCE.assets}/admin/img/pro-cta-bg.png)`,
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					padding: '45px 36px',
					display: 'flex',
					justifyContent: 'space-between',
					height: '100%',
					flexDirection: 'column',
				}}
			>
				<div>
					<h2 className="text-white text-4xl mb-8 font-bold">
						Didn’t spot the feature you were hoping for?
					</h2>
					<p className="text-white font-medium text-[16px]">
						Drop us a message. Your suggestion could inspire our next
						EasyCommerce feature, or who knows, it might be cooking already!
					</p>
				</div>

				<button 
					className="bg-white w-full text-center p-3 rounded-lg text-ec-title font-semibold text-base hover:bg-[#E3FF10] duration-300 block"
					onClick={ () => setShowFeedback(true) }
				>
					Say Howdy!
				</button>
			</div>

			{showFeedback && <Modal setShowModal={setShowFeedback} />}
		</div>
	);
};

export default ContentGrid;
